import React, { useContext, useEffect, useState } from "react";
import "./DemandApproval.css";
import { apiurl } from "../../../../../path";
import Application from "../../../StateContext/Application.js";
import {
  ApprovePay32,
  AvailableReleaseAmount,
  Balance,
  BillApprovalBlue32,
  Search32,
  SelectedDemandAmount,
  TotalAmountRelease,
  TotalLimitAlloted123,
  TotalProjectCost11,
  TotalWorkOrders,
} from "../../../../../public/LoginImages/importimages.js";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import { jwtDecode } from "jwt-decode";
import GooglePagination from "../../../styles/GooglePagination";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";
import { formatDateTime, formatDate, getDivisionRank } from "../../../../../utils/DateFormat.js";
import validateFile from "../../../../../utils/fileUploadHelper.js";



const DemandApproval = () => {
  const pathname = useLocation();
  useEffect(() => {
    setShowSpecific(1);
    setShowDistrictSummary(true);
  }, [pathname]);
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  console.log("userData: ", userData);

  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);

  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    DemandCreation,
    GetDemandApproval,
    ApproveBills,
    GetTotalAmountAvailbaleInBank,
    CreateToken,
    Usermenu,
    Getyears,
    GetStateBillSummary,
    RejectOrSendBackBill,
    GetDistrictwiseAccess,
  } = operation;

  const [projectId, setProjectId] = useState([]);
  const [ALLtableData, setALLTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [getAvailableBankBalance, SetAvailableBankBalance] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const [CountBalance, setCountBalance] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState("");

  const [selectedDivision, setSelectedDivision] = useState("");
  const [showDivisionSummary, setShowDivisionSummary] = useState(false);

  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedWorkType, setSelectedWorkType] = useState("");

  const [districtSummary, setDistrictSummary] = useState([]);
  const [showDistrictSummary, setShowDistrictSummary] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [uploadOrderFile, setUploadOrderFile] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
    const [fromDate1, setFromDate1] = useState("");
  const [toDate1, setToDate1] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [approvedYear, setApprovedYear] = useState("");
  const [districtData, setDistrictData] = useState([]);
  const [selectedBillData, setselectedBillData] = useState({});
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remarkAction, setRemarkAction] = useState(null); // "Reject" | "SendBack"
  const [remarkText, setRemarkText] = useState("");

  const [exportingPDF, setExportingPDF] = useState(false);

  const [selectedProposalYear, setselectedProposalYear] = useState("");
  const HandleDivisionClick = (division) => {
    setSelectedDivision(division);
    setSelectedDistrict("");
    setselectedProposalYear("");
    setSelectedBills([]);
    setSelectAll(false);
    setCurrentPage(1);
    setDistrictData([]);
    setTableData([]);
    setShowSpecific(3);
  };
  
  // const filteredDistricts = districtSummary.filter(
  //   (d) => d.Division === selectedDivision,
  // );

  console.log("All TableData: ", ALLtableData);
  const ALLtableDataRef = React.useRef([]);
  const billSlipRef = React.useRef(null);
  const [userDistrict, setuserDistrict] = useState({});

  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);

  useEffect(() => {
    ALLtableDataRef.current = ALLtableData;
  }, [ALLtableData]);

  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  // const [filteredBills, setFilteredBills] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const handleUploadOrder = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // No bill selected
    if (selectedBills.length === 0) {
      alert("Please select bill first!");
      return;
    }

    const validation = validateFile(file, 2);

    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }

    setUploadOrderFile(file);

    // Attach same uploaded file to all selected bills
    const updatedFiles = {};

    selectedBills.forEach((billId) => {
      updatedFiles[billId] = file;
    });

    setUploadedFiles((prev) => ({
      ...prev,
      ...updatedFiles,
    }));
  };
  const [currentPage, setCurrentPage] = useState(1);

  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? tableData.length || 1 : 10;

  const totalPages = Math.ceil(tableData?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //  const sortedBills = Array.isArray(tableData)? tableData.slice() // ✅ prevent state mutation
  // .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         : [];
  const sortedBills = tableData;
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = tableData?.slice(indexOfFirstBill, indexOfLastBill);

  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,
  });

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [AdminData, setAdminData] = useState([]);

  console.log("Admin DAta: ", AdminData);

  const administrativeYearSource =
    ALLtableDataRef.current || [];
   const administrativeYearSummary = React.useMemo(() => {
    if (!Array.isArray(districtData)) return [];
  
    const yearMap = {};
  
    districtData.forEach((item) => {
      const year =
        item.AdministrativeYear ||
        item.ProposalYear ||
        item.Year;
  
      if (!year) return;
  
      const yearKey = String(year).trim();
  
      if (!yearMap[yearKey]) {
        yearMap[yearKey] = {
          AdministrativeYear: yearKey,
          TotalBills: 0,
          TotalAmount: 0,
        };
      }
  
      yearMap[yearKey].TotalBills += 1;
      yearMap[yearKey].TotalAmount += Number(item.BillAmount || 0);
    });
  
    return Object.values(yearMap).sort((a, b) =>
      b.AdministrativeYear.localeCompare(a.AdministrativeYear)
    );
  }, [districtData]);
    console.log("administrativeYearSummary...... ", administrativeYearSummary);
  const administrativeYearData = ALLtableDataRef.current;
  const yearSummary = administrativeYearData.reduce((acc, item) => {
    const year = item.ProposalYear || "Unknown";
  
    if (!acc[year]) {
      acc[year] = [];
    }
  
    acc[year].push(item);
  
    return acc;
  }, {});
  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("Demand Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const FetchData = async () => {
    try {
      if (AdminData?.Department_Name === "State") {
        // ✅ Fetch BOTH summary and all bills together
        let [summaryRes, allBills] = await Promise.all([
          GetStateBillSummary(),
          GetDemandApproval(), // no param = all bills
        ]);

        if (summaryRes?.status) {
          setDistrictSummary(summaryRes.message);
          setShowDistrictSummary(true);
          setShowSpecific(1);
        }

        // if (allBills && allBills.length > 0) {
        //   setALLTableData(allBills); // ✅ stored for district filtering
        // }
        if (allBills && allBills.length > 0) {
  const seenIds = new Set();
  const uniqueBills = allBills.filter((r) => {
    if (seenIds.has(r.DemandGenerationID)) return false;
    seenIds.add(r.DemandGenerationID);
    return true;
  });
  setALLTableData(uniqueBills);
}

        return;
      }

      // Non-state unchanged
      let res = await GetDemandApproval();
      let proposalData = res.map((val) => ({
        ProjectId: val.MainWorkOrderID,
        ProjectName: val.MainWorkOrderID,
      }));
      const seen = new Set();
      const uniqueProposalData = proposalData.filter((item) => {
        const key = item.ProjectId;
        return seen.has(key) ? false : seen.add(key);
      });
      setProjectId(uniqueProposalData);
      setTableData(res);
      setALLTableData(res);
      setShowSpecific(0);
    } catch (err) {
      console.log(err);
    }
  };

  //For Fetching Admin details
  const GetAdminData = async () => {
    try {
      let res = await Usermenu();
      console.log(res);
      setAdminData(res.Data);
      setuserDistrict(res?.Data?.District);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetInitialData();
  }, []);

  useEffect(() => {
    if (AdminData?.Department_Name) {
      FetchData(); // only run once AdminData is ready
    }
  }, [AdminData?.Department_Name]);

  const GetInitialData = async () => {
    await GetAdminData();
    await GetTotalAmountAvailableInBank();
  };
  // const HandleYearClick = (year) => {
  //   setSelectedBills([]);
  //   setSelectAll(false);
  //   setCurrentPage(1);

  //   setData((prev) => ({
  //     ...prev,
  //     ProjectID: "",
  //   }));

  //   const latest = ALLtableDataRef.current;

  //   console.log("ALLtableData at year click:", latest.length);
  //   console.log("Selected Division:", selectedDivision);
  //   console.log("Selected District:", selectedDistrict);
  //   console.log("Clicked Administrative Year:", year);

  //   const selectedYear = String(year).trim();

  //   const filtered = latest.filter((item) => {
  //     const divisionMatch =
  //       !selectedDivision || item.Division === selectedDivision;

  //     const districtMatch =
  //       !selectedDistrict ||
  //       item.District === selectedDistrict ||
  //       item.District?.startsWith(`${selectedDistrict}-`);

  //     const itemYear = String(
  //       item.AdministrativeYear || item.ProposalYear || item.Year || "",
  //     ).trim();

  //     return divisionMatch && districtMatch && itemYear === selectedYear;
  //   });

  //   console.log("Filtered Year Bills:", filtered.length);

  //   setselectedProposalYear(selectedYear);

  //   setDistrictData(filtered);
  //   setTableData(filtered);

  //   setShowDistrictSummary(false);

  //   // Show bill details
  //   setShowSpecific(0);
  // };

  const HandleDistrictClick = (district) => {
    setSelectedBills([]);
    setSelectAll(false);
    setCurrentPage(1);
    setData((prev) => ({ ...prev, ProjectID: "" }));

    const latest = ALLtableDataRef.current;

    console.log("ALLtableData at district click:", latest.length);
    console.log("Selected Division:", selectedDivision);
    console.log("Clicked District:", district);

    const filtered = latest.filter((item) => {
    const districtMatch =
      item.District === district ||
      item.District?.startsWith(`${district}-`);

          // return districtMatch && inDateRange(item);
                    return districtMatch && passesBase(item);
  });

  
    console.log("Filtered District Bills:", filtered.length);

    setSelectedDistrict(district);
    setselectedProposalYear("");

    // District details data
    setDistrictData(filtered);
    setTableData(filtered);

    setShowDistrictSummary(false);

    // Show selected district details
    setShowSpecific(5);

    console.log("filtered district wise: ", filtered);
  };
const normalizeYear = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, "")
    .replace(/–/g, "-")
    .replace(/—/g, "-");
const HandleYearClick = (year) => {
  setSelectedBills([]);
  setSelectAll(false);
  setCurrentPage(1);

  setData((prev) => ({
    ...prev,
    ProjectID: "",
  }));

  const latest = ALLtableDataRef.current;

  console.log("ALLtableData at year click:", latest.length);
  console.log("Selected Division:", selectedDivision);
  console.log("Selected District:", selectedDistrict);
  console.log("Clicked Administrative Year:", year);
console.log("ALLtableDataRef", ALLtableDataRef);
  const selectedYear = normalizeYear(year);

  const filtered = latest.filter((item) => {
    const itemDivision = String(item.Division ?? "").trim();
    const itemDistrict = String(item.District ?? "").trim();

    const itemYear = normalizeYear(
      item.AdministrativeYear ||
      item.ProposalYear ||
      item.Year
    );

    const divisionMatch =
      !selectedDivision ||
      itemDivision === String(selectedDivision).trim();

    const selectedDistrictValue =
      String(selectedDistrict ?? "").trim();

    const districtMatch =
      !selectedDistrict ||
      itemDistrict === selectedDistrictValue ||
      itemDistrict.startsWith(`${selectedDistrictValue}-`);

    const yearMatch = itemYear === selectedYear;

    console.log("FILTER CHECK:", {
      itemDivision,
      selectedDivision,
      divisionMatch,

      itemDistrict,
      selectedDistrict,
      districtMatch,

      itemYear,
      selectedYear,
      yearMatch,

      item,
    });

    // return (
    //   districtMatch &&
    //   yearMatch &&
    //   divisionMatch &&
    //    inDateRange(item)  
    // );
        return districtMatch && yearMatch && passesBase(item);
  });

  console.log("Filtered Year Bills:", filtered.length);
  console.log("after year click data ....", filtered);

  setselectedProposalYear(selectedYear);
  setDistrictData(filtered);
  setTableData(filtered);

  setShowDistrictSummary(false);
  setShowSpecific(0);
};
  const [selectedBills, setSelectedBills] = useState([]);
  const [loading, setLoading] = useState(false);

  // const handleCheckboxChange = (id) => {

  //   setSelectedBills((prevSelected) =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter((ProjectID) => ProjectID !== id) // Remove if already selected
  //       : [...prevSelected, id] // Add if not selected

  //   );
  // };

  //   const handleCheckboxChange = (id) => {
  //     const bill = tableData.find(b => b.DemandGenerationID === id);
  //     const amount = Number(bill.BillAmount);
  // if (
  //   AdminData.Department_Name === "State" &&
  //   (AdminData.RoleID !== 24)&&
  //   !uploadedFiles[id]
  // ) {
  //   alert("Please Upload Order file first!");
  //   return;
  // }
  //     setSelectedBills((prevSelected) => {
  //       let updated;
  //       if (prevSelected.includes(id)) {
  //         updated = prevSelected.filter((item) => item !== id);
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount - amount
  //         }));
  //       } else {
  //         updated = [...prevSelected, id];
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount + amount
  //         }));
  //       }
  //       return updated;
  //     });
  //   };
  const handleCheckboxChange = (id) => {
    const bill = tableData.find((b) => b.DemandGenerationID === id);

    const amount = Number(bill.BillAmount);

    // Upload Work validation
    // if (
    //   AdminData.Department_Name === "State" &&
    //   AdminData.RoleID != 24 &&
    //   !uploadedFiles[id]
    // ) {
    //   alert("Please upload work file first!");
    //   return;
    // }

    setSelectedBills((prevSelected) => {
      // Existing selected bill objects
      const selectedBillObjects = tableData.filter((b) =>
        prevSelected.includes(b.DemandGenerationID),
      );

      // District validation
      if (prevSelected.length > 0 && !prevSelected.includes(id)) {
        const firstDistrict = selectedBillObjects[0]?.District;

        if (firstDistrict !== bill.District) {
          alert("You can select bills from the same district only!");
          return prevSelected;
        }
      }

      if (prevSelected.length > 0 && !prevSelected.includes(id)) {
  const firstDept = String(selectedBillObjects[0]?.DepartmentAccessID ?? "");
  if (firstDept !== String(bill.DepartmentAccessID ?? "")) {
    alert("You can select bills from the same department only!");
    return prevSelected;
  }
}

      let updated;

      if (prevSelected.includes(id)) {
        updated = prevSelected.filter((item) => item !== id);

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount - amount,
        }));
      } else {
        updated = [...prevSelected, id];

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount + amount,
        }));
      }

      return updated;
    });
  };
  console.log("selectedbills", selectedBills);

 
  const approveSelected = async ({ remark = "", nextRole = "" } = {}) => {
    if (selectedBills.length === 0) {
      alert("No bills selected for approval!");
      return;
    }
    if (AdminData.RoleID == 25 || AdminData.RoleID == 40) {
      const missingFiles = selectedBills.filter((id) => !uploadedFiles[id]);

      if (missingFiles.length > 0) {
        alert("Please upload Fund Release Order file for all selected bills!");
        return;
      }
    }
    // Defensive numeric parse (treat invalid/missing as 0)
    const available = Number(TotalPaidCount) || 0;
    const selectedDemand = Number(data?.SelectedDemandAmount) || 0;


    console.log(selectedBills);
    setLoading(true); // Start loader

    try {
      const formData = new FormData();

       formData.append("selectedBills", JSON.stringify(selectedBills));
  // formData.append("forwardRemark", remark);
  // formData.append("nextRole", nextRole);

      Object.keys(uploadedFiles).forEach((billId) => {
        formData.append(`uploadOrder_${billId}`, uploadedFiles[billId]);
      });

      // await ApproveBills(formData, Etoken);
      let response = await ApproveBills(formData, Etoken);

      if (response.message) {
        alert(response.message);

        FetchData();
        window.location.reload();
      } else if (response.error) {
        alert(response.error);

        FetchData();
        window.location.reload();
      }
    } catch (error) {
      console.error("Error approving bills:", error);
      alert("An error occurred while approving bills.");
      window.location.reload();
    } finally {
      setLoading(false); // Stop loader
    }
  };
  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank();
    console.log(data);
    setBankBalance(data[0]);
    // setCountBalance(data.result1[0])
  };
  let TotalPaidCount = BankBalance.AvailableBalanceinBank;
  console.log(BankBalance);

  const FetchDemandApprovalData = async (e) => {
    e.preventDefault();
    const { ProjectID } = data;
    console.log(ProjectID);

    if (!ProjectID) {
      alert("Required all field priject id and piu name");
      return;
    }

    try {
      let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
      console.log(res1);

      let result = res1;
      let ans = result.filter((item) => item.ProjectID == ProjectID);

      // setTableData(ans);

      console.log(ans);
    } catch (err) {
      console.log(err);
    }
  };

  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce(
      (acc, item) => acc + Number(item.BillAmount),
      0,
    );

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount,
    }));
  };

  useEffect(() => {
    TotalAmount();
  }, [tableData]);

  const TotalSelectedDemandAmount = (amount) => {
    setData((prev) => ({
      ...prev,
      SelectedDemandAmount:
        Number(prev.SelectedDemandAmount || 0) + Number(amount),
    }));
  };

 
  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;

    // ✅ State department logic
    let validBills = currentBills;

    const validBillIDs = validBills.map((item) => item.DemandGenerationID);

    setSelectAll(checked);

    if (checked) {
      const newSelected = [...new Set([...selectedBills, ...validBillIDs])];

      setSelectedBills(newSelected);

      const newlyAdded = validBills.filter(
        (bill) => !selectedBills.includes(bill.DemandGenerationID),
      );

      const newAmount = newlyAdded.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount + newAmount,
      }));

      // optional alert only for State
      // if (
      //   AdminData.Department_Name === "State" &&
      //   AdminData.RoleID !== 24 &&
      //   validBills.length !== currentBills.length
      // ) {
      //   alert("Some bills were skipped because Upload Order file is missing.");
      // }
    } else {
      const remainingSelected = selectedBills.filter(
        (id) => !validBillIDs.includes(id),
      );

      setSelectedBills(remainingSelected);

      const removedAmount = validBills.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount,
      }));
    }
  };
  useEffect(() => {
    if (data.ProjectID) {
      if (data.ProjectID == "All") {
        let res = ALLtableData;
        setTableData(res);
      } else {
        let res = ALLtableData.filter(
          (item) => item.ProjectID === data.ProjectID,
        );
        setTableData(res);
      }
    }
  }, [data.ProjectID]);

  const inMyStage = (item) => {
  if (item.Approvance7 === undefined) {
    console.warn("Approvance7 missing in bill data: add it to the backend SELECT");
    return true;
  }
  if (item.Status !== "false") return false;

  const role = Number(AdminData?.RoleID);
  if (role === 25 || role === 40) {
    return item.Approvance7 === "true" && item.Approvance8 === "false";
  }
  if (role === 24 || role === 41) {
    return item.Approvance8 === "true" && item.Approvance9 === "false";
  }
  return true;
};

  // Derived — no extra API call needed
  // District rows: Checker / SO counts come from the same bill list as the Year Summary
  const districtSummaryView = React.useMemo(() => {
    if (!ALLtableData.length) return districtSummary;

    const isChecker = AdminData?.Role === "RDD Checker(ASO)";
    const isSO = AdminData?.Role === "RDD Section Officer";

    return districtSummary.map((row) => {
      const bills = ALLtableData.filter(
        (item) =>
          (item.District === row.District ||
            item.District?.startsWith(`${row.District}-`)) &&
          passesBase(item),
      );
      const count = bills.length;
      const amount = bills.reduce((s, b) => s + Number(b.BillAmount || 0), 0);

      if (isChecker)
        return { ...row, RDDCheckerCount: count, RDDCheckerAmount: amount };
      if (isSO) return { ...row, RDDSOCount: count, RDDSOAmount: amount };
      return row;
    });
  }, [
    districtSummary,
    ALLtableData,
    AdminData?.Role,
    AdminData?.RoleID,
    fromDate1,
    toDate1,
  ]);

  const filteredDistricts = districtSummaryView.filter(
    (d) => d.Division === selectedDivision,
  );

  // Division totals built from the district rows above
  const divisionSummary = React.useMemo(() => {
    const map = {};
    districtSummaryView.forEach((item) => {
      const div = item.Division || "Unknown";
      if (!map[div]) {
        map[div] = {
          Division: div,
          TotalPendingCount: 0,
          TotalPendingAmount: 0,
          RDDCheckerCount: 0,
          RDDCheckerAmount: 0,
          RDDSOCount: 0,
          RDDSOAmount: 0,
        };
      }
      map[div].TotalPendingCount += Number(item.TotalPendingCount || 0);
      map[div].TotalPendingAmount += Number(item.TotalPendingAmount || 0);
      map[div].RDDCheckerCount += Number(item.RDDCheckerCount || 0);
      map[div].RDDCheckerAmount += Number(item.RDDCheckerAmount || 0);
      map[div].RDDSOCount += Number(item.RDDSOCount || 0);
      map[div].RDDSOAmount += Number(item.RDDSOAmount || 0);
    });

    return Object.values(map).sort(
      (a, b) => getDivisionRank(a.Division) - getDivisionRank(b.Division),
    );
  }, [districtSummaryView]);

  const DemandDeductionDetailByBillID = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(2);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const currentPageIDs = currentBills.map((bill) => bill.DemandGenerationID);
    const allSelected = currentPageIDs.every((id) =>
      selectedBills.includes(id),
    );
    setSelectAll(allSelected);
  }, [currentBills, selectedBills]);

  console.log("selectedBills", selectedBills);
  const allSelectedBillsHaveFiles =
    selectedBills.length > 0 &&
    currentBills
      .filter((bill) => selectedBills.includes(bill.DemandGenerationID))
      .every((bill) => uploadedFiles[bill.DemandGenerationID]);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressImages, setProgressImages] = useState([]);
  const [progressData, setProgressData] = useState([]);

  console.log("progressData: ", progressData);

  const openProgressModal = (images, location) => {
    try {
      const parsedImages = JSON.parse(images || "[]");
      const parsedLocations = JSON.parse(location || "[]");

      let imageArray = [];

      parsedImages.forEach((img) => {
        try {
          const nested = JSON.parse(img);

          if (Array.isArray(nested)) {
            imageArray.push(...nested);
          } else {
            imageArray.push(img);
          }
        } catch {
          imageArray.push(img);
        }
      });

      const combinedData = imageArray.map((image, index) => {
        let locationObj = {};

        try {
          locationObj = JSON.parse(parsedLocations[index] || "{}");
        } catch (err) {
          console.log(err);
        }

        return {
          image,
          location: locationObj,
        };
      });

      console.log("combinedData", combinedData);

      setProgressData(combinedData);
      setShowProgressModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  const selectedBillDetails = tableData.filter((bill) =>
    selectedBills.includes(bill.DemandGenerationID),
  );

  const selectedBillCount = selectedBillDetails.length;

  const selectedBillAmount = selectedBillDetails.reduce(
    (sum, bill) => sum + Number(bill.BillAmount || 0),
    0,
  );

  useEffect(() => {
    let filtered = [...ALLtableData];

    if (approvedYear) {
      filtered = filtered.filter(
        (item) => String(item.WorkApprovedYear) === String(approvedYear),
      );
    }

    if (data.ProjectID && data.ProjectID !== "All") {
      filtered = filtered.filter(
        (item) => item.MainWorkOrderID === data.ProjectID,
      );
    }


    if (selectedDistrict) {
      filtered = filtered.filter(
        (item) =>
          item.District === selectedDistrict ||
          item.District.startsWith(`${selectedDistrict}-`),
      );
    }

    if (selectedProposalYear) {
      filtered = filtered.filter(
        (item) =>
          normalizeYear(item.AdministrativeYear || item.ProposalYear || item.Year) ===
          selectedProposalYear,
      );
    }
    if (selectedTaluka) {
      filtered = filtered.filter(
        (item) => (item.Taluka || item.ulb) === selectedTaluka,
      );
    }

    if (selectedWorkType) {
      filtered = filtered.filter(
        (item) => (item.typeOfWork || item.workType) === selectedWorkType,
      );
    }
    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        if (!item.BillReceivedDate) return false;

        // Convert ISO date properly
        const uploadDate = new Date(item.BillReceivedDate);
        uploadDate.setHours(0, 0, 0, 0);

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from) from.setHours(0, 0, 0, 0);
        if (to) to.setHours(23, 59, 59, 999);

        if (from && to) {
          return uploadDate >= from && uploadDate <= to;
        }

        if (from) {
          return uploadDate >= from;
        }

        if (to) {
          return uploadDate <= to;
        }

        return true;
      });
    }
    // 🔹 Search Filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }


    // date range + stage filter (State users only)
    if (AdminData?.Department_Name === "State") {
      filtered = filtered.filter(passesBase);
    }

    setTableData(filtered);
    console.log("tabledata", tableData);

    setCurrentPage(1);
  }, [
    data.ProjectID,
    data.ApprovedYear,
    ALLtableData,
    fromDate,
    toDate,
      fromDate1,      // 👈 added
      toDate1,        // 👈 added   
    searchTerm,
    approvedYear,

        selectedDistrict,
    selectedTaluka,
    selectedProposalYear,
    selectedWorkType,
    AdminData?.RoleID,
    AdminData?.Department_Name,
  ]);

  // Unique work names scoped to the correct level, independent of current filters
  const workNameOptions = React.useMemo(() => {
    let scoped = [...ALLtableData];

    if (approvedYear) {
      scoped = scoped.filter(
        (item) => String(item.WorkApprovedYear) === String(approvedYear),
      );
    }
    if (selectedDistrict) {
      scoped = scoped.filter(
        (item) =>
          item.District === selectedDistrict ||
          item.District?.startsWith(`${selectedDistrict}-`),
      );
    }
    if (selectedProposalYear) {
      scoped = scoped.filter(
        (item) => item.ProposalYear === selectedProposalYear,
      );
    }
    if (selectedTaluka) {
      scoped = scoped.filter(
        (item) => (item.Taluka || item.ulb) === selectedTaluka,
      );
    }
    if (selectedWorkType) {
      scoped = scoped.filter(
        (item) => (item.typeOfWork || item.workType) === selectedWorkType,
      );
    }

    const seen = new Set();
    return scoped.filter((item) => {
      const key = item.MainWorkOrderID;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [
    ALLtableData,
    approvedYear,
    selectedDistrict,
    selectedProposalYear,
    selectedTaluka,
    selectedWorkType,
  ]);

  const settingshowspecific3 = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(4);
      let filtered = res;
      console.log("filtered............", filtered);
      filtered = filtered.filter((val) => val.DemandGenerationID == ID);
      setselectedBillData(filtered[0]);
      console.log("selected Bill ---> ", filtered[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }

    setExportingBillSlipPDF(true);

    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;
      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo =
        selectedBillData?.DemandGenerationID || selectedDemandID;
      pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);
      alert("Failed to export bill slip PDF. Please try again.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };

  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setSelectedBills("");
    setselectedBillData([]);
    setShowSpecific(0);
  };

  const labelStyle = {
    border: "1px solid #000",
    padding: "6px",
    width: "18%",
    fontWeight: "bold",
    background: "#f5f5f5",
  };

  const valueStyle = {
    border: "1px solid #000",
    padding: "6px",
  };

  const tableHead = {
    border: "1px solid #000",
    background: "#d9d9d9",
    padding: "8px",
    textAlign: "center",
  };

  const tableCell = {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "center",
  };
  const vendorData = fetchSpecificDemandDeductionDetail?.find(
    (item) => item.TypeOfAmount === "Total Amount Payable",
  );
  const officerStyle = {
    marginTop: "8px",
    fontSize: "12px",
    fontWeight: "bold",
    textAlign: "center",
  };

  const officerMarathiStyle = {
    fontSize: "11px",
    textAlign: "center",
    marginTop: "3px",
  };
  const footerTitleStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "8px",
  };

  const footerTitleTdStyle = {
    border: "1px solid #555",
    padding: "6px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
  };

  const remarksTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
  };

  const remarksTableTdStyle = {
    border: "1px solid #555",
    padding: "8px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "right",
  };

  const instructionTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };

  const instructionTableTdStyle = {
    border: "1px solid #555",
    padding: "10px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "justify",
  };

  const signatureTableStyle = {
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };

  const signatureTableTdStyle = {
    border: "1px solid #555",
    height: "80px",
    width: "50%",
    verticalAlign: "bottom",
    padding: "10px",
  };

  const signBoxStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  };

  const signSpaceStyle = {
    height: "25px",
  };

  const signTitleStyle = {
    fontSize: "12px",
    fontWeight: "bold",
    textAlign: "center",
  };

  const openRemarkModal = (action) => {
    if (selectedBills.length === 0) {
      alert("No bills selected!");
      return;
    }
    setRemarkAction(action);
    setRemarkText("");
    setShowRemarkModal(true);
  };

  const submitRejectSendBack = async () => {
    if (!remarkText.trim()) {
      alert("Remark is required!");
      return;
    }
    setLoading(true);
    try {
      const response = await RejectOrSendBackBill(
        selectedBills,
        remarkText,
        remarkAction,
      );
      if (response.message) {
        alert(response.message);
        setShowRemarkModal(false);
        FetchData();
        window.location.reload();
      } else if (response.error) {
        alert(response.error);
      }
    } catch (error) {
      console.error("Reject/SendBack error:", error);
      alert("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const exportTableByClassToExcel = async (
    currentBills,
    filename = "Bill_Inward.xlsx",
  ) => {
    if (!Array.isArray(currentBills) || currentBills.length === 0) {
      alert("No data available");
      return;
    }
  
    setLoading(true);
  
    await new Promise((resolve) => setTimeout(resolve, 500));
  
    try {

      const selectedIds = (selectedBills || []).map((id) => String(id));
  
      const billsToDownload =
        selectedIds.length > 0
          ? currentBills.filter((bill) =>
              selectedIds.includes(String(bill.DemandGenerationID)),
            )
          : currentBills;
  
      if (!billsToDownload || billsToDownload.length === 0) {
        alert("No selected records found to download.");
        return;
      }
  
      let totalBillAmount = 0;
      let totalNetPayableAmount = 0;
      let totalDeductionAmount = 0;
  
      const formatDate = (dateValue) => {
        if (!dateValue) return "";
  
        const date = new Date(dateValue);
  
        if (isNaN(date.getTime())) return "";
  
        return date.toLocaleDateString("en-IN");
      };
  
      const isStateFundRelease =
        AdminData?.Department_Name === "State" &&
        (Number(AdminData?.RoleID) === 24 ||
          Number(AdminData?.RoleID) === 41);
  
      /* =====================================================
         CREATE EXCEL DATA
      ===================================================== */
  
      const excelData = billsToDownload.map((val, index) => {
        const billAmount = Number(val.BillAmount || 0);
        const netPayableAmount = Number(val.NetPayableAmount || 0);
        const deductionAmount = Number(val.DeductionAmount || 0);
  
        totalBillAmount += isNaN(billAmount) ? 0 : billAmount;
  
        totalNetPayableAmount += isNaN(netPayableAmount)
          ? 0
          : netPayableAmount;
  
        totalDeductionAmount += isNaN(deductionAmount)
          ? 0
          : deductionAmount;
  
        const row = {
          "Sr No.": index + 1,
  
          "Demand ID": val.DemandGenerationID || "",
  
          "Bill Creation Date": val.Date || "-",
  
          "Bill Receive Date at RDD": val.BillReceivedDate || "-",
  
          "Administrative Approval Year (A.A.Year)":
            val.ProposalYear || "-",
  
          "MHUID Number": val.MHUID_Number || "-",
  
          "Work Name": val.MainWorkOrderID || "-",
  
          Taluka: val.Taluka || val.ulb || "",
  
          "Class Of Work": val.classOfWork || val.workClass || "",
  
          "Type Of Work": val.typeOfWork || val.workType || "",
  
          "Work Order Type":
            val.WorkOrderType || val.workOrderType || "-",
  
          "Bill Amount": isNaN(billAmount) ? 0 : billAmount,
  
          "Net Payable Amount": isNaN(netPayableAmount)
            ? 0
            : netPayableAmount,
  
          Deduction: isNaN(deductionAmount) ? 0 : deductionAmount,
  
          "Administrative Approved GR Date": formatDate(
            val.GRApproveDate || val.workApprovedGRDate,
          ),
  
          "Work Order Date": val.WorkOrderDate || "-",
  
          "Physical Progress in Percentage":
            val.physicalValueOfProgress != null
              ? `${val.physicalValueOfProgress}%`
              : "",
  
          "Measurement Book": val.Measurement_Book || "-",
  
          "SQM Inspection Report": val.Inspection_Report || "-",
  
          "Work Completion Date": val.WorkEndDate || "-",
  
          "Bill Copy": val.UploadBillCopy || "-",
  
          "Vendor Name": val.ContractorName || "",
  
          "Head Code": val.BudgetID || "",
        };
  
        // State Role 24/41 only
        if (isStateFundRelease) {
          row["Fund Release Order"] = val.uploadWork || "No File";
        }
  
        return row;
      });
  
      /* =====================================================
         TOTAL ROW
      ===================================================== */
  
      const totalRow = {
        "Sr No.": "",
  
        "Demand ID": "",
  
        "Bill Creation Date": "",
  
        "Bill Receive Date at RDD": "",
  
        "Administrative Approval Year (A.A.Year)": "",
  
        "MHUID Number": "",
  
        "Work Name": "",
  
        Taluka: "",
  
        "Class Of Work": "",
  
        "Type Of Work": "",
  
        "Work Order Type": "TOTAL",
  
        "Bill Amount": totalBillAmount,
  
        "Net Payable Amount": totalNetPayableAmount,
  
        Deduction: totalDeductionAmount,
  
        "Administrative Approved GR Date": "",
  
        "Work Order Date": "",
  
        "Physical Progress in Percentage": "",
  
        "Measurement Book": "",
  
        "SQM Inspection Report": "",
  
        "Work Completion Date": "",
  
        "Bill Copy": "",
  
        "Vendor Name": "",
  
        "Head Code": "",
      };
  
      if (isStateFundRelease) {
        totalRow["Fund Release Order"] = "";
      }
  
      excelData.push(totalRow);
  
      /* =====================================================
         CREATE WORKSHEET
      ===================================================== */
  
      const worksheet = XLSX.utils.json_to_sheet(excelData);
  
      /* =====================================================
         COLUMN WIDTHS
      ===================================================== */
  
      const columnWidths = [
        { wch: 8 },  // Sr No.
        { wch: 18 }, // Demand ID
        { wch: 20 }, // Bill Creation Date
        { wch: 25 }, // Bill Receive Date
        { wch: 25 }, // A.A. Year
        { wch: 20 }, // MHUID
        { wch: 35 }, // Work Name
        { wch: 18 }, // Taluka
        { wch: 20 }, // Class Of Work
        { wch: 20 }, // Type Of Work
        { wch: 20 }, // Work Order Type
        { wch: 18 }, // Bill Amount
        { wch: 22 }, // Net Payable
        { wch: 18 }, // Deduction
        { wch: 25 }, // GR Date
        { wch: 20 }, // Work Order Date
        { wch: 25 }, // Physical Progress
        { wch: 35 }, // Measurement Book
        { wch: 35 }, // Inspection Report
        { wch: 25 }, // Work Completion Date
        { wch: 35 }, // Bill Copy
        { wch: 30 }, // Vendor
        { wch: 25 }, // Head Code
      ];
  
      if (isStateFundRelease) {
        columnWidths.push({ wch: 35 });
      }
  
      worksheet["!cols"] = columnWidths;
  
      /* =====================================================
         FREEZE HEADER
      ===================================================== */
  
      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };
  
      /* =====================================================
         AUTOFILTER
         Exclude TOTAL row
      ===================================================== */
  
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: {
            r: 0,
            c: 0,
          },
          e: {
            r: excelData.length - 2,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };
  
      /* =====================================================
         FORMAT AMOUNT COLUMNS
      ===================================================== */
  
      // Column positions based on current object order:
      // K = Bill Amount
      // L = Net Payable Amount
      // M = Deduction
  
      const billAmountColumn = 11;
      const netPayableColumn = 12;
      const deductionColumn = 13;
  
      for (let row = 1; row <= excelData.length; row++) {
        const billCell = worksheet[
          XLSX.utils.encode_cell({
            r: row,
            c: billAmountColumn,
          })
        ];
  
        const netCell = worksheet[
          XLSX.utils.encode_cell({
            r: row,
            c: netPayableColumn,
          })
        ];
  
        const deductionCell = worksheet[
          XLSX.utils.encode_cell({
            r: row,
            c: deductionColumn,
          })
        ];
  
        if (billCell) {
          billCell.z = "#,##0.00";
        }
  
        if (netCell) {
          netCell.z = "#,##0.00";
        }
  
        if (deductionCell) {
          deductionCell.z = "#,##0.00";
        }
      }
  
      /* =====================================================
         CREATE WORKBOOK
      ===================================================== */
  
      const workbook = XLSX.utils.book_new();
  
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Bill Inward",
      );
  
      XLSX.writeFile(workbook, filename);
  
    } catch (error) {
      console.error("Excel Export Error:", error);
      alert("Error while exporting Excel file");
    } finally {
      setLoading(false);
    }
  };

  const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title,
    chunkSize = 500,
  ) => {
    const originalTable = document.querySelector(`.${tableClass}`);
  
    if (!originalTable) {
      setExportingPDF(false);
      alert("Table not found");
      return;
    }
  
    setLoading(true);
    setExportingPDF(true);
  
    await new Promise((res) => setTimeout(res, 600));
  
    try {
      const selectedIds = (selectedBills || []).map((id) => String(id));
  
      // Get all actual data rows
      const allDataRows = Array.from(
        originalTable.querySelectorAll("tbody tr[data-demand-id]")
      );
  
      // Selected records -> export selected
      // Nothing selected -> export all
      const rowsToDownload =
        selectedIds.length > 0
          ? allDataRows.filter((row) =>
              selectedIds.includes(
                String(row.getAttribute("data-demand-id"))
              )
            )
          : allDataRows;
  
      const totalRows = rowsToDownload.length;
  
      if (totalRows === 0) {
        alert("No records found to download.");
        return;
      }
  
      for (let start = 0; start < totalRows; start += chunkSize) {
        const end = Math.min(start + chunkSize, totalRows);
  
        // IDs for current chunk
        const currentChunkIds = rowsToDownload
          .slice(start, end)
          .map((row) =>
            String(row.getAttribute("data-demand-id"))
          );
  
        // Clone complete table
        const table = originalTable.cloneNode(true);
  
        // Remove rows not belonging to current chunk
        const clonedDataRows = table.querySelectorAll(
          "tbody tr[data-demand-id]"
        );
  
        clonedDataRows.forEach((row) => {
          const demandId = String(
            row.getAttribute("data-demand-id")
          );
  
          if (!currentChunkIds.includes(demandId)) {
            row.remove();
          }
        });
  
        // Remove Page Total / Gross Total / any other non-data rows
        // already present in the live table (footer rows etc.)
        table.querySelectorAll("tbody tr:not([data-demand-id])").forEach(
          (row) => row.remove()
        );
  
        // =====================================================
        // PDF ONLY: RESET SR. NO. FROM 1
        // =====================================================
        const pdfRows = table.querySelectorAll("tbody tr[data-demand-id]");
  
        pdfRows.forEach((row, index) => {
          const firstCell = row.querySelector("td");
  
          if (firstCell) {
            firstCell.textContent = start + index + 1;
          }
        });
  
        // =====================================================
        // ADD SINGLE TOTAL ROW AT BOTTOM OF CURRENT PDF CHUNK
        // "Total" label under Type of Work column,
        // summed amount under Amount column, everything else blank.
        // =====================================================
  
  // 👇 SET THESE TO MATCH YOUR ACTUAL <td> ORDER (0-based)
  const TYPE_OF_WORK_COLUMN_INDEX = 10; // "Total" label goes here
  const AMOUNT_COLUMN_INDEXES = [11, 12, 13]; // TODO: confirm your 3 real amount column indexes
  
  // Sum each amount column separately
  const chunkTotals = {}; // { 11: 5000, 12: 3000, 13: 1200 }
  
  AMOUNT_COLUMN_INDEXES.forEach((colIndex) => {
    chunkTotals[colIndex] = 0;
  });
  
  pdfRows.forEach((row) => {
    const cells = row.querySelectorAll("td");
  
    AMOUNT_COLUMN_INDEXES.forEach((colIndex) => {
      if (cells[colIndex]) {
        const value = cells[colIndex].innerText
          .replace(/,/g, "")
          .replace(/[₹\s]/g, "")
          .trim();
  
        const number = parseFloat(value);
  
        if (!isNaN(number)) {
          chunkTotals[colIndex] += number;
        }
      }
    });
  });
  
  const totalRow = document.createElement("tr");
  
  const totalCells =
    table.querySelector("tbody tr[data-demand-id]")
      ?.querySelectorAll("td").length || 1;
  
  for (let i = 0; i < totalCells; i++) {
    const td = document.createElement("td");
  
    td.style.fontWeight = "bold";
    td.style.border = "1px solid #000";
    td.style.padding = "8px";
    td.style.backgroundColor = "#f2f2f2";
  
    if (i === TYPE_OF_WORK_COLUMN_INDEX) {
      td.textContent = "Total";
    } else if (AMOUNT_COLUMN_INDEXES.includes(i)) {
      td.textContent = chunkTotals[i].toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      td.textContent = "";
    }
  
    totalRow.appendChild(td);
  }
  
  table.querySelector("tbody").appendChild(totalRow);
  
        // =====================================================
        // Create temporary PDF container
        // =====================================================
        const pdfContainer = document.createElement("div");
  
        const tableWidth = originalTable.scrollWidth;
  
        pdfContainer.style.position = "fixed";
        pdfContainer.style.left = "-10000px";
        pdfContainer.style.top = "0";
        pdfContainer.style.width = `${tableWidth + 40}px`;
        pdfContainer.style.minWidth = `${tableWidth + 40}px`;
        pdfContainer.style.backgroundColor = "#ffffff";
        pdfContainer.style.padding = "20px";
        pdfContainer.style.boxSizing = "border-box";
        pdfContainer.style.fontFamily =
          "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";
  
        table.style.width = `${tableWidth}px`;
        table.style.minWidth = `${tableWidth}px`;
        table.style.maxWidth = "none";
        table.style.tableLayout = "auto";
  
        // =====================================================
        // Title
        // =====================================================
        const titleElement = document.createElement("div");
  
        titleElement.innerText = `${title} (${start + 1} - ${end})`;
  
        titleElement.style.textAlign = "center";
        titleElement.style.fontSize = "28px";
        titleElement.style.fontWeight = "bold";
        titleElement.style.marginBottom = "20px";
        titleElement.style.padding = "10px";
        titleElement.style.color = "#000";
        titleElement.style.fontFamily =
          "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";
  
        pdfContainer.appendChild(titleElement);
        pdfContainer.appendChild(table);
  
        document.body.appendChild(pdfContainer);
  
        await new Promise((res) => setTimeout(res, 500));
  
        // =====================================================
        // A3 Landscape PDF
        // =====================================================
        const pdf = new jsPDF("l", "mm", "a3");
  
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
  
        const sideMargin = 10;
        const topMargin = 10;
        const bottomMargin = 15;
  
        const canvas = await html2canvas(pdfContainer, {
          scale: 1.5,
          useCORS: true,
          backgroundColor: "#ffffff",
          windowWidth: pdfContainer.scrollWidth,
        });
  
        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;
  
        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;
  
        let renderedHeight = 0;
        let pageNumber = 0;
  
        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight
          );
  
          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");
  
          pageCanvas.width = canvas.width;
          pageCanvas.height = Math.ceil(sliceHeight);
  
          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight
          );
  
          const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);
  
          if (pageNumber > 0) {
            pdf.addPage();
          }
  
          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm
          );
  
          renderedHeight += sliceHeight;
          pageNumber++;
        }
  
        // Save PDF
        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
  
        // Remove temporary container
        document.body.removeChild(pdfContainer);
  
        await new Promise((res) => setTimeout(res, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
      alert("Error while generating PDF.");
    } finally {
      setExportingPDF(false);
      setLoading(false);
    }
  };

  const formatFileName = (file) => {
    if (!file) return "";

    const dotIndex = file.lastIndexOf(".");
    const extension = dotIndex !== -1 ? file.substring(dotIndex) : "";
    const lastThree =
      dotIndex !== -1 ? file.substring(dotIndex - 4, dotIndex) : "";

    return `${file.substring(0, 10)}........${lastThree}${extension}`;
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!progressData?.length) return;

      if (e.key === "ArrowRight") {
        setSelectedImageIndex(
          (prevIndex) => (prevIndex + 1) % progressData.length,
        );
      }

      if (e.key === "ArrowLeft") {
        setSelectedImageIndex(
          (prevIndex) =>
            (prevIndex - 1 + progressData.length) % progressData.length,
        );
      }

    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progressData]);

  
  const refreshStateSummary = async () => {
  try {
    const summaryRes = await GetStateBillSummary(fromDate1, toDate1);
    if (summaryRes?.status) {
      setDistrictSummary(summaryRes.message);
    }
  } catch (err) {
    console.log(err);
  }
};

useEffect(() => {
  if (AdminData?.Department_Name === "State") {
    refreshStateSummary();

  }
}, [fromDate1, toDate1,selectedDistrict]);

function inDateRange(item) {
  if (!fromDate1 && !toDate1) return true;
  if (!item.BillReceivedDate) return false;

  const d = new Date(item.BillReceivedDate);
  d.setHours(0, 0, 0, 0);

  if (fromDate1) {
    const from = new Date(fromDate1);
    from.setHours(0, 0, 0, 0);
    if (d < from) return false;
  }
  if (toDate1) {
    const to = new Date(toDate1);
    to.setHours(23, 59, 59, 999);
    if (d > to) return false;
  }
  return true;
};
// Same stage rule as the backend summary query

function passesBase(item) {
  return inDateRange(item) && inMyStage(item);
}

// Approve button entry point
const handleApproveClick = async () => {
  if (selectedBills.length === 0) {
    alert("No bills selected for approval!");
    return;
  }
  // State users have no district flow -> approve directly
  if (AdminData?.Department_Name !== "District") {
    await approveSelected();
    return;
  }
  await openForwardPopup();
};

const openForwardPopup = async () => {
  const rows = (ALLtableDataRef.current || []).filter((b) =>
    selectedBills.includes(b.DemandGenerationID),
  );

  const districts = [...new Set(rows.map((b) => String(b.District || "").split("-")[0].trim()))];
  const depts = [...new Set(rows.map((b) => String(b.DepartmentAccessID ?? "")))];

  if (districts.length !== 1) { alert("Please select bills from one district at a time."); return; }
  if (depts.length !== 1)     { alert("Please select bills from one department at a time."); return; }

  // setAccessLoading(true);
  try {
    // the BACKEND resolves role -> stage -> next role from districtwiseaccess
    const res = await GetDistrictwiseAccess(districts[0], depts[0] || null);
    if (!res?.status) throw new Error(res?.message || "Unable to load approval flow.");

    const info = res.data;
    // setFlowInfo(info);

    if (info.isLast) {
      // last district role (CAFO) -> goes to State, no next district role
      if (window.confirm("Approve selected bills and send them to State (RDD)?")) {
        await approveSelected();
      }
      return;
    }

    // setAvailableNextRoles([info.nextRole]);
    // setSelectedNextRole(info.nextRole);
    // setForwardRemark("");
    // setShowPopup(true);
  } catch (error) {
    console.error("District access error:", error);
    alert(error.message || "Unable to load forwarding roles.");
  } finally {
    // setAccessLoading(false);
  }
};

// const submitForwardBills = async () => {
//   if (!selectedNextRole) return;
//   setShowPopup(false);
//   await approveSelected({ remark: forwardRemark.trim(), nextRole: selectedNextRole });
// };

  return (
    <>
      {/* DIVISION TABLE */}
      {showspecific === 1 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            <h4
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                margin: 0,
              }}
            >
              <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
              {t("Bill Inwards")}
            </h4>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" , marginLeft:"10px"}}>
    <div className="input-group" style={{ width: "190px" }}>
      <span className="input-group-text">{t("From")}</span>
      <input
        type="date"
        className="form-control"
        value={fromDate1}
        max={toDate1 || undefined}
        onChange={(e) => setFromDate1(e.target.value)}
      />
    </div>

    <div className="input-group" style={{ width: "190px" }}>
      <span className="input-group-text">{t("To")}</span>
      <input
        type="date"
        className="form-control"
        value={toDate1}
        min={fromDate1 || undefined}
        onChange={(e) => setToDate1(e.target.value)}
      />
    </div>
  </div>
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
              {t("Division Summary")}
            </h4>
       
            <div
              className="col-12 tableContainer2"
              style={{ overflowX: "scroll" }}
            >
              <table
                className="col-12"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1565c0",
                      color: "white",
                      fontSize: "11px",
                    }}
                  >
                    <th
                      rowSpan="2"
                      style={{
                        padding: "8px",
                        minWidth: "60px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Sr No")}
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        padding: "8px",
                        minWidth: "150px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Division")}
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        padding: "8px",
                        minWidth: "260px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Total Pending Bill at ZP Level")}
                    </th>
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <th
                        colSpan="2"
                        style={{
                          padding: "8px",
                          minWidth: "260px",
                          fontSize: "15px",
                          fontWeight: "600",
                        }}
                      >
                        {t("RDD Checker(ASO)")}
                      </th>
                    )}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <th
                        colSpan="2"
                        style={{
                          padding: "8px",
                          minWidth: "260px",
                          fontSize: "15px",
                          fontWeight: "600",
                        }}
                      >
                        {t("RDD Section Officer")}
                      </th>
                    )}
                  </tr>
                  <tr
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "11px",
                    }}
                  >
                    <th
                      style={{
                        padding: "8px",
                        minWidth: "130px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Count")}
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        minWidth: "130px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Amount")}
                    </th>
                    {(AdminData?.Role === "RDD Checker(ASO)" ||
                      AdminData?.Role === "RDD Section Officer") && (
                      <>
                        <th
                          style={{
                            padding: "8px",
                            minWidth: "130px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Count")}
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            minWidth: "130px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Amount")}
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {divisionSummary.length > 0 ? (
                    divisionSummary.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          fontSize: "10px",
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "white",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#e3f2fd")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0 ? "#f9f9f9" : "white")
                        }
                        onClick={() => HandleDivisionClick(item.Division)}
                      >
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            color: "#1976d2",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t(item.Division)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {item.TotalPendingCount}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {Number(item.TotalPendingAmount).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {item.RDDCheckerCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(item.RDDCheckerAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {item.RDDSOCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(item.RDDSOAmount).toLocaleString("en-IN")}
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "20px", fontWeight: "bold" }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}
                </tbody>

                <tfoot>
                  {(() => {
                    const total = divisionSummary.reduce(
                      (acc, item) => ({
                        TotalPendingCount:
                          acc.TotalPendingCount +
                          Number(item.TotalPendingCount || 0),
                        TotalPendingAmount:
                          acc.TotalPendingAmount +
                          Number(item.TotalPendingAmount || 0),
                        RDDCheckerCount:
                          acc.RDDCheckerCount +
                          Number(item.RDDCheckerCount || 0),
                        RDDCheckerAmount:
                          acc.RDDCheckerAmount +
                          Number(item.RDDCheckerAmount || 0),
                        RDDSOCount:
                          acc.RDDSOCount + Number(item.RDDSOCount || 0),
                        RDDSOAmount:
                          acc.RDDSOAmount + Number(item.RDDSOAmount || 0),
                      }),
                      {
                        TotalPendingCount: 0,
                        TotalPendingAmount: 0,
                        RDDCheckerCount: 0,
                        RDDCheckerAmount: 0,
                        RDDSOCount: 0,
                        RDDSOAmount: 0,
                      },
                    );

                    return (
                      <tr
                        style={{
                          backgroundColor: "#ccdef4",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "11px",
                        }}
                      >
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                          colSpan={2}
                        >
                          {t("Total")}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {total.TotalPendingCount}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {Number(total.TotalPendingAmount).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {total.RDDCheckerCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(total.RDDCheckerAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {total.RDDSOCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(total.RDDSOAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })()}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      )}

      {showspecific === 3 && showDistrictSummary && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          {/* Header bar matching bill table */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginBottom: "20px",
              padding: "10px 4rem",
            }}
          >
            {AdminData?.Department_Name === "State" && (
              <button
                className="btn btn-danger"
                onClick={() => {
                  setCurrentPage(1);
                  setTableData([]);
                  setShowSpecific(1);
                  // setFromDate1();
                  // setToDate1();
                }}
              >
                Back
              </button>
            )}

            <h4
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                margin: 0,
              }}
            >
              <img
                src={BillApprovalBlue32}
                alt="Bill"
                style={{ width: "1.5rem" }}
              />
              {t("Bill Data")}
            </h4>
          </div>

          {/* Table card */}
          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px 20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
              {t("Bill Data")}
            </h4>

            <div
              className="col-12 tableContainer2"
              style={{ overflowX: "scroll" }}
            >
              <table
                className="col-12"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  {/* Top Header */}
                  <tr
                    style={{
                      backgroundColor: "#1565c0",
                      color: "white",
                      fontSize: "11px",
                      textAlign: "center",
                    }}
                  >
                    <th
                      rowSpan="2"
                      style={{
                        minWidth: "60px",
                        padding: "8px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Sr No")}
                    </th>

                    <th
                      rowSpan="2"
                      style={{
                        minWidth: "130px",
                        padding: "8px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("District")}
                    </th>

                    {/* Parent Header */}
                    <th
                      colSpan="2"
                      style={{
                        minWidth: "260px",
                        padding: "8px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Total Pending Bill at ZP Level")}
                    </th>

                    {/* Dynamic Parent Header */}
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <th
                        colSpan="2"
                        style={{
                          minWidth: "260px",
                          padding: "8px",
                          fontSize: "15px",
                          fontWeight: "600",
                        }}
                      >
                        {t("RDD Checker(ASO)")}
                      </th>
                    )}

                    {AdminData?.Role === "RDD Section Officer" && (
                      <th
                        colSpan="2"
                        style={{
                          minWidth: "260px",
                          padding: "8px",
                          fontSize: "15px",
                          fontWeight: "600",
                        }}
                      >
                        {t("RDD Section Officer")}
                      </th>
                    )}
                  </tr>

                  {/* Sub Header */}
                  <tr
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "11px",
                      textAlign: "center",
                    }}
                  >
                    {/* Total Pending Bill sub columns */}
                    <th
                      style={{
                        minWidth: "130px",
                        padding: "8px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Count")}
                    </th>

                    <th
                      style={{
                        minWidth: "130px",
                        padding: "8px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Amount")}
                    </th>

                    {/* RDD Checker sub columns */}
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <>
                        <th
                          style={{
                            minWidth: "130px",
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Count")}
                        </th>

                        <th
                          style={{
                            minWidth: "130px",
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Amount")}
                        </th>
                      </>
                    )}

                    {/* RDD SO sub columns */}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <>
                        <th
                          style={{
                            minWidth: "130px",
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Count")}
                        </th>

                        <th
                          style={{
                            minWidth: "130px",
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {t("Amount")}
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredDistricts && filteredDistricts.length > 0 ? (
                    filteredDistricts.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          fontSize: "10px",
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "white", // alternating rows
                        }}
                      >
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            color: "#1976d2",
                            cursor: "pointer",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                          onClick={() => HandleDistrictClick(item.District)}
                        >
                          {t(item.District)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {item.TotalPendingCount}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {Number(item.TotalPendingAmount || 0).toLocaleString(
                            "en-IN",
                          )}
                        </td>

                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {item.RDDCheckerCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(
                                item.RDDCheckerAmount || 0,
                              ).toLocaleString("en-IN")}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              {item.RDDSOCount}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                fontSize: "15px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {Number(item.RDDSOAmount || 0).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "20px", fontWeight: "bold" }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}
                  <tr
                    style={{
                      backgroundColor: "#e3f2fd",
                      fontWeight: "bold",
                      fontSize: "11px",
                    }}
                  >
                    <td
                      colSpan={2}
                      style={{
                        padding: "10px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {t("Total")}
                    </td>

                    {/* Total Pending */}
                    <td
                      style={{
                        padding: "10px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {filteredDistricts.reduce(
                        (sum, item) =>
                          sum + Number(item.TotalPendingCount || 0),
                        0,
                      )}
                    </td>

                    <td
                      style={{
                        padding: "10px",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      ₹{" "}
                      {filteredDistricts
                        .reduce(
                          (sum, item) =>
                            sum + Number(item.TotalPendingAmount || 0),
                          0,
                        )
                        .toLocaleString("en-IN")}
                    </td>

                    {/* RDD Checker Total */}
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <>
                        <td
                          style={{
                            padding: "10px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {filteredDistricts.reduce(
                            (sum, item) =>
                              sum + Number(item.RDDCheckerCount || 0),
                            0,
                          )}
                        </td>

                        <td
                          style={{
                            padding: "10px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {filteredDistricts
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.RDDCheckerAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                      </>
                    )}

                    {/* RDD SO Total */}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <>
                        <td
                          style={{
                            padding: "10px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {filteredDistricts.reduce(
                            (sum, item) => sum + Number(item.RDDSOCount || 0),
                            0,
                          )}
                        </td>

                        <td
                          style={{
                            padding: "10px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {filteredDistricts
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.RDDSOAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {/* Year wise record */}

      {showspecific === 5 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginBottom: "20px",
              padding: "10px 4rem",
            }}
          >
            <button
              className="btn btn-danger"
              onClick={() => {
                setCurrentPage(1);
                setSelectedDistrict("");
                setselectedProposalYear("");
                setDistrictData([]);
                setTableData([]);
                setShowSpecific(3);
                setShowDistrictSummary(true);
                // setFromDate1();
                // setToDate1();
              }}
            >
              Back
            </button>

            <h4
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                margin: 0,
              }}
            >
              <img
                src={BillApprovalBlue32}
                alt="Bill"
                style={{ width: "1.5rem" }}
              />

              {t("Administrative Year Summary")}

              {selectedDistrict && (
                <span
                  style={{
                    // color: "#1976d2",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  - {t(selectedDistrict)}
                </span>
              )}
            </h4>
          </div>

          {/* Table Card */}
          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <h4
              style={{
                marginBottom: "15px",
                fontWeight: "bold",
              }}
            >
              {t("Administrative Year Summary")}

              {selectedDistrict && (
                <span
                  style={{
                    // color: "#1976d2",
                    fontSize: "18px",
                    fontWeight: "600",
                    marginLeft: "8px",
                  }}
                >
                  - {t(selectedDistrict)}
                </span>
              )}
            </h4>

            <div
              className="col-12 tableContainer2"
              style={{ overflowX: "auto" }}
            >
              <table
                className="col-12"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1565c0",
                      color: "white",
                    }}
                  >
                    <th
                      style={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "15%",
                      }}
                    >
                      {t("Sr No")}
                    </th>

                    <th
                      style={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "35%",
                      }}
                    >
                      {t("Administrative Year")}
                    </th>

                    <th
                      style={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "25%",
                      }}
                    >
                      {t("Total Bills")}
                    </th>

                    <th
                      style={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "25%",
                      }}
                    >
                      {t("Total Amount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                 {administrativeYearSummary.length > 0 ? (
    [...administrativeYearSummary]
      .sort((a, b) => {
        const yearA = parseInt(a.AdministrativeYear.split("-")[0]);
        const yearB = parseInt(b.AdministrativeYear.split("-")[0]);

        return yearA - yearB; // Ascending order
      })
      .map((item, index) => (
        <tr
          key={item.AdministrativeYear}
          style={{
            backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
          }}
        >
                        {/* Sr No */}
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {index + 1}
                        </td>

                        {/* Administrative Year */}
                        <td
                          onClick={() =>
                            HandleYearClick(item.AdministrativeYear)
                          }
                          style={{
                            padding: "12px",
                            color: "#1976d2",
                            cursor: "pointer",
                            fontSize: "15px",
                            fontWeight: "600",
                            textDecoration: "underline",
                          }}
                        >
                          {item.AdministrativeYear}
                        </td>

                        {/* Total Bills */}
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {item.TotalBills}
                        </td>

                        {/* Total Amount */}
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          ₹{" "}
                          {Number(item.TotalAmount || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{
                          padding: "25px",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}

                  {/* Grand Total */}
                  {administrativeYearSummary.length > 0 && (
                    <tr
                      style={{
                        backgroundColor: "#e3f2fd",
                        fontWeight: "bold",
                      }}
                    >
                      <td
                        colSpan="2"
                        style={{
                          padding: "12px",
                          fontSize: "15px",
                          textAlign: "right",
                        }}
                      >
                        {t("Total")}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          fontSize: "15px",
                        }}
                      >
                        {administrativeYearSummary.reduce(
                          (sum, item) => sum + Number(item.TotalBills || 0),
                          0,
                        )}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          fontSize: "15px",
                        }}
                      >
                        ₹{" "}
                        {administrativeYearSummary
                          .reduce(
                            (sum, item) => sum + Number(item.TotalAmount || 0),
                            0,
                          )
                          .toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {showspecific === 0 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            {/* <button className=' px-4 py-2'
              onClick={approveSelected}
              // onClick={(e) => { SetGenerateToken(false) }}
              disabled={selectedBills.length <= 0 ? true : loading}
              style={{
                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer',
                background: selectedBills.length <= 0 ? (
                  'linear-gradient(to Right,rgba(141, 141, 141, 0.97))'
                ) : ('linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )'), color: 'white',
                fontSize: "16px"
              }}
            ><img src="" style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve & Pay'}
            </button> */}
            {/* <button className='btn btn-success'>Approve & Pay</button> */}
            {/* <button className='btn mx-2' style={{ backgroundColor: "#B6BAC1" }}>Back</button> */}

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {AdminData?.Department_Name === "State" && (
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    setSelectedBills([]);
                    setSelectAll(false);
                    setCurrentPage(1);
                //     setFromDate1();
                // setToDate1();

                    // Get complete original data
                    const latest = ALLtableDataRef.current || [];

                    // Keep currently selected district
                    const district = selectedDistrict;

                    console.log("Selected District:", district);

                    // Get only selected district data
                    // const districtFilteredData = latest.filter((item) => {
                    //   return (
                    //     item.District === district ||
                    //     item.District?.startsWith(`${district}-`)
                    //   );
                    // });
                    const districtFilteredData = latest.filter((item) => {
                      const districtMatch =
                        item.District === district ||
                        item.District?.startsWith(`${district}-`);

                      // return districtMatch && inDateRange(item);
                        return districtMatch && passesBase(item);
                    });

                    console.log(
                      "Selected District Year Summary Data:",
                      districtFilteredData,
                    );

                    // Restore selected district data
                    setDistrictData(districtFilteredData);
                    setTableData(districtFilteredData);

                    // IMPORTANT:
                    // Do NOT clear selectedDistrict here
                    // setSelectedDistrict("");

                    // Clear selected year because we are going back to Year Summary
                    setselectedProposalYear("");

                    // Show selected District Administrative Year Summary
                    setShowSpecific(5);
                    setShowDistrictSummary(true);
                  }}
                >
                  Back
                </button>
              )}
              <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
                {t("Bill Inwards")}
              </h4>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                onClick={approveSelected}
                disabled={selectedBills.length <= 0 ? true : loading}
                style={{
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "8px 20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  fontFamily: "sans-serif",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  cursor:
                    selectedBills.length <= 0
                      ? "not-allowed"
                      : loading
                        ? "not-allowed"
                        : "pointer",
                  background:
                    selectedBills.length <= 0
                      ? "linear-gradient(to Right,rgba(141, 141, 141, 0.97)"
                      : "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5)",
                  color: "white",
                }}
              >
                <img
                  src={ApprovePay32}
                  style={{ width: "14px", filter: "brightness(0) invert(1)" }}
                />
                {loading
                  ? AdminData.Department_Name === "District" ||
                    AdminData.Department_Name === "State"
                    ? "Processing..."
                    : ""
                  : t("Approve")}
              </button>

              <button
                onClick={() => openRemarkModal("SendBack")}
                disabled={selectedBills.length <= 0}
                style={{
                  background: "#f0ad4e",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "8px 20px",
                  gap: "8px",
                  fontWeight: 600,
                  cursor: selectedBills.length <= 0 ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src="/Send-Back-Selected32.png"
                  style={{
                    width: "14px",
                    filter: "brightness(0) invert(1)",
                    gap: "8px",
                  }}
                />
                {t("Send Back")}
              </button>

              <button
                onClick={() => openRemarkModal("Reject")}
                disabled={selectedBills.length <= 0}
                style={{
                  background: "#dc3545",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "8px 20px",
                  fontWeight: 600,
                  cursor: selectedBills.length <= 0 ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src="/Reject-Selected32.png"
                  style={{
                    width: "14px",
                    filter: "brightness(0) invert(1)",
                    gap: "8px",
                  }}
                />
                {t("Reject")}
              </button>
            </div>
          </div>

         
          <div
            className=" col-12 my-3 px-4"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col-12"
              style={{
                padding: "1px",
                borderRadius: "10px",
                background: "linear-gradient(to right, #2196f3, #9c27b0)",
                // display: "inline-block",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
                  padding: "30px 20px",
                  borderRadius: "8px",
                  fontFamily: "sans-serif",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    // marginRight: "5px",
                  }}
                >
                  {" "}
                  {t("Work Name")}
                </label>
                <select
                  name="ProjectID"
                  id=""
                  value={data.ProjectID}
                  onChange={HandleChangeData}
                  style={{
                    padding: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    width: "550px",
                    fontSize: "14px",
                  }}
                >
                  <option value="All">{t("Choose Work Name")}</option>
                  {workNameOptions.map((val, index) => (
                    <option key={index} value={val.MainWorkOrderID}>
                      {val.MainWorkOrderID}
                    </option>
                  ))}
                </select>

                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginRight: "5px",
                  }}
                >
                  {t("Administrative Approved Year")}
                </label>

                <select
                  name="ApprovedYear"
                  value={approvedYear}
                  onChange={(e) => setApprovedYear(e.target.value)}
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "250px",
                    fontSize: "14px",
                  }}
                >
                  <option value="">{t("Choose Approved Year")}</option>

                  {[
                    ...new Set(
                      tableData
                        ?.map((item) => item.WorkApprovedYear)
                        .filter(Boolean),
                    ),
                  ]
                    .sort()
                    .map((year, index) => (
                      <option key={index} value={year}>
                        {year}
                      </option>
                    ))}
                </select>
                {/* <button
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <span>{t("Search")}</span>
                </button> */}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              margin: "20px",
              gap: "20px",
            }}
          >
            {/* Left Side - Tally Table */}
            <div>
              <table
                style={{
                  borderCollapse: "collapse",
                  minWidth: "300px",
                  background: "#fff",
                  boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                }}
              >
                <thead>
                  <tr style={{ background: "#1976d2", color: "#fff" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {t("No. of Bills")}
                    </th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {t("Total Amount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {selectedBillCount}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      ₹ {selectedBillAmount.toLocaleString("en-IN")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Right Side - Upload Order */}
            {AdminData.Department_Name == "State" &&
              (AdminData.RoleID == 25 || AdminData.RoleID == 40) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "15px",
                    background: "#f8fafc",
                    borderRadius: "10px",
                    border: "1px solid #dbe4ee",
                  }}
                >
                  <label
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      color: "#1e293b",
                      margin: 0,
                    }}
                  >
                    {t("Fund Release Order")}
                  </label>

                  <input
                    type="file"
                    accept=".pdf,.xls,.xlsx"
                    onChange={handleUploadOrder}
                    style={{
                      border: "1px solid #cbd5e1",
                      padding: "8px",
                      borderRadius: "6px",
                      background: "white",
                      fontSize: "13px",
                      cursor: "pointer",
                    }}
                  />

                  {/* {uploadOrderFile && (
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#0f172a",
                        fontWeight: "500",
                      }}
                    >
                      {uploadOrderFile.name}
                    </span>
                  )} */}
                </div>
              )}
          </div>

          <div style={{ display: "flex", gap: "8px", padding: "4px 1rem" }}>
            <div className="input-group" style={{ width: "150px" }}>
              <select
                className="form-select"
                value={selectedTaluka}
                onChange={(e) => setSelectedTaluka(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "13px",
                }}
              >
                <option value="">Select Taluka</option>

                {[
                  ...new Set(
                    ALLtableData.map((item) => item.Taluka || item.ulb).filter(
                      Boolean,
                    ),
                  ),
                ]
                  .sort()
                  .map((taluka) => (
                    <option key={taluka} value={taluka}>
                      {taluka}
                    </option>
                  ))}
              </select>
            </div>

            {/* Type of Work */}
            <div className="input-group" style={{ width: "170px" }}>
              <select
                className="form-select"
                value={selectedWorkType}
                onChange={(e) => setSelectedWorkType(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "13px",
                }}
              >
                <option value="">Select Type Of Work</option>

                {[
                  ...new Set(
                    ALLtableData.map(
                      (item) => item.typeOfWork || item.workType,
                    ).filter(Boolean),
                  ),
                ]
                  .sort()
                  .map((workType) => (
                    <option key={workType} value={workType}>
                      {workType}
                    </option>
                  ))}
              </select>
            </div>

            {(AdminData.RoleID == 24 ||
              AdminData.RoleID == 25 ||
              AdminData.RoleID == 40 ||
              AdminData.RoleID == 41) && (
              <div style={{ display: "flex", gap: "8px", padding: "4px 1rem" }}>
                {/* <label className="form-label">Date</label> */}

                <div className="d-flex gap-2">
                  <div className="input-group" style={{ width: "170px" }}>
                    <span className="input-group-text">From</span>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="input-group" style={{ width: "170px" }}>
                    <span className="input-group-text">To</span>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </div>
                {/* Search */}
                <div style={{ position: "relative", width: "220px" }}>
                  <img
                    src="/Search32.png"
                    alt="Search"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      opacity: 0.6,
                    }}
                  />
                  <input
                    type="text"
                    placeholder={t("Search Here")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px 12px 8px 32px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f1f6fc",
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px 20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <div className="d-flex gap-2 justify-content-between">
              <div>
                <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
                  {t("Bill Details")}
                </h4>
              </div>
              <div className="d-flex gap-2 ">
                <button
                  className="btn btn-success"
                  onClick={() =>
                    exportTableByClassToExcel(currentBills, "Bill_Inward.xlsx")
                  }
                >
                  {t("Download Excel")}
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() =>
                    downloadTableOnlyAsPDF(
                      "BillInward",
                      "BillInward.pdf",
                      `Zilha Parishad – ${
                        userData?.District === "State"
                          ? selectedDistrict
                          : userData?.District || selectedDistrict
                      }`,
                    )
                  }
                >
                  {t("Download PDF")}
                </button>
              </div>
            </div>

            <div
              className="col-12 tableContainer2"
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "600px", // change height as needed
                position: "relative",
              }}
            >
              <table
                className="col-12 BillInward"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                  background: "white",
                }}
              >
                <thead
                  style={{
                    position: "sticky",
                    backgroundColor: "#1976d2",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <tr
                    style={{
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {/* <th style={{ minWidth: "70px", paddingInline: "4px" }}>
                      <input
                        type="checkbox"
                        style={{ height: "1.2rem", width: "1.4rem" }}
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </th>
                    <th style={{ minWidth: "70px", padding: "8px" }}>
                      {t("Sr.No.")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Class Of Work")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Type Of Work")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      Taluka
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Approved Year")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Approval GR Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("MHUID Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Head Code")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Physical Progress in Percentage")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Received Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Net Payable Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Deduction")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Vendor Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Copy")}
                    </th> */}
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Copy")}
                    </th> */}
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Order Copy")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approved GR (AAGR)")}
                    </th>
                        <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Measurement Book")}
                    </th>
                        <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("SQM Inspection Report")}
                    </th>
                        <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work completion Certificate")}
                    </th> */}

                    <th style={{ minWidth: "70px", paddingInline: "4px" }}>
                      <input
                        type="checkbox"
                        style={{ height: "1.2rem", width: "1.4rem" }}
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </th>
                    <th style={{ minWidth: "70px", padding: "8px" }}>
                      {t("Sr.No.")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand ID")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Creation Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Receive Date at RDD")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approval Year (A.A.Year)")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("MHUID Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Taluka")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Class Of Work")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Type Of Work")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Net Payable Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Deduction")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approval GR Date")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Order Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Physical Progress in Percentage")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Measurement Book")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("SQM Inspection Report")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Completion Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Copy")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Vendor Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Head Code")}
                    </th>

                    {AdminData.Department_Name == "State" &&
                      (AdminData.RoleID == 24 || AdminData.RoleID == 41) && (
                        <th style={{ minWidth: "130px", padding: "8px" }}>
                          {t("Fund Release Order")}
                        </th>
                      )}
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("View mass slip")}
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {currentBills && currentBills.length > 0 ? (
                    <>
                      {currentBills.map((val, index) => {
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                        return (
                          <tr
                            key={index}
                            style={{
                              fontSize: "18px",
                              backgroundColor: bgColor,
                            }}
                            data-demand-id={val.DemandGenerationID}
                          >
                            <td>
                              <input
                                type="checkbox"
                                style={{ height: "1.2rem", width: "1.2rem" }}
                                checked={selectedBills.includes(
                                  val.DemandGenerationID,
                                )}
                                onChange={(e) => {
                                  handleCheckboxChange(val.DemandGenerationID);
                                  // TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount);

                                  // if unchecking any one, uncheck master
                                  if (!e.target.checked) {
                                    setSelectAll(false);
                                  }
                                }}
                              />
                            </td>
                            <td>{index + 1}</td>
                            {/* <td><input type="checkbox" onChange={(e) => TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount)} /></td> */}
                            <td>
                              <span
                                onClick={() =>
                                  settingshowspecific3(val.DemandGenerationID)
                                }
                                style={{
                                  color: "#0d6efd",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: "500",
                                }}
                              >
                                {val.DemandGenerationID}
                              </span>
                            </td>
                            <td>{formatDateTime(val.Date)}</td>
                            <td>
                              {val.BillReceivedDate
                                ? formatDateTime(val.BillReceivedDate)
                                : "-"}
                            </td>
                            <td>{val.ProposalYear || "-"}</td>
                            <td>{val.MHUID_Number || "-"}</td>
                            <td
                              style={{
                                maxWidth: "300px",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {val.MainWorkOrderID}
                            </td>
                            <td>{val.Taluka || val.ulb}</td>
                            <td>{val.classOfWork || val.workClass}</td>
                            <td>
                              {val.typeOfWork && val.typeOfWork !== "NULL"
                                ? val.typeOfWork
                                : val.workType && val.workType !== "NULL"
                                  ? val.workType
                                  : "-"}
                            </td>
                            {/* <td>{val.BillAmount}</td> */}
                            <td>{Number(val.BillAmount).toLocaleString("en-IN")}</td>
                            {/* <td>{val.NetPayableAmount}</td> */}
                            <td>{Number(val.NetPayableAmount).toLocaleString("en-IN")}</td>
                            <td
                              onClick={() =>
                                DemandDeductionDetailByBillID(
                                  val.DemandGenerationID,
                                )
                              }
                            >
                              <p
                                className="makeitlink my-auto"
                                style={{ textAlign: "center" }}
                              >
                                {Number(val.DeductionAmount).toLocaleString(
                                  "en-IN",
                                )}
                              </p>
                            </td>
                            <td>
                              {val.GRCopy ? (
                                <a
                                  href={`${apiurl}/UploadedGR/${val.GRCopy}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#0d6efd",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  {(val.GRApproveDate ||
                                    val.workApprovedGRDate) &&
                                    formatDate(
                                      val.GRApproveDate ||
                                        val.workApprovedGRDate,
                                    )}
                                </a>
                              ) : (
                                ((val.GRApproveDate ||
                                  val.workApprovedGRDate) &&
                                  // new Date(
                                  //   val.GRApproveDate || val.workApprovedGRDate
                                  // ).toLocaleDateString()
                                  formatDate(
                                    val.GRApproveDate || val.workApprovedGRDate,
                                  )) ||
                                "-"
                              )}
                            </td>
                            <td
                              style={{
                                width: "140px",
                                minWidth: "140px",
                                padding: "10px",
                                textAlign: "center",
                              }}
                            >
                              {val.CopyofWorkOrder ? (
                                <a
                                  // href={`${apiurl}/Work_completionImages/${val.Work_completion}`}
                                  href={`${apiurl}/WorkOrderDocsImages/${val.CopyofWorkOrder}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#0d6efd",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  {val.WorkOrderDate
                                    ? formatDate(val.WorkOrderDate)
                                    : "-"}
                                </a>
                              ) : val.WorkOrderDate ? (
                                formatDate(val.WorkOrderDate)
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              <span
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  openProgressModal(
                                    val.physicalprogressImage,
                                    val.Location,
                                  )
                                }
                              >
                                {val.physicalValueOfProgress}%
                              </span>
                            </td>
                            <td>
                              {val.Measurement_Book ? (
                                <p>
                                  <a
                                    href={`${apiurl}/Measurement_BookImages/${val.Measurement_Book}`}
                                    target="_blank"
                                  >
                                    {formatFileName(val.Measurement_Book)}
                                  </a>
                                </p>
                              ) : (
                                <p
                                  className="text-danger fw-bold my-auto"
                                  style={{ fontSize: "12px" }}
                                >
                                  {t("No File")}
                                </p>
                              )}
                            </td>
                            <td>
                              {val.Inspection_Report ? (
                                <p>
                                  <a
                                    href={`${apiurl}/Inspection_ReportImages/${val.Inspection_Report}`}
                                    target="_blank"
                                  >
                                    {formatFileName(val.Inspection_Report)}
                                  </a>
                                </p>
                              ) : (
                                <p
                                  className="text-danger fw-bold my-auto"
                                  style={{ fontSize: "12px" }}
                                >
                                  {t("No File")}
                                </p>
                              )}
                            </td>
                            <td>
                              {val.Work_completion ? (
                                <a
                                  href={`${apiurl}/Work_completionImages/${val.Work_completion}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#0d6efd",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  {val.WorkEndDate
                                    ? formatDate(val.WorkEndDate)
                                    : "-"}
                                </a>
                              ) : val.WorkEndDate ? (
                                formatDate(val.WorkEndDate)
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {val.UploadBillCopy ? (
                                <p className="my-auto">
                                  <a
                                    href={`${apiurl}/BillCopyDocsImages/${val.UploadBillCopy}`}
                                    target="_blank"
                                  >
                                    {formatFileName(val.UploadBillCopy)}
                                  </a>
                                </p>
                              ) : (
                                <p
                                  className="text-danger fw-bold my-auto"
                                  style={{ fontSize: "18px" }}
                                >
                                  {t("No File")}
                                </p>
                              )}
                            </td>
                            <td>{val.ContractorName}</td>
                            <td>{val.BudgetID}</td>
                            {/*  */}

                            {/* <td>{val.physicalValueOfProgress}%</td> */}

                            {/*
                             */}
                            {/* <td style={{ fontSize: "12px", padding: "5px" }}>
                              <button
                                className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
                                style={{
                                  minHeight: "33px",
                                  minWidth: "100px",
                                  padding: "0.375rem 0.75rem",
                                  fontSize: "0.9rem",
                                  fontWeight: 400,
                                  lineHeight: 1.5,
                                  cursor: "pointer",
                                  background:
                                    "linear-gradient(to right, #38439f, #048ecc)",
                                  color: "white",
                                  borderRadius: "999px",
                                  border: "1px solid transparent",
                                }}
                                onClick={() =>
                                  settingshowspecific3(val.DemandGenerationID)
                                }
                              >
                                <img
                                  src="/view32.png"
                                  alt="view"
                                  width="15"
                                  height="15"
                                  style={{ verticalAlign: "middle" }}
                                />
                                <span style={{ lineHeight: 1 }}>View </span>
                              </button>
                            </td> */}

                            {AdminData.Department_Name == "State" &&
                              (AdminData.RoleID == 24 ||
                                AdminData.RoleID == 41) && (
                                <td className="py-2">
                                  {val.uploadWork ? (
                                    <p className="my-auto">
                                      <a
                                        href={`${apiurl}/UploadWorkFiles/${val.uploadWork}`}
                                        target="_blank"
                                      >
                                        {formatFileName(val.uploadWork)}
                                      </a>
                                    </p>
                                  ) : (
                                    <p
                                      className="text-danger fw-bold my-auto"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {t("No File")}
                                    </p>
                                  )}
                                </td>
                              )}
                          </tr>
                        );
                      })}{" "}
                      <tr
                        style={{
                          backgroundColor: "#ffffff",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        <td
                          colSpan={11}
                          style={{ textAlign: "right", padding: "10px" }}
                        >
                          Page Total
                        </td>

                        {/* Total Bill Amount */}
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce(
                              (sum, item) => sum + Number(item.BillAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>

                        {/* Total Net Payable Amount */}
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.NetPayableAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.DeductionAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        {/* Empty remaining columns */}
                        <td colSpan={0}></td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#ffffff",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        <td
                          colSpan={11}
                          style={{ textAlign: "right", padding: "10px" }}
                        >
                          Gross Total
                        </td>

                        {/* Total Bill Amount */}
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {sortedBills
                            .reduce(
                              (sum, item) => sum + Number(item.BillAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>

                        {/* Total Net Payable Amount */}
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {sortedBills
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.NetPayableAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {sortedBills
                            .reduce(
                              (sum, item) =>
                                sum + Number(item.DeductionAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        {/* Empty remaining columns */}
                        <td colSpan={0}></td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan={14}>{t("No data found !!")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // padding: " 0px 2.5rem",
                height: "3rem",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <div>
                <p style={{ margin: "0px", color: "black" }}>
                  {t("Showing")}{" "}
                  {tableData.length === 0 ? 0 : indexOfFirstBill + 1} {t("to")}{" "}
                  {Math.min(indexOfLastBill, tableData.length)} {t("of")}{" "}
                  {tableData.length} {t("entries")}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <GooglePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

                <button
                  onClick={() => {
                    setShowAll(!showAll);
                    setCurrentPage(1);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#fff",
                    background: showAll
                      ? "linear-gradient(135deg, #28a745, #20c997)"
                      : "linear-gradient(135deg, #0067ab, #0098d5)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showAll ? "✓ Showing All" : "View All"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedDemandID && showspecific === 2 && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12">
              <div className="col-12 py-3">
                <button
                  className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                  onClick={() => setShowSpecific(0)}
                >
                  {t("Back")}
                </button>
              </div>

              <div className="col-11 my-4 mx-auto">
                <div className="row">
                  <div className="col-9 my-auto">
                    <h2
                      className="col-10 m-0"
                      style={{
                        color: "#2C78DB",
                        fontWeight: "700",
                        fontSize: "1.4rem",
                      }}
                    >
                      {t("Deduction Data of Bill")} {selectedDemandID}
                    </h2>
                  </div>

                  {/* <div className="col-2 text-end">
                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
              </div> */}
                </div>
              </div>
              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB", overflowX: "hidden" }}
                  >
                    <table
                      className="m-0 p-0"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "12px",
                          }}
                        >
                          <th style={{ width: "10%" }}>{t("Sr No")}</th>
                          <th style={{ width: "45%" }}>
                            {t("Deduction Name")}
                          </th>
                          <th style={{ width: "45%", textAlign: "left" }}>
                            {t("Deduction Amount")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fetchSpecificDemandDeductionDetail &&
                        fetchSpecificDemandDeductionDetail.length > 0 ? (
                          <>
                            {fetchSpecificDemandDeductionDetail
                              .filter(
                                (item) =>
                                  item.TypeOfAmount !== "Total Amount Payable",
                              )
                              .map((val, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <td>{index + 1}</td>
                                    <td>{val.TypeOfAmount}</td>
                                    <td style={{ textAlign: "left" }}>
                                      ₹{" "}
                                      {Number(val.TotalAmount).toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}

                            <tr
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#f0f0f0",
                              }}
                            >
                              <td colSpan={2}>{t("Total Deduction Amount")}</td>
                              <td style={{ textAlign: "left" }}>
                                ₹{" "}
                                {
                                  Number(
                                    fetchSpecificDemandDeductionDetail
                                      .filter(
                                        (item) =>
                                          item.TypeOfAmount !==
                                          "Total Amount Payable",
                                      )
                                      .reduce(
                                        (acc, curr) =>
                                          acc +
                                          parseFloat(curr.TotalAmount || 0),
                                        0,
                                      ),
                                  ).toLocaleString("en-IN")
                                  // .toFixed(2)
                                }
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td colSpan={5} className="fw-bold">
                              {t("No Data Found !!")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressImages?.length > 0 ? (
                    progressImages.map((img, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <img
                          src={`${apiurl}/UploadProgressDocsImages/${img}`}
                          alt="progress"
                          className=" rounded border p-2"
                          style={{
                            maxWidth: "100%",
                            textAlign: "center",
                            alignItems: "center",
                            maxHeight: "500px",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressData?.length > 0 ? (
                    progressData.map((item, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "10px",
                            background: "#fff",
                          }}
                        >
                          <img
                            src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
                            alt="Document"
                            style={{
                              width: "120px",
                              cursor: "pointer",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              setSelectedImage(
                                `${apiurl}/UploadProgressDocsImages/${item.image}`,
                              );
                              setSelectedImageIndex(index);
                              setShowImageModal(true);
                            }}
                          />
                          {/* <img
                            src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
                            alt="progress"
                            className="img-fluid rounded"
                            style={{
                              width: "100%",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                          /> */}

                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "14px",
                              lineHeight: "1.7",
                            }}
                          >
                            <div>
                              📍 <strong>Latitude:</strong>{" "}
                              {item.location?.latitude || "-"}
                            </div>

                            <div>
                              📍 <strong>Longitude:</strong>{" "}
                              {item.location?.longitude || "-"}
                            </div>

                            <div>
                              📅 <strong>Date:</strong>{" "}
                              {item.location?.date || "-"}
                            </div>

                            <div>
                              🕒 <strong>Time:</strong>{" "}
                              {item.location?.time || "-"}
                            </div>

                            <div>
                              ⛰️ <strong>Elevation:</strong>{" "}
                              {item.location?.elevation || "-"} m
                            </div>

                            <div>
                              🎯 <strong>Accuracy:</strong>{" "}
                              {item.location?.accuracy || "-"} m
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRemarkModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "24px",
              borderRadius: "12px",
              width: "420px",
            }}
          >
            <h5>
              {remarkAction === "Reject"
                ? t("Reject Bill")
                : t("Send Back Bill")}
            </h5>
            <textarea
              rows={4}
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
              placeholder={t("Enter remark (required)")}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                marginTop: "10px",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "16px",
              }}
            >
              <button
                onClick={() => setShowRemarkModal(false)}
                className="btn btn-secondary"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={submitRejectSendBack}
                className={
                  remarkAction === "Reject"
                    ? "btn btn-danger"
                    : "btn btn-warning"
                }
              >
                {t("Confirm")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showspecific === 4 && (
        <>
          <div className="col-12 m-auto">
            <div
              className="col-12 m-auto my-15 mb-10 budgetContainer "
              style={{
                maxHeight: "85vh", // or 700px
                overflowY: "auto",
                overflowX: "hidden",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <div className="m-auto budgetElement">
                {/* Heading */}

                {/* TABLE CONTAINER */}
                <div
                  className="mt-3 d-flex justify-content-between"
                  style={{
                    position: "relative",
                    alignItems: "center",
                    background: "#fff",
                  }}
                >
                  {/* TITLE – LEFT */}
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <img
                      src="/Bill-files64.png"
                      alt="MAS Slip"
                      width="26"
                      height="26"
                      // style={{ transform: "translateY(9px)", }}
                    />
                    <h5 className="m-0 fw-bold">Bill Slip</h5>
                  </div>
                  {/* BACK BUTTON – TOP RIGHT */}
                  <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-primary d-flex align-items-center gap-2"
                      style={{
                        borderRadius: "999px",
                        padding: "6px 22px",
                        fontSize: "14px",
                        zIndex: 10,
                      }}
                      onClick={exportBillSlipPDF}
                      disabled={exportingBillSlipPDF}
                    >
                      {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
                    </button>
                    <button
                      className="btn btn-danger d-flex align-items-center gap-2"
                      style={{
                        top: "12px",
                        right: "12px",
                        borderRadius: "999px",
                        padding: "6px 22px",
                        fontSize: "14px",
                        zIndex: 10,
                      }}
                      onClick={BackFunction}
                    >
                      {/* <img
                        src={Back32}
                        alt="back"
                        width="14"
                        height="14"
                        // style={{ filter: "brightness(0) invert(1)" }}
                      /> */}
                      Back
                    </button>
                  </div>
                </div>

                {/* ================= HEADER ================= */}
                <div ref={billSlipRef}>
                  <div
                    className="text-center text-white py-3"
                    style={{
                      background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                    }}
                  >
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Zila Parishad - {selectedBillData.District}
                    </div>

                    {/* <div style={{ fontSize: "15px", fontWeight: "bold" }}>
                      प्रशासकीय मंजुरी वर्ष - 2026-2027
                    </div>

                    <div>
                      विभाग - EXE.ENGINEER ZP Division{" "}
                      {selectedBillData.Division}
                    </div>

                    <div>उप-विभाग - {selectedBillData.District}</div>

                    <div class="small">
                      या तपशीलवार शीर्षाचे देयकासाठी आवश्यक असेल तिथे वित्त
                      विभागाचा अनौपचारिक संदर्भ तपासावा.
                    </div> */}
                  </div>
                  <div className="border border-dark p-1">
                    <table
                      className="table mb-0"
                      style={{ fontSize: "14px", border: "none" }}
                    >
                      <tbody>
                        {/* <tr>
                          <td className='text-start'>
                            <span>UserName :</span>

                          </td>
                          <td className='text-end'>
                            <span>DateTime : </span>
                          </td>
                        </tr> */}
                        <tr>
                          <td
                            colSpan={2}
                            className="fw-bold text-center fs-6 p-1"
                          >
                            {" "}
                            Bill Slip for RDD
                          </td>
                        </tr>
                        {[
                          [
                            "User Name",
                            `${selectedBillData.UploadedBy ?? "-"}`,
                          ],
                          [
                            "Demand ID",
                            `${selectedBillData.DemandGenerationID ?? "-"}`,
                          ],
                          [
                            "Bill Creation Date",
                            formatDateTime(selectedBillData.UploadedOn),
                          ],
                          ["Head Code", `${selectedBillData.BudgetID ?? "-"}`],
                          ["Work Name", `${selectedBillData.ProjectID ?? "-"}`],
                          [
                            "Class of Work",
                            `${selectedBillData.classOfWork || selectedBillData.workClass || "-"}`,
                          ],
                          [
                            "Work Approved Year",
                            `${selectedBillData.ProposalYear ?? "-"}`,
                          ],
                          [
                            "Work order date",
                            formatDate(selectedBillData.WorkOrderDate),
                          ],
                          [
                            "Work Approved Amount",
                            `${selectedBillData.ApprovedWorkAmount ?? "-"}`,
                          ],
                          [
                            "Gross Bill Amount",
                            `${selectedBillData.BillAmount ?? "-"}`,
                          ],
                          [
                            "R.A.Bill No:",
                            `${selectedBillData.RABillNumber ?? "-"}`,
                          ],

                          [
                            "Invoice Bill No",
                            `${selectedBillData.InvoiceNo ?? "-"}`,
                          ],
                        ].map(([label, value], index) => (
                          <tr
                            key={index}
                            style={{ border: "1.5px solid #1190CA" }}
                          >
                            <td
                              className="text-start"
                              style={{
                                width: "30%",
                                backgroundColor: "#EAF3FB",
                                fontWeight: 500,
                                padding: "6px 10px",
                                borderRight: "1.5px solid #1190CA",
                              }}
                            >
                              {label}
                            </td>

                            <td
                              className="text-start"
                              style={{
                                width: "70%",
                                padding: "6px 10px",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              {value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <table
                      className="mt-1"
                      style={{
                        borderCollapse: "collapse",
                        border: "1px solid #000",
                      }}
                    >
                      <tbody>
                        <tr className="border border-dark">
                          <td
                            className="text-start border border-dark "
                            style={{ width: "30%" }}
                          >
                            Bill Amount
                          </td>
                          <td
                            className="text-start border border-dark"
                            style={{ width: "23%" }}
                          >
                            Deduction Amount
                          </td>
                          {/* <td
                            className="text-start border border-dark"
                            style={{ width: "23%" }}
                          >
                            Total Bill Amount
                          </td> */}
                          <td
                            className="text-start border border-dark "
                            style={{ width: "24%" }}
                          >
                            Net Payable
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start border border-dark">
                            {selectedBillData.BillAmount}
                          </td>
                          <td className="text-start border border-dark">
                            {selectedBillData.DeductionAmount}
                          </td>
                          {/* <td className="text-start border border-dark">
                            {selectedBillData.BillAmount}
                          </td> */}
                          <td className="text-start border border-dark">
                            {selectedBillData.NetPayableAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Vendor Details */}
                    <table
                      className="mt-2"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "14px",
                      }}
                    >
                      <tbody>
                        {/* Section Title */}
                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            backgroundColor: "#EAF3FB",
                          }}
                        >
                          <td
                            colSpan="6"
                            style={{
                              padding: "8px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                            }}
                          >
                            Vendor Details
                          </td>
                        </tr>

                        {/* Column Headers */}
                        <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Vendor Name
                          </td>
                          {/* <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }}>PAN Number</td> */}
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            IFSC Code
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Branch Name
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Bank Name
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Account Number
                          </td>
                          <td
                            style={{
                              padding: "6px 8px",
                              fontWeight: 500,
                              backgroundColor: "#1190CA",
                              color: "white",
                            }}
                          >
                            Amount{" "}
                          </td>
                        </tr>

                        {fetchSpecificDemandDeductionDetail &&
                          fetchSpecificDemandDeductionDetail
                            .filter(
                              (val) =>
                                val.TypeOfAmount == "Total Amount Payable",
                            )
                            .map((val, index) => {
                              return (
                                <>
                                  <tr
                                    style={{ border: "1.5px solid #1190CA" }}
                                    key={index}
                                  >
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.Vendor_Company_Name}
                                    </td>
                                    {/* <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Vendor_Company_Name}</td> */}
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.Bank_IFSC_Code}
                                    </td>
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.Branch_Name}
                                    </td>
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.BANK_NAME}
                                    </td>
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.Bank_Account_Number}
                                    </td>
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {val.NetPayableAmount}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}

                        {/* <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                          >
                            Shivsai Construction
                          </td>
                          <td className='border border-dark'>AKIPS8199N</td>
                          <td className='border border-dark'>MAHB0001302</td>
                          <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
                          <td className='border border-dark'>2,43,991.0</td>
                          <td className='border border-dark'> 2,43,991.0</td>
                        </tr> */}

                        {/* Total */}
                        <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                            style={{
                              padding: "6px 8px",
                              backgroundColor: "#EAF3FB",
                              fontWeight: 500,
                            }}
                            colSpan={5}
                          >
                            Total
                          </td>
                          <td className="border border-dark">
                            {selectedBillData.NetPayableAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table
                      className="my-2"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            backgroundColor: "#EAF3FB",
                          }}
                        >
                          <td
                            colSpan="6"
                            style={{
                              padding: "8px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                            }}
                          >
                            Deduction Amount Details
                          </td>
                        </tr>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                          }}
                        >
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Sr No
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Deduction Type
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Deduction Amount{" "}
                          </th>
                          {/* <th style={{ minWidth: "60px", padding: "8px" }}>
                          Vendor Name
                        </th> */}
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Account Number
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            Bank Name
                          </th>
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            IFSC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fetchSpecificDemandDeductionDetail.filter(
                          (val) => val.TypeOfAmount != "Total Amount Payable",
                        )?.length == 0 ? (
                          <tr>
                            <td
                              colSpan="30"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        ) : (
                          fetchSpecificDemandDeductionDetail
                            .filter(
                              (val) =>
                                val.TypeOfAmount != "Total Amount Payable",
                            )
                            .map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  className="px-3"
                                  key={index}
                                  style={{
                                    borderBottom: "1px solid #3b409e",
                                    backgroundColor: bgColor,
                                  }}
                                >
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {technicalInwards.TypeOfAmount}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {technicalInwards.TotalAmount}
                                  </td>
                                  {/* <td
                                  style={{ fontSize: "12px", padding: "5px" }}
                                >
                                  {technicalInwards.Vendor_Company_Name}
                                </td> */}
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {technicalInwards.Bank_Account_Number}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {technicalInwards.Bank_Name}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {technicalInwards.Bank_IFSC_Code}
                                  </td>
                                </tr>
                              );
                            })
                        )}

                        <tr
                          style={{
                            border: "1.5px solid #1190CA",
                            fontWeight: 600,
                            background: "white",
                          }}
                        >
                          <td
                            colSpan="2"
                            style={{ padding: "6px 8px", textAlign: "right" }}
                          >
                            Total
                          </td>
                          <td style={{ padding: "6px 8px" }}>
                            {selectedBillData.DeductionAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Signature grid */}
                    <table style={footerTitleStyle}>
                      <tbody>
                        <tr>
                          <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={remarksTableStyle}>
                      <tbody>
                        <tr>
                          <td style={remarksTableTdStyle}>
                            प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत
                            करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च
                            करण्यात येणार आहे.
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={remarksTableStyle}>
                      <tbody>
                        <tr>
                          <td style={remarksTableTdStyle}>
                            स्वाक्षरी आहरण व संवितरण अधिकारी
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={instructionTableStyle}>
                      <tbody>
                        <tr>
                          <td style={instructionTableTdStyle}>
                            दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे
                            प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या
                            अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात
                            नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी
                            ग्रामविकास विभाग मुबई येथे सादर करण्यात आले नव्हते.
                            प्रमाणित करण्यात येते की वरील मागणी ही महाराष्ट्र
                            कोषागार नियम / मुंबई वित्तीय नियम / महाराष्ट्र
                            आकस्मिक खर्च नियम व वेळोवेळी विहित केलेल्या
                            आदेशांच्या आधारे तयार करण्यात आली आहे. श्री. किंवा
                            श्रीमती ______________________________ यांना सदर
                            देयकाची रक्कम/किंवा अपेक्षित देयक प्रदान करीता
                            प्राधिकृत करण्यात आले असून त्यांची स्वाक्षरी
                            खालीलप्रमाणे आहे.
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* <table style={signatureTableStyle}>
                      <tbody>
                        <tr>
                          <td style={signatureTableTdStyle}>
                            <div style={signBoxStyle}>
                              <div style={signSpaceStyle}></div>
                              <div style={signTitleStyle}>
                                संदेश वाहकाची स्वाक्षरी
                              </div>
                            </div>
                          </td>

                          <td style={signatureTableTdStyle}></td>

                          <td style={signatureTableTdStyle}>
                            <div style={signBoxStyle}>
                              <div style={signSpaceStyle}></div>

                              <div style={signTitleStyle}>सही</div>

                              <div style={officerStyle}>
                                DY Secretary / Controller Officer
                              </div>

                              <div style={officerMarathiStyle}>
                                आहरण व संवितरण अधिकारी
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table> */}

                    {/* Footer */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* Previous Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();

              const prevIndex =
                (selectedImageIndex - 1 + progressData.length) %
                progressData.length;

              setSelectedImageIndex(prevIndex);
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❮
          </button>

          {/* Close Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowImageModal(false);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ×
          </button>

          {/* Current Image */}
          <img
            src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "85%",
              maxHeight: "85%",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />

          <button
            onClick={() => setShowImageModal(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            ×
          </button>

          {/* Image Counter */}
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              padding: "6px 12px",
              borderRadius: "20px",
            }}
          >
            {selectedImageIndex + 1} / {progressData.length}
          </div>

          {/* Next Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();

              const nextIndex = (selectedImageIndex + 1) % progressData.length;

              setSelectedImageIndex(nextIndex);
            }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❯
          </button>
        </div>
      )}

      {/* {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={selectedImage}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />

          <button
            onClick={() => setShowImageModal(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      )} */}
    </>
  );
};
export default DemandApproval;




// --> old cdoe
// import React, { useContext, useEffect, useState } from "react";
// import "./DemandApproval.css";
// import { apiurl } from "../../../../../path";
// import Application from "../../../StateContext/Application.js";
// import {
//   ApprovePay32,
//   AvailableReleaseAmount,
//   Balance,
//   BillApprovalBlue32,
//   Search32,
//   SelectedDemandAmount,
//   TotalAmountRelease,
//   TotalLimitAlloted123,
//   TotalProjectCost11,
//   TotalWorkOrders,
// } from "../../../../../public/LoginImages/importimages.js";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
// import { jwtDecode } from "jwt-decode";
// import GooglePagination from "../../../styles/GooglePagination";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import * as XLSX from "xlsx";
// import { useLocation } from "react-router-dom";
// import { formatDateTime, formatDate, getDivisionRank } from "../../../../../utils/DateFormat.js";
// import validateFile from "../../../../../utils/fileUploadHelper.js";


// const DemandApproval = () => {
//   const location = useLocation();
//   // ---- State declarations ----
//   const [userData, setUserData] = useState(null);
//   const [AdminData, setAdminData] = useState([]);
//   // ---- Show Division Summary only for State users ----
//   useEffect(() => {
//     if (AdminData?.Department_Name === "State") {
//       setShowSpecific(1);
//       setShowDistrictSummary(true);
//     }
//   }, [location.pathname, AdminData?.Department_Name]);

// //   const pathname = useLocation();
// //   useEffect(() => {
// //     setShowSpecific(1);
// //     setShowDistrictSummary(true);
// //   }, [pathname]);
// // // const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("Token");
//     if (token) {
//       try {
//         // Decode the JWT token to get user details
//         const decoded = jwtDecode(token);
//         setUserData(decoded);
//         console.log("Logged User Info:", decoded);
//       } catch (error) {
//         console.error("Invalid token:", error);
//       }
//     }
//   }, []);

//   console.log("userData: ", userData);

//   const { language, toggleLanguage, t } = useLanguage();
//   const operation = useContext(Application);

//   const {
//     GetProjectInfo,
//     GetBudgetHeadInfo,
//     DemandCreation,
//     GetDemandApproval,
//     ApproveBills,
//     GetTotalAmountAvailbaleInBank,
//     CreateToken,
//     Usermenu,
//     Getyears,
//     GetStateBillSummary,
//     RejectOrSendBackBill,
//   } = operation;

//   const [projectId, setProjectId] = useState([]);
//   const [ALLtableData, setALLTableData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [getAvailableBankBalance, SetAvailableBankBalance] = useState([]);
//   const [BankBalance, setBankBalance] = useState([]);
//   const [CountBalance, setCountBalance] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [showspecific, setShowSpecific] = useState(0);
//   const [selectedDemandID, setSelectedDemandID] = useState();
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);
//   const [selectedImage, setSelectedImage] = useState("");

//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [showDivisionSummary, setShowDivisionSummary] = useState(false);

//   const [selectedTaluka, setSelectedTaluka] = useState("");
//   const [selectedWorkType, setSelectedWorkType] = useState("");

//   const [districtSummary, setDistrictSummary] = useState([]);
//   const [showDistrictSummary, setShowDistrictSummary] = useState(false);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [uploadOrderFile, setUploadOrderFile] = useState(null);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//     const [fromDate1, setFromDate1] = useState("");
//   const [toDate1, setToDate1] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [approvedYear, setApprovedYear] = useState("");
//   const [districtData, setDistrictData] = useState([]);
//   const [selectedBillData, setselectedBillData] = useState({});
//   const [showRemarkModal, setShowRemarkModal] = useState(false);
//   const [remarkAction, setRemarkAction] = useState(null); // "Reject" | "SendBack"
//   const [remarkText, setRemarkText] = useState("");

//   const [exportingPDF, setExportingPDF] = useState(false);

//   const [selectedProposalYear, setselectedProposalYear] = useState("");
//   const HandleDivisionClick = (division) => {
//     setSelectedDivision(division);
//     setSelectedDistrict("");
//     setselectedProposalYear("");
//     setSelectedBills([]);
//     setSelectAll(false);
//     setCurrentPage(1);
//     setDistrictData([]);
//     setTableData([]);
//     setShowSpecific(3);
//   };
  
//   // const filteredDistricts = districtSummary.filter(
//   //   (d) => d.Division === selectedDivision,
//   // );

//   console.log("All TableData: ", ALLtableData);
//   const ALLtableDataRef = React.useRef([]);
//   const billSlipRef = React.useRef(null);
//   const [userDistrict, setuserDistrict] = useState({});

//   const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);

//   useEffect(() => {
//     ALLtableDataRef.current = ALLtableData;
//   }, [ALLtableData]);

//   const [
//     fetchSpecificDemandDeductionDetail,
//     setfetchSpecficDemandDeductionDetail,
//   ] = useState([]);
//   // const [filteredBills, setFilteredBills] = useState([]);
//   const [uploadedFiles, setUploadedFiles] = useState({});
//   const handleUploadOrder = (e) => {
//     const file = e.target.files[0];

//     if (!file) return;

//     // No bill selected
//     if (selectedBills.length === 0) {
//       alert("Please select bill first!");
//       return;
//     }

//     const validation = validateFile(file, 2);

//     if (!validation.valid) {
//       alert(validation.message);
//       e.target.value = "";
//       return;
//     }

//     setUploadOrderFile(file);

//     // Attach same uploaded file to all selected bills
//     const updatedFiles = {};

//     selectedBills.forEach((billId) => {
//       updatedFiles[billId] = file;
//     });

//     setUploadedFiles((prev) => ({
//       ...prev,
//       ...updatedFiles,
//     }));
//   };
//   const [currentPage, setCurrentPage] = useState(1);

//   const [showAll, setShowAll] = useState(false);
//   const billsPerPage = showAll ? tableData.length || 1 : 10;

//   const totalPages = Math.ceil(tableData?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   //  const sortedBills = Array.isArray(tableData)? tableData.slice() // ✅ prevent state mutation
//   // .sort((a, b) => new Date(b.Date) - new Date(a.Date))
//   //         : [];
//   const sortedBills = tableData;
//   const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
//   // const currentBills = tableData?.slice(indexOfFirstBill, indexOfLastBill);

//   const [data, setData] = useState({
//     ProjectName: "",
//     ProjectID: "",
//     PIU: "",
//     AvaiableReleaseAmount: 0,
//     SelectedDemandAmount: 0,
//     Balance: 0,
//   });

//   const [hide, sethide] = useState(true);
//   const [Etoken, SetEtoken] = useState(false);
//   const [GenerateToken, SetGenerateToken] = useState(true);


//   console.log("Admin DAta: ", AdminData);
//   // const administrativeYearSummary = React.useMemo(() => {
//   //   if (!Array.isArray(districtData)) return [];

//   //   const yearMap = {};

//   //   districtData.forEach((item) => {
//   //     const year = item.AdministrativeYear || item.ProposalYear || item.Year;

//   //     if (!year) return;

//   //     const yearKey = String(year).trim();

//   //     if (!yearMap[yearKey]) {
//   //       yearMap[yearKey] = {
//   //         AdministrativeYear: yearKey,
//   //         TotalBills: 0,
//   //         TotalAmount: 0,
//   //       };
//   //     }

//   //     yearMap[yearKey].TotalBills += 1;
//   //     yearMap[yearKey].TotalAmount += Number(item.BillAmount || 0);
//   //   });

//   //   return Object.values(yearMap).sort((a, b) =>
//   //     b.AdministrativeYear.localeCompare(a.AdministrativeYear),
//   //   );
//   // }, [districtData]);
//   // console.log("administrativeYearSummary...... ", administrativeYearSummary);
//   // const administrativeYearData = ALLtableDataRef.current;
//   // const yearSummary = administrativeYearData.reduce((acc, item) => {
//   //   const year = item.ProposalYear || "Unknown";

//   //   if (!acc[year]) {
//   //     acc[year] = [];
//   //   }

//   //   acc[year].push(item);

//   //   return acc;
//   // }, {});
//    const administrativeYearSource =
//     ALLtableDataRef.current || [];
//    const administrativeYearSummary = React.useMemo(() => {
//     if (!Array.isArray(districtData)) return [];
  
//     const yearMap = {};
  
//     districtData.forEach((item) => {
//       const year =
//         item.AdministrativeYear ||
//         item.ProposalYear ||
//         item.Year;
  
//       if (!year) return;
  
//       const yearKey = String(year).trim();
  
//       if (!yearMap[yearKey]) {
//         yearMap[yearKey] = {
//           AdministrativeYear: yearKey,
//           TotalBills: 0,
//           TotalAmount: 0,
//         };
//       }
  
//       yearMap[yearKey].TotalBills += 1;
//       yearMap[yearKey].TotalAmount += Number(item.BillAmount || 0);
//     });
  
//     return Object.values(yearMap).sort((a, b) =>
//       b.AdministrativeYear.localeCompare(a.AdministrativeYear)
//     );
//   }, [districtData]);
//     console.log("administrativeYearSummary...... ", administrativeYearSummary);
//   const administrativeYearData = ALLtableDataRef.current;
//   const yearSummary = administrativeYearData.reduce((acc, item) => {
//     const year = item.ProposalYear || "Unknown";
  
//     if (!acc[year]) {
//       acc[year] = [];
//     }
  
//     acc[year].push(item);
  
//     return acc;
//   }, {});
//   async function GenerateTokenFor(e) {
//     e.preventDefault();
//     let data = await CreateToken("Demand Approval");
//     document.getElementById("tokencopys").innerText = data;
//     SetEtoken(data);
//     sethide(false);
//   }

//   const HandleChangeData = (e) => {
//     const { name, value } = e.target;
//     setData({ ...data, [name]: value });
//   };

//   const FetchData = async () => {
//     try {
//       if (AdminData?.Department_Name === "State") {
//         // ✅ Fetch BOTH summary and all bills together
//         let [summaryRes, allBills] = await Promise.all([
//           GetStateBillSummary(),
//           GetDemandApproval(), // no param = all bills
//         ]);

//         if (summaryRes?.status) {
//           setDistrictSummary(summaryRes.message);
//           setShowDistrictSummary(true);
//           setShowSpecific(1);
//         }

//         // if (allBills && allBills.length > 0) {
//         //   setALLTableData(allBills); // ✅ stored for district filtering
//         // }
//         if (allBills && allBills.length > 0) {
//   const seenIds = new Set();
//   const uniqueBills = allBills.filter((r) => {
//     if (seenIds.has(r.DemandGenerationID)) return false;
//     seenIds.add(r.DemandGenerationID);
//     return true;
//   });
//   setALLTableData(uniqueBills);
// }

//         return;
//       }

//       // Non-state unchanged
//       let res = await GetDemandApproval();
//       let proposalData = res.map((val) => ({
//         ProjectId: val.MainWorkOrderID,
//         ProjectName: val.MainWorkOrderID,
//       }));
//       const seen = new Set();
//       const uniqueProposalData = proposalData.filter((item) => {
//         const key = item.ProjectId;
//         return seen.has(key) ? false : seen.add(key);
//       });
//       setProjectId(uniqueProposalData);
//       setTableData(res);
//       setALLTableData(res);
//       setShowSpecific(0);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   //For Fetching Admin details
//   const GetAdminData = async () => {
//     try {
//       let res = await Usermenu();
//       console.log(res);
//       setAdminData(res.Data);
//       setuserDistrict(res?.Data?.District);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     GetInitialData();
//   }, []);

//   useEffect(() => {
//     if (AdminData?.Department_Name) {
//       FetchData(); // only run once AdminData is ready
//     }
//   }, [AdminData?.Department_Name]);

//   const GetInitialData = async () => {
//     await GetAdminData();
//     await GetTotalAmountAvailableInBank();
//   };
//   // const HandleYearClick = (year) => {
//   //   setSelectedBills([]);
//   //   setSelectAll(false);
//   //   setCurrentPage(1);

//   //   setData((prev) => ({
//   //     ...prev,
//   //     ProjectID: "",
//   //   }));

//   //   const latest = ALLtableDataRef.current;

//   //   console.log("ALLtableData at year click:", latest.length);
//   //   console.log("Selected Division:", selectedDivision);
//   //   console.log("Selected District:", selectedDistrict);
//   //   console.log("Clicked Administrative Year:", year);

//   //   const selectedYear = String(year).trim();

//   //   const filtered = latest.filter((item) => {
//   //     const divisionMatch =
//   //       !selectedDivision || item.Division === selectedDivision;

//   //     const districtMatch =
//   //       !selectedDistrict ||
//   //       item.District === selectedDistrict ||
//   //       item.District?.startsWith(`${selectedDistrict}-`);

//   //     const itemYear = String(
//   //       item.AdministrativeYear || item.ProposalYear || item.Year || "",
//   //     ).trim();

//   //     return divisionMatch && districtMatch && itemYear === selectedYear;
//   //   });

//   //   console.log("Filtered Year Bills:", filtered.length);

//   //   setselectedProposalYear(selectedYear);

//   //   setDistrictData(filtered);
//   //   setTableData(filtered);

//   //   setShowDistrictSummary(false);

//   //   // Show bill details
//   //   setShowSpecific(0);
//   // };

//   const HandleDistrictClick = (district) => {
//     setSelectedBills([]);
//     setSelectAll(false);
//     setCurrentPage(1);
//     setData((prev) => ({ ...prev, ProjectID: "" }));

//     const latest = ALLtableDataRef.current;

//     console.log("ALLtableData at district click:", latest.length);
//     console.log("Selected Division:", selectedDivision);
//     console.log("Clicked District:", district);

//     const filtered = latest.filter((item) => {
//     const districtMatch =
//       item.District === district ||
//       item.District?.startsWith(`${district}-`);

//           // return districtMatch && inDateRange(item);
//                     return districtMatch && passesBase(item);
//   });

  
//     console.log("Filtered District Bills:", filtered.length);

//     setSelectedDistrict(district);
//     setselectedProposalYear("");

//     // District details data
//     setDistrictData(filtered);
//     setTableData(filtered);

//     setShowDistrictSummary(false);

//     // Show selected district details
//     setShowSpecific(5);

//     console.log("filtered district wise: ", filtered);
//   };
// const normalizeYear = (value) =>
//   String(value ?? "")
//     .trim()
//     .replace(/\s+/g, "")
//     .replace(/–/g, "-")
//     .replace(/—/g, "-");
// const HandleYearClick = (year) => {
//   setSelectedBills([]);
//   setSelectAll(false);
//   setCurrentPage(1);

//   setData((prev) => ({
//     ...prev,
//     ProjectID: "",
//   }));

//   const latest = ALLtableDataRef.current;

//   console.log("ALLtableData at year click:", latest.length);
//   console.log("Selected Division:", selectedDivision);
//   console.log("Selected District:", selectedDistrict);
//   console.log("Clicked Administrative Year:", year);
// console.log("ALLtableDataRef", ALLtableDataRef);
//   const selectedYear = normalizeYear(year);

//   const filtered = latest.filter((item) => {
//     const itemDivision = String(item.Division ?? "").trim();
//     const itemDistrict = String(item.District ?? "").trim();

//     const itemYear = normalizeYear(
//       item.AdministrativeYear ||
//       item.ProposalYear ||
//       item.Year
//     );

//     const divisionMatch =
//       !selectedDivision ||
//       itemDivision === String(selectedDivision).trim();

//     const selectedDistrictValue =
//       String(selectedDistrict ?? "").trim();

//     const districtMatch =
//       !selectedDistrict ||
//       itemDistrict === selectedDistrictValue ||
//       itemDistrict.startsWith(`${selectedDistrictValue}-`);

//     const yearMatch = itemYear === selectedYear;

//     console.log("FILTER CHECK:", {
//       itemDivision,
//       selectedDivision,
//       divisionMatch,

//       itemDistrict,
//       selectedDistrict,
//       districtMatch,

//       itemYear,
//       selectedYear,
//       yearMatch,

//       item,
//     });

//     // return (
//     //   districtMatch &&
//     //   yearMatch &&
//     //   divisionMatch &&
//     //    inDateRange(item)  
//     // );
//         return districtMatch && yearMatch && passesBase(item);
//   });

//   console.log("Filtered Year Bills:", filtered.length);
//   console.log("after year click data ....", filtered);

//   setselectedProposalYear(selectedYear);
//   setDistrictData(filtered);
//   setTableData(filtered);

//   setShowDistrictSummary(false);
//   setShowSpecific(0);
// };
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // const handleCheckboxChange = (id) => {

//   //   setSelectedBills((prevSelected) =>
//   //     prevSelected.includes(id)
//   //       ? prevSelected.filter((ProjectID) => ProjectID !== id) // Remove if already selected
//   //       : [...prevSelected, id] // Add if not selected

//   //   );
//   // };

//   //   const handleCheckboxChange = (id) => {
//   //     const bill = tableData.find(b => b.DemandGenerationID === id);
//   //     const amount = Number(bill.BillAmount);
//   // if (
//   //   AdminData.Department_Name === "State" &&
//   //   (AdminData.RoleID !== 24)&&
//   //   !uploadedFiles[id]
//   // ) {
//   //   alert("Please Upload Order file first!");
//   //   return;
//   // }
//   //     setSelectedBills((prevSelected) => {
//   //       let updated;
//   //       if (prevSelected.includes(id)) {
//   //         updated = prevSelected.filter((item) => item !== id);
//   //         setData(prev => ({
//   //           ...prev,
//   //           SelectedDemandAmount: prev.SelectedDemandAmount - amount
//   //         }));
//   //       } else {
//   //         updated = [...prevSelected, id];
//   //         setData(prev => ({
//   //           ...prev,
//   //           SelectedDemandAmount: prev.SelectedDemandAmount + amount
//   //         }));
//   //       }
//   //       return updated;
//   //     });
//   //   };
//   const handleCheckboxChange = (id) => {
//     const bill = tableData.find((b) => b.DemandGenerationID === id);

//     const amount = Number(bill.BillAmount);

//     // Upload Work validation
//     // if (
//     //   AdminData.Department_Name === "State" &&
//     //   AdminData.RoleID != 24 &&
//     //   !uploadedFiles[id]
//     // ) {
//     //   alert("Please upload work file first!");
//     //   return;
//     // }

//     setSelectedBills((prevSelected) => {
//       // Existing selected bill objects
//       const selectedBillObjects = tableData.filter((b) =>
//         prevSelected.includes(b.DemandGenerationID),
//       );

//       // District validation
//       if (prevSelected.length > 0 && !prevSelected.includes(id)) {
//         const firstDistrict = selectedBillObjects[0]?.District;

//         if (firstDistrict !== bill.District) {
//           alert("You can select bills from the same district only!");
//           return prevSelected;
//         }
//       }

//       let updated;

//       if (prevSelected.includes(id)) {
//         updated = prevSelected.filter((item) => item !== id);

//         setData((prev) => ({
//           ...prev,
//           SelectedDemandAmount: prev.SelectedDemandAmount - amount,
//         }));
//       } else {
//         updated = [...prevSelected, id];

//         setData((prev) => ({
//           ...prev,
//           SelectedDemandAmount: prev.SelectedDemandAmount + amount,
//         }));
//       }

//       return updated;
//     });
//   };
//   console.log("selectedbills", selectedBills);

//   // const approveSelected = async () => {
//   //   if (selectedBills.length === 0) {
//   //     alert('No bills selected for approval!');
//   //     return;
//   //   }
//   //   console.log(selectedBills);
//   //   setLoading(true); // Start loader
//   //   try {
//   //     let response = await ApproveBills(selectedBills, Etoken); // Call backend function
//   //     if (response.message) {
//   //       alert(response.message);
//   //       window.location.reload()
//   //       FetchData(); // Refresh the list after approval
//   //     }
//   //     if (response.error) {
//   //       alert(response.error)
//   //       window.location.reload()
//   //       FetchData(); // Refresh the list after approval
//   //     }
//   //   } catch (error) {
//   //     console.error('Error approving bills:', error);
//   //     alert('An error occurred while approving bills.');
//   //     window.location.reload()
//   //   }
//   //   setLoading(false); // Stop loader
//   // };

//   const approveSelected = async () => {
//     if (selectedBills.length === 0) {
//       alert("No bills selected for approval!");
//       return;
//     }
//     if (AdminData.RoleID == 25 || AdminData.RoleID == 40) {
//       const missingFiles = selectedBills.filter((id) => !uploadedFiles[id]);

//       if (missingFiles.length > 0) {
//         alert("Please upload Fund Release Order file for all selected bills!");
//         return;
//       }
//     }
//     // Defensive numeric parse (treat invalid/missing as 0)
//     const available = Number(TotalPaidCount) || 0;
//     const selectedDemand = Number(data?.SelectedDemandAmount) || 0;

//     // if (available < selectedDemand) {
//     //   alert(
//     //     "Insufficient Available Release Amount. Approval requires Available Release Amount >= Selected Demand Amount.",
//     //   );
//     //   return;
//     // }

//     console.log(selectedBills);
//     setLoading(true); // Start loader
//     // try {
//     //   let response = await ApproveBills(selectedBills, Etoken); // Call backend function
//     //   if (response.message) {
//     //     alert(response.message);
//     //     // refresh
//     //     FetchData();
//     //     window.location.reload();
//     //   } else if (response.error) {
//     //     alert(response.error);
//     //     FetchData();
//     //     window.location.reload();
//     //   }
//     // }
//     try {
//       const formData = new FormData();

//       formData.append("selectedBills", JSON.stringify(selectedBills));

//       Object.keys(uploadedFiles).forEach((billId) => {
//         formData.append(`uploadOrder_${billId}`, uploadedFiles[billId]);
//       });

//       // await ApproveBills(formData, Etoken);
//       let response = await ApproveBills(formData, Etoken);

//       if (response.message) {
//         alert(response.message);

//         FetchData();
//         window.location.reload();
//       } else if (response.error) {
//         alert(response.error);

//         FetchData();
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error("Error approving bills:", error);
//       alert("An error occurred while approving bills.");
//       window.location.reload();
//     } finally {
//       setLoading(false); // Stop loader
//     }
//   };
//   const GetTotalAmountAvailableInBank = async () => {
//     let data = await GetTotalAmountAvailbaleInBank();
//     console.log(data);
//     setBankBalance(data[0]);
//     // setCountBalance(data.result1[0])
//   };
//   let TotalPaidCount = BankBalance.AvailableBalanceinBank;
//   console.log(BankBalance);

//   const FetchDemandApprovalData = async (e) => {
//     e.preventDefault();
//     const { ProjectID } = data;
//     console.log(ProjectID);

//     if (!ProjectID) {
//       alert("Required all field priject id and piu name");
//       return;
//     }

//     try {
//       let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
//       console.log(res1);

//       let result = res1;
//       let ans = result.filter((item) => item.ProjectID == ProjectID);

//       // setTableData(ans);

//       console.log(ans);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const TotalAmount = () => {
//     const totalAvaiablereleaseAmount = tableData.reduce(
//       (acc, item) => acc + Number(item.BillAmount),
//       0,
//     );

//     setData((prev) => ({
//       ...prev,
//       AvaiableReleaseAmount: totalAvaiablereleaseAmount,
//     }));
//   };

//   useEffect(() => {
//     TotalAmount();
//   }, [tableData]);

//   const TotalSelectedDemandAmount = (amount) => {
//     setData((prev) => ({
//       ...prev,
//       SelectedDemandAmount:
//         Number(prev.SelectedDemandAmount || 0) + Number(amount),
//     }));
//   };

//   // const handleSelectAllChange = (e) => {
//   //   const checked = e.target.checked;
//   //   setSelectAll(checked);

//   //   if (checked) {
//   //     const allIds = tableData.map((item) => item.DemandGenerationID);
//   //     setSelectedBills(allIds);

//   //     // Total of all selected bill amounts
//   //     const totalAmount = tableData.reduce((acc, item) => acc + Number(item.BillAmount), 0);
//   //     setData((prev) => ({
//   //       ...prev,
//   //       SelectedDemandAmount: totalAmount
//   //     }));
//   //   } else {
//   //     setSelectedBills([]);
//   //     setData((prev) => ({
//   //       ...prev,
//   //       SelectedDemandAmount: 0
//   //     }));
//   //   }
//   // };

//   // const handleSelectAllChange = (e) => {
//   //   const checked = e.target.checked;
//   //   setSelectAll(checked);

//   //   const currentPageBillIDs = currentBills.map((item) => item.DemandGenerationID);

//   //   if (checked) {
//   //     // Add all currentBills if not already selected
//   //     const newSelected = [...new Set([...selectedBills, ...currentPageBillIDs])];
//   //     setSelectedBills(newSelected);

//   //     // Add only those current page bills that were not already selected
//   //     const newlyAdded = currentBills.filter(bill => !selectedBills.includes(bill.DemandGenerationID));
//   //     const newAmount = newlyAdded.reduce((acc, item) => acc + Number(item.BillAmount), 0);

//   //     setData((prev) => ({
//   //       ...prev,
//   //       SelectedDemandAmount: prev.SelectedDemandAmount + newAmount
//   //     }));
//   //   } else {
//   //     // Remove only current page bills from selection
//   //     const remainingSelected = selectedBills.filter(id => !currentPageBillIDs.includes(id));
//   //     setSelectedBills(remainingSelected);

//   //     const removedAmount = currentBills.reduce((acc, item) => acc + Number(item.BillAmount), 0);

//   //     setData((prev) => ({
//   //       ...prev,
//   //       SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount
//   //     }));
//   //   }
//   // };

//   const handleSelectAllChange = (e) => {
//     const checked = e.target.checked;

//     // ✅ State department logic
//     let validBills = currentBills;

//     // if (AdminData.Department_Name === "State" && AdminData.RoleID !== 24) {
//     //   validBills = currentBills.filter(
//     //     (item) => uploadedFiles[item.DemandGenerationID],
//     //   );
//     // }

//     // ✅ Check same district before select all
//     // if (checked && validBills.length > 0) {
//     //   const districtSet = new Set(validBills.map((item) => item.District));

//     //   if (districtSet.size > 1) {
//     //     alert("Please select bills from same district only!");
//     //     return;
//     //   }
//     // }

//     const validBillIDs = validBills.map((item) => item.DemandGenerationID);

//     setSelectAll(checked);

//     if (checked) {
//       const newSelected = [...new Set([...selectedBills, ...validBillIDs])];

//       setSelectedBills(newSelected);

//       const newlyAdded = validBills.filter(
//         (bill) => !selectedBills.includes(bill.DemandGenerationID),
//       );

//       const newAmount = newlyAdded.reduce(
//         (acc, item) => acc + Number(item.BillAmount),
//         0,
//       );

//       setData((prev) => ({
//         ...prev,
//         SelectedDemandAmount: prev.SelectedDemandAmount + newAmount,
//       }));

//       // optional alert only for State
//       // if (
//       //   AdminData.Department_Name === "State" &&
//       //   AdminData.RoleID !== 24 &&
//       //   validBills.length !== currentBills.length
//       // ) {
//       //   alert("Some bills were skipped because Upload Order file is missing.");
//       // }
//     } else {
//       const remainingSelected = selectedBills.filter(
//         (id) => !validBillIDs.includes(id),
//       );

//       setSelectedBills(remainingSelected);

//       const removedAmount = validBills.reduce(
//         (acc, item) => acc + Number(item.BillAmount),
//         0,
//       );

//       setData((prev) => ({
//         ...prev,
//         SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount,
//       }));
//     }
//   };
//   useEffect(() => {
//     if (data.ProjectID) {
//       if (data.ProjectID == "All") {
//         let res = ALLtableData;
//         setTableData(res);
//       } else {
//         let res = ALLtableData.filter(
//           (item) => item.ProjectID === data.ProjectID,
//         );
//         setTableData(res);
//       }
//     }
//   }, [data.ProjectID]);

//   const inMyStage = (item) => {
//   if (item.Approvance7 === undefined) {
//     console.warn("Approvance7 missing in bill data: add it to the backend SELECT");
//     return true;
//   }
//   if (item.Status !== "false") return false;

//   const role = Number(AdminData?.RoleID);
//   if (role === 25 || role === 40) {
//     return item.Approvance7 === "true" && item.Approvance8 === "false";
//   }
//   if (role === 24 || role === 41) {
//     return item.Approvance8 === "true" && item.Approvance9 === "false";
//   }
//   return true;
// };

//   // Derived — no extra API call needed
//   // District rows: Checker / SO counts come from the same bill list as the Year Summary
//   const districtSummaryView = React.useMemo(() => {
//     if (!ALLtableData.length) return districtSummary;

//     const isChecker = AdminData?.Role === "RDD Checker(ASO)";
//     const isSO = AdminData?.Role === "RDD Section Officer";

//     return districtSummary.map((row) => {
//       const bills = ALLtableData.filter(
//         (item) =>
//           (item.District === row.District ||
//             item.District?.startsWith(`${row.District}-`)) &&
//           passesBase(item),
//       );
//       const count = bills.length;
//       const amount = bills.reduce((s, b) => s + Number(b.BillAmount || 0), 0);

//       if (isChecker)
//         return { ...row, RDDCheckerCount: count, RDDCheckerAmount: amount };
//       if (isSO) return { ...row, RDDSOCount: count, RDDSOAmount: amount };
//       return row;
//     });
//   }, [
//     districtSummary,
//     ALLtableData,
//     AdminData?.Role,
//     AdminData?.RoleID,
//     fromDate1,
//     toDate1,
//   ]);

//   const filteredDistricts = districtSummaryView.filter(
//     (d) => d.Division === selectedDivision,
//   );

//   // Division totals built from the district rows above
//   const divisionSummary = React.useMemo(() => {
//     const map = {};
//     districtSummaryView.forEach((item) => {
//       const div = item.Division || "Unknown";
//       if (!map[div]) {
//         map[div] = {
//           Division: div,
//           TotalPendingCount: 0,
//           TotalPendingAmount: 0,
//           RDDCheckerCount: 0,
//           RDDCheckerAmount: 0,
//           RDDSOCount: 0,
//           RDDSOAmount: 0,
//         };
//       }
//       map[div].TotalPendingCount += Number(item.TotalPendingCount || 0);
//       map[div].TotalPendingAmount += Number(item.TotalPendingAmount || 0);
//       map[div].RDDCheckerCount += Number(item.RDDCheckerCount || 0);
//       map[div].RDDCheckerAmount += Number(item.RDDCheckerAmount || 0);
//       map[div].RDDSOCount += Number(item.RDDSOCount || 0);
//       map[div].RDDSOAmount += Number(item.RDDSOAmount || 0);
//     });

//     return Object.values(map).sort(
//       (a, b) => getDivisionRank(a.Division) - getDivisionRank(b.Division),
//     );
//   }, [districtSummaryView]);

//   const DemandDeductionDetailByBillID = async (ID) => {
//     try {
//       let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
//       setfetchSpecficDemandDeductionDetail(res);
//       setSelectedDemandID(ID);
//       setShowSpecific(2);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     const currentPageIDs = currentBills.map((bill) => bill.DemandGenerationID);
//     const allSelected = currentPageIDs.every((id) =>
//       selectedBills.includes(id),
//     );
//     setSelectAll(allSelected);
//   }, [currentBills, selectedBills]);

//   console.log("selectedBills", selectedBills);
//   const allSelectedBillsHaveFiles =
//     selectedBills.length > 0 &&
//     currentBills
//       .filter((bill) => selectedBills.includes(bill.DemandGenerationID))
//       .every((bill) => uploadedFiles[bill.DemandGenerationID]);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const [progressImages, setProgressImages] = useState([]);
//   const [progressData, setProgressData] = useState([]);

//   console.log("progressData: ", progressData);

//   // const openProgressModal = (images) => {
//   //   try {
//   //     let parsedImages = [];

//   //     // First parse
//   //     const firstParse = JSON.parse(images || "[]");

//   //     // Second parse because your data is nested stringified array
//   //     parsedImages = firstParse.flatMap((item) => {
//   //       try {
//   //         return JSON.parse(item);
//   //       } catch {
//   //         return [];
//   //       }
//   //     });

//   //     setProgressImages(parsedImages);
//   //     setShowProgressModal(true);
//   //   } catch (err) {
//   //     console.log("Image Parse Error:", err);
//   //     setProgressImages([]);
//   //   }
//   // };

//   const openProgressModal = (images, location) => {
//     try {
//       const parsedImages = JSON.parse(images || "[]");
//       const parsedLocations = JSON.parse(location || "[]");

//       let imageArray = [];

//       parsedImages.forEach((img) => {
//         try {
//           const nested = JSON.parse(img);

//           if (Array.isArray(nested)) {
//             imageArray.push(...nested);
//           } else {
//             imageArray.push(img);
//           }
//         } catch {
//           imageArray.push(img);
//         }
//       });

//       const combinedData = imageArray.map((image, index) => {
//         let locationObj = {};

//         try {
//           locationObj = JSON.parse(parsedLocations[index] || "{}");
//         } catch (err) {
//           console.log(err);
//         }

//         return {
//           image,
//           location: locationObj,
//         };
//       });

//       console.log("combinedData", combinedData);

//       setProgressData(combinedData);
//       setShowProgressModal(true);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   //-->old code
//   // const openProgressModal = (images, location) => {
//   //   console.log("images: ", images);
//   //   console.log("location: ", location);
//   //   try {
//   //     const parsedImages = JSON.parse(images || "[]");
//   //     const parsedLocations = JSON.parse(location || "[]");

//   //     const combinedData = parsedImages.map((img, index) => {
//   //       let imageName = img;

//   //       // Handle nested JSON array string
//   //       try {
//   //         const nestedImage = JSON.parse(img);
//   //         if (Array.isArray(nestedImage)) {
//   //           imageName = nestedImage[0];
//   //         }
//   //       } catch (e) {}

//   //       let locationObj = {};

//   //       try {
//   //         locationObj = JSON.parse(parsedLocations[index] || "{}");
//   //       } catch (e) {}

//   //       return {
//   //         image: imageName,
//   //         location: locationObj,
//   //       };
//   //     });

//   //     console.log("combinedData", combinedData);

//   //     setProgressData(combinedData);
//   //     setShowProgressModal(true);
//   //   } catch (err) {
//   //     console.log(err);
//   //   }
//   // };

//   const selectedBillDetails = tableData.filter((bill) =>
//     selectedBills.includes(bill.DemandGenerationID),
//   );

//   const selectedBillCount = selectedBillDetails.length;

//   const selectedBillAmount = selectedBillDetails.reduce(
//     (sum, bill) => sum + Number(bill.BillAmount || 0),
//     0,
//   );

//   useEffect(() => {
//     let filtered = [...ALLtableData];

//     if (approvedYear) {
//       filtered = filtered.filter(
//         (item) => String(item.WorkApprovedYear) === String(approvedYear),
//       );
//     }

//     if (data.ProjectID && data.ProjectID !== "All") {
//       filtered = filtered.filter(
//         (item) => item.MainWorkOrderID === data.ProjectID,
//       );
//     }

//     // if (data.ApprovedYear) {
//     //   filtered = filtered.filter(
//     //     (item) => String(item.AAYear) === String(data.ApprovedYear),
//     //   );
//     // }
//     if (selectedDistrict) {
//       filtered = filtered.filter(
//         (item) =>
//           item.District === selectedDistrict ||
//           item.District.startsWith(`${selectedDistrict}-`),
//       );
//     }
//     // if (selectedProposalYear) {
//     //   filtered = filtered.filter(
//     //     (item) => item.ProposalYear === selectedProposalYear,
//     //   );
//     // }
//     // if (selectedTaluka) {
//     //   filtered = filtered.filter(
//     //     (item) => (item.Taluka || item.ulb) === selectedTaluka,
//     //   );
//     // }

//     // if (selectedWorkType) {
//     //   filtered = filtered.filter(
//     //     (item) => item.typeOfWork || item.workType === selectedWorkType,
//     //   );
//     // }
//     if (selectedProposalYear) {
//       filtered = filtered.filter(
//         (item) =>
//           normalizeYear(item.AdministrativeYear || item.ProposalYear || item.Year) ===
//           selectedProposalYear,
//       );
//     }
//     if (selectedTaluka) {
//       filtered = filtered.filter(
//         (item) => (item.Taluka || item.ulb) === selectedTaluka,
//       );
//     }

//     if (selectedWorkType) {
//       filtered = filtered.filter(
//         (item) => (item.typeOfWork || item.workType) === selectedWorkType,
//       );
//     }
//     if (fromDate || toDate) {
//       filtered = filtered.filter((item) => {
//         if (!item.BillReceivedDate) return false;

//         // Convert ISO date properly
//         const uploadDate = new Date(item.BillReceivedDate);
//         uploadDate.setHours(0, 0, 0, 0);

//         const from = fromDate ? new Date(fromDate) : null;
//         const to = toDate ? new Date(toDate) : null;

//         if (from) from.setHours(0, 0, 0, 0);
//         if (to) to.setHours(23, 59, 59, 999);

//         if (from && to) {
//           return uploadDate >= from && uploadDate <= to;
//         }

//         if (from) {
//           return uploadDate >= from;
//         }

//         if (to) {
//           return uploadDate <= to;
//         }

//         return true;
//       });
//     }
//     // 🔹 Search Filter
//     if (searchTerm.trim()) {
//       const lower = searchTerm.toLowerCase();
//       filtered = filtered.filter((bill) =>
//         Object.values(bill).some((val) =>
//           String(val ?? "")
//             .toLowerCase()
//             .includes(lower),
//         ),
//       );
//     }

//     // date range chosen on Division screen
// // if (fromDate1 || toDate1) {
// //   filtered = filtered.filter((item) => inDateRange(item));
// // }
//     // date range + stage filter (State users only)
//     if (AdminData?.Department_Name === "State") {
//       filtered = filtered.filter(passesBase);
//     }

//     setTableData(filtered);
//     console.log("tabledata", tableData);

//     setCurrentPage(1);
//   }, [
//     data.ProjectID,
//     data.ApprovedYear,
//     ALLtableData,
//     fromDate,
//     toDate,
//       fromDate1,      // 👈 added
//       toDate1,        // 👈 added   
//     searchTerm,
//     approvedYear,
//     // selectedDistrict,
//     // selectedTaluka,
//     // selectedProposalYear,
//         selectedDistrict,
//     selectedTaluka,
//     selectedProposalYear,
//     selectedWorkType,
//     AdminData?.RoleID,
//     AdminData?.Department_Name,
//   ]);

//   // Unique work names scoped to the correct level, independent of current filters
//   const workNameOptions = React.useMemo(() => {
//     let scoped = [...ALLtableData];

//     if (approvedYear) {
//       scoped = scoped.filter(
//         (item) => String(item.WorkApprovedYear) === String(approvedYear),
//       );
//     }
//     if (selectedDistrict) {
//       scoped = scoped.filter(
//         (item) =>
//           item.District === selectedDistrict ||
//           item.District?.startsWith(`${selectedDistrict}-`),
//       );
//     }
//     if (selectedProposalYear) {
//       scoped = scoped.filter(
//         (item) => item.ProposalYear === selectedProposalYear,
//       );
//     }
//     if (selectedTaluka) {
//       scoped = scoped.filter(
//         (item) => (item.Taluka || item.ulb) === selectedTaluka,
//       );
//     }
//     if (selectedWorkType) {
//       scoped = scoped.filter(
//         (item) => (item.typeOfWork || item.workType) === selectedWorkType,
//       );
//     }

//     const seen = new Set();
//     return scoped.filter((item) => {
//       const key = item.MainWorkOrderID;
//       if (!key || seen.has(key)) return false;
//       seen.add(key);
//       return true;
//     });
//   }, [
//     ALLtableData,
//     approvedYear,
//     selectedDistrict,
//     selectedProposalYear,
//     selectedTaluka,
//     selectedWorkType,
//   ]);

//   const settingshowspecific3 = async (ID) => {
//     try {
//       let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
//       setfetchSpecficDemandDeductionDetail(res);
//       setSelectedDemandID(ID);
//       setShowSpecific(4);
//       let filtered = res;
//       console.log("filtered............", filtered);
//       filtered = filtered.filter((val) => val.DemandGenerationID == ID);
//       setselectedBillData(filtered[0]);
//       console.log("selected Bill ---> ", filtered[0]);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const exportBillSlipPDF = async () => {
//     if (!billSlipRef.current) {
//       alert("Bill slip not found");
//       return;
//     }

//     setExportingBillSlipPDF(true);

//     try {
//       const canvas = await html2canvas(billSlipRef.current, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//       });

//       const pdf = new jsPDF("p", "mm", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const margin = 5;
//       const maxImgWidth = pageWidth - margin * 2;
//       const maxImgHeight = pageHeight - margin * 2;
//       const widthRatio = maxImgWidth / canvas.width;
//       const heightRatio = maxImgHeight / canvas.height;
//       const ratio = Math.min(widthRatio, heightRatio);
//       const imgWidth = canvas.width * ratio;
//       const imgHeight = canvas.height * ratio;

//       pdf.addImage(
//         canvas.toDataURL("image/png"),
//         "PNG",
//         (pageWidth - imgWidth) / 2,
//         margin,
//         imgWidth,
//         imgHeight,
//       );

//       const transactionNo =
//         selectedBillData?.DemandGenerationID || selectedDemandID;
//       pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
//     } catch (error) {
//       console.error("Bill slip PDF export error:", error);
//       alert("Failed to export bill slip PDF. Please try again.");
//     } finally {
//       setExportingBillSlipPDF(false);
//     }
//   };

//   const BackFunction = () => {
//     setfetchSpecficDemandDeductionDetail([]);
//     setSelectedBills("");
//     setselectedBillData([]);
//     setShowSpecific(0);
//   };

//   const labelStyle = {
//     border: "1px solid #000",
//     padding: "6px",
//     width: "18%",
//     fontWeight: "bold",
//     background: "#f5f5f5",
//   };

//   const valueStyle = {
//     border: "1px solid #000",
//     padding: "6px",
//   };

//   const tableHead = {
//     border: "1px solid #000",
//     background: "#d9d9d9",
//     padding: "8px",
//     textAlign: "center",
//   };

//   const tableCell = {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "center",
//   };
//   const vendorData = fetchSpecificDemandDeductionDetail?.find(
//     (item) => item.TypeOfAmount === "Total Amount Payable",
//   );
//   const officerStyle = {
//     marginTop: "8px",
//     fontSize: "12px",
//     fontWeight: "bold",
//     textAlign: "center",
//   };

//   const officerMarathiStyle = {
//     fontSize: "11px",
//     textAlign: "center",
//     marginTop: "3px",
//   };
//   const footerTitleStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginTop: "8px",
//   };

//   const footerTitleTdStyle = {
//     border: "1px solid #555",
//     padding: "6px",
//     textAlign: "center",
//     fontSize: "12px",
//     fontWeight: "bold",
//   };

//   const remarksTableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//   };

//   const remarksTableTdStyle = {
//     border: "1px solid #555",
//     padding: "8px",
//     fontSize: "11px",
//     lineHeight: "18px",
//     textAlign: "right",
//   };

//   const instructionTableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginTop: "-1px",
//   };

//   const instructionTableTdStyle = {
//     border: "1px solid #555",
//     padding: "10px",
//     fontSize: "11px",
//     lineHeight: "18px",
//     textAlign: "justify",
//   };

//   const signatureTableStyle = {
//     width: "100%",
//     tableLayout: "fixed",
//     borderCollapse: "collapse",
//     marginTop: "-1px",
//   };

//   const signatureTableTdStyle = {
//     border: "1px solid #555",
//     height: "80px",
//     width: "50%",
//     verticalAlign: "bottom",
//     padding: "10px",
//   };

//   const signBoxStyle = {
//     width: "100%",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "flex-end",
//   };

//   const signSpaceStyle = {
//     height: "25px",
//   };

//   const signTitleStyle = {
//     fontSize: "12px",
//     fontWeight: "bold",
//     textAlign: "center",
//   };

//   const openRemarkModal = (action) => {
//     if (selectedBills.length === 0) {
//       alert("No bills selected!");
//       return;
//     }
//     setRemarkAction(action);
//     setRemarkText("");
//     setShowRemarkModal(true);
//   };

//   const submitRejectSendBack = async () => {
//     if (!remarkText.trim()) {
//       alert("Remark is required!");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await RejectOrSendBackBill(
//         selectedBills,
//         remarkText,
//         remarkAction,
//       );
//       if (response.message) {
//         alert(response.message);
//         setShowRemarkModal(false);
//         FetchData();
//         window.location.reload();
//       } else if (response.error) {
//         alert(response.error);
//       }
//     } catch (error) {
//       console.error("Reject/SendBack error:", error);
//       alert("An error occurred.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const exportTableByClassToExcel = async (
//     currentBills,
//     filename = "Bill_Inward.xlsx",
//   ) => {
//     if (!Array.isArray(currentBills) || currentBills.length === 0) {
//       alert("No data available");
//       return;
//     }
  
//     setLoading(true);
  
//     await new Promise((resolve) => setTimeout(resolve, 500));
  
//     try {
//       /* =====================================================
//          SELECTED RECORDS LOGIC
//          If selectedBills has records → export selected only
//          If nothing selected → export all records
//       ===================================================== */
  
//       const selectedIds = (selectedBills || []).map((id) => String(id));
  
//       const billsToDownload =
//         selectedIds.length > 0
//           ? currentBills.filter((bill) =>
//               selectedIds.includes(String(bill.DemandGenerationID)),
//             )
//           : currentBills;
  
//       if (!billsToDownload || billsToDownload.length === 0) {
//         alert("No selected records found to download.");
//         return;
//       }
  
//       /* =====================================================
//          TOTALS
//       ===================================================== */
  
//       let totalBillAmount = 0;
//       let totalNetPayableAmount = 0;
//       let totalDeductionAmount = 0;
  
//       const formatDate = (dateValue) => {
//         if (!dateValue) return "";
  
//         const date = new Date(dateValue);
  
//         if (isNaN(date.getTime())) return "";
  
//         return date.toLocaleDateString("en-IN");
//       };
  
//       const isStateFundRelease =
//         AdminData?.Department_Name === "State" &&
//         (Number(AdminData?.RoleID) === 24 ||
//           Number(AdminData?.RoleID) === 41);
  
//       /* =====================================================
//          CREATE EXCEL DATA
//       ===================================================== */
  
//       const excelData = billsToDownload.map((val, index) => {
//         const billAmount = Number(val.BillAmount || 0);
//         const netPayableAmount = Number(val.NetPayableAmount || 0);
//         const deductionAmount = Number(val.DeductionAmount || 0);
  
//         totalBillAmount += isNaN(billAmount) ? 0 : billAmount;
  
//         totalNetPayableAmount += isNaN(netPayableAmount)
//           ? 0
//           : netPayableAmount;
  
//         totalDeductionAmount += isNaN(deductionAmount)
//           ? 0
//           : deductionAmount;
  
//         const row = {
//           "Sr No.": index + 1,
  
//           "Demand ID": val.DemandGenerationID || "",
  
//           "Bill Creation Date": val.Date || "-",
  
//           "Bill Receive Date at RDD": val.BillReceivedDate || "-",
  
//           "Administrative Approval Year (A.A.Year)":
//             val.ProposalYear || "-",
  
//           "MHUID Number": val.MHUID_Number || "-",
  
//           "Work Name": val.MainWorkOrderID || "-",
  
//           Taluka: val.Taluka || val.ulb || "",
  
//           "Class Of Work": val.classOfWork || val.workClass || "",
  
//           "Type Of Work": val.typeOfWork || val.workType || "",
  
//           "Work Order Type":
//             val.WorkOrderType || val.workOrderType || "-",
  
//           "Bill Amount": isNaN(billAmount) ? 0 : billAmount,
  
//           "Net Payable Amount": isNaN(netPayableAmount)
//             ? 0
//             : netPayableAmount,
  
//           Deduction: isNaN(deductionAmount) ? 0 : deductionAmount,
  
//           "Administrative Approved GR Date": formatDate(
//             val.GRApproveDate || val.workApprovedGRDate,
//           ),
  
//           "Work Order Date": val.WorkOrderDate || "-",
  
//           "Physical Progress in Percentage":
//             val.physicalValueOfProgress != null
//               ? `${val.physicalValueOfProgress}%`
//               : "",
  
//           "Measurement Book": val.Measurement_Book || "-",
  
//           "SQM Inspection Report": val.Inspection_Report || "-",
  
//           "Work Completion Date": val.WorkEndDate || "-",
  
//           "Bill Copy": val.UploadBillCopy || "-",
  
//           "Vendor Name": val.ContractorName || "",
  
//           "Head Code": val.BudgetID || "",
//         };
  
//         // State Role 24/41 only
//         if (isStateFundRelease) {
//           row["Fund Release Order"] = val.uploadWork || "No File";
//         }
  
//         return row;
//       });
  
//       /* =====================================================
//          TOTAL ROW
//       ===================================================== */
  
//       const totalRow = {
//         "Sr No.": "",
  
//         "Demand ID": "",
  
//         "Bill Creation Date": "",
  
//         "Bill Receive Date at RDD": "",
  
//         "Administrative Approval Year (A.A.Year)": "",
  
//         "MHUID Number": "",
  
//         "Work Name": "",
  
//         Taluka: "",
  
//         "Class Of Work": "",
  
//         "Type Of Work": "",
  
//         "Work Order Type": "TOTAL",
  
//         "Bill Amount": totalBillAmount,
  
//         "Net Payable Amount": totalNetPayableAmount,
  
//         Deduction: totalDeductionAmount,
  
//         "Administrative Approved GR Date": "",
  
//         "Work Order Date": "",
  
//         "Physical Progress in Percentage": "",
  
//         "Measurement Book": "",
  
//         "SQM Inspection Report": "",
  
//         "Work Completion Date": "",
  
//         "Bill Copy": "",
  
//         "Vendor Name": "",
  
//         "Head Code": "",
//       };
  
//       if (isStateFundRelease) {
//         totalRow["Fund Release Order"] = "";
//       }
  
//       excelData.push(totalRow);
  
//       /* =====================================================
//          CREATE WORKSHEET
//       ===================================================== */
  
//       const worksheet = XLSX.utils.json_to_sheet(excelData);
  
//       /* =====================================================
//          COLUMN WIDTHS
//       ===================================================== */
  
//       const columnWidths = [
//         { wch: 8 },  // Sr No.
//         { wch: 18 }, // Demand ID
//         { wch: 20 }, // Bill Creation Date
//         { wch: 25 }, // Bill Receive Date
//         { wch: 25 }, // A.A. Year
//         { wch: 20 }, // MHUID
//         { wch: 35 }, // Work Name
//         { wch: 18 }, // Taluka
//         { wch: 20 }, // Class Of Work
//         { wch: 20 }, // Type Of Work
//         { wch: 20 }, // Work Order Type
//         { wch: 18 }, // Bill Amount
//         { wch: 22 }, // Net Payable
//         { wch: 18 }, // Deduction
//         { wch: 25 }, // GR Date
//         { wch: 20 }, // Work Order Date
//         { wch: 25 }, // Physical Progress
//         { wch: 35 }, // Measurement Book
//         { wch: 35 }, // Inspection Report
//         { wch: 25 }, // Work Completion Date
//         { wch: 35 }, // Bill Copy
//         { wch: 30 }, // Vendor
//         { wch: 25 }, // Head Code
//       ];
  
//       if (isStateFundRelease) {
//         columnWidths.push({ wch: 35 });
//       }
  
//       worksheet["!cols"] = columnWidths;
  
//       /* =====================================================
//          FREEZE HEADER
//       ===================================================== */
  
//       worksheet["!freeze"] = {
//         xSplit: 0,
//         ySplit: 1,
//       };
  
//       /* =====================================================
//          AUTOFILTER
//          Exclude TOTAL row
//       ===================================================== */
  
//       worksheet["!autofilter"] = {
//         ref: XLSX.utils.encode_range({
//           s: {
//             r: 0,
//             c: 0,
//           },
//           e: {
//             r: excelData.length - 2,
//             c: Object.keys(excelData[0]).length - 1,
//           },
//         }),
//       };
  
//       /* =====================================================
//          FORMAT AMOUNT COLUMNS
//       ===================================================== */
  
//       // Column positions based on current object order:
//       // K = Bill Amount
//       // L = Net Payable Amount
//       // M = Deduction
  
//       const billAmountColumn = 11;
//       const netPayableColumn = 12;
//       const deductionColumn = 13;
  
//       for (let row = 1; row <= excelData.length; row++) {
//         const billCell = worksheet[
//           XLSX.utils.encode_cell({
//             r: row,
//             c: billAmountColumn,
//           })
//         ];
  
//         const netCell = worksheet[
//           XLSX.utils.encode_cell({
//             r: row,
//             c: netPayableColumn,
//           })
//         ];
  
//         const deductionCell = worksheet[
//           XLSX.utils.encode_cell({
//             r: row,
//             c: deductionColumn,
//           })
//         ];
  
//         if (billCell) {
//           billCell.z = "#,##0.00";
//         }
  
//         if (netCell) {
//           netCell.z = "#,##0.00";
//         }
  
//         if (deductionCell) {
//           deductionCell.z = "#,##0.00";
//         }
//       }
  
//       /* =====================================================
//          CREATE WORKBOOK
//       ===================================================== */
  
//       const workbook = XLSX.utils.book_new();
  
//       XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         "Bill Inward",
//       );
  
//       XLSX.writeFile(workbook, filename);
  
//     } catch (error) {
//       console.error("Excel Export Error:", error);
//       alert("Error while exporting Excel file");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadTableOnlyAsPDF = async (
//     tableClass,
//     filename,
//     title,
//     chunkSize = 500,
//   ) => {
//     const originalTable = document.querySelector(`.${tableClass}`);
  
//     if (!originalTable) {
//       setExportingPDF(false);
//       alert("Table not found");
//       return;
//     }
  
//     setLoading(true);
//     setExportingPDF(true);
  
//     await new Promise((res) => setTimeout(res, 600));
  
//     try {
//       const selectedIds = (selectedBills || []).map((id) => String(id));
  
//       // Get all actual data rows
//       const allDataRows = Array.from(
//         originalTable.querySelectorAll("tbody tr[data-demand-id]")
//       );
  
//       // Selected records -> export selected
//       // Nothing selected -> export all
//       const rowsToDownload =
//         selectedIds.length > 0
//           ? allDataRows.filter((row) =>
//               selectedIds.includes(
//                 String(row.getAttribute("data-demand-id"))
//               )
//             )
//           : allDataRows;
  
//       const totalRows = rowsToDownload.length;
  
//       if (totalRows === 0) {
//         alert("No records found to download.");
//         return;
//       }
  
//       for (let start = 0; start < totalRows; start += chunkSize) {
//         const end = Math.min(start + chunkSize, totalRows);
  
//         // IDs for current chunk
//         const currentChunkIds = rowsToDownload
//           .slice(start, end)
//           .map((row) =>
//             String(row.getAttribute("data-demand-id"))
//           );
  
//         // Clone complete table
//         const table = originalTable.cloneNode(true);
  
//         // Remove rows not belonging to current chunk
//         const clonedDataRows = table.querySelectorAll(
//           "tbody tr[data-demand-id]"
//         );
  
//         clonedDataRows.forEach((row) => {
//           const demandId = String(
//             row.getAttribute("data-demand-id")
//           );
  
//           if (!currentChunkIds.includes(demandId)) {
//             row.remove();
//           }
//         });
  
//         // Remove Page Total / Gross Total / any other non-data rows
//         // already present in the live table (footer rows etc.)
//         table.querySelectorAll("tbody tr:not([data-demand-id])").forEach(
//           (row) => row.remove()
//         );
  
//         // =====================================================
//         // PDF ONLY: RESET SR. NO. FROM 1
//         // =====================================================
//         const pdfRows = table.querySelectorAll("tbody tr[data-demand-id]");
  
//         pdfRows.forEach((row, index) => {
//           const firstCell = row.querySelector("td");
  
//           if (firstCell) {
//             firstCell.textContent = start + index + 1;
//           }
//         });
  
//         // =====================================================
//         // ADD SINGLE TOTAL ROW AT BOTTOM OF CURRENT PDF CHUNK
//         // "Total" label under Type of Work column,
//         // summed amount under Amount column, everything else blank.
//         // =====================================================
  
//   // 👇 SET THESE TO MATCH YOUR ACTUAL <td> ORDER (0-based)
//   const TYPE_OF_WORK_COLUMN_INDEX = 10; // "Total" label goes here
//   const AMOUNT_COLUMN_INDEXES = [11, 12, 13]; // TODO: confirm your 3 real amount column indexes
  
//   // Sum each amount column separately
//   const chunkTotals = {}; // { 11: 5000, 12: 3000, 13: 1200 }
  
//   AMOUNT_COLUMN_INDEXES.forEach((colIndex) => {
//     chunkTotals[colIndex] = 0;
//   });
  
//   pdfRows.forEach((row) => {
//     const cells = row.querySelectorAll("td");
  
//     AMOUNT_COLUMN_INDEXES.forEach((colIndex) => {
//       if (cells[colIndex]) {
//         const value = cells[colIndex].innerText
//           .replace(/,/g, "")
//           .replace(/[₹\s]/g, "")
//           .trim();
  
//         const number = parseFloat(value);
  
//         if (!isNaN(number)) {
//           chunkTotals[colIndex] += number;
//         }
//       }
//     });
//   });
  
//   const totalRow = document.createElement("tr");
  
//   const totalCells =
//     table.querySelector("tbody tr[data-demand-id]")
//       ?.querySelectorAll("td").length || 1;
  
//   for (let i = 0; i < totalCells; i++) {
//     const td = document.createElement("td");
  
//     td.style.fontWeight = "bold";
//     td.style.border = "1px solid #000";
//     td.style.padding = "8px";
//     td.style.backgroundColor = "#f2f2f2";
  
//     if (i === TYPE_OF_WORK_COLUMN_INDEX) {
//       td.textContent = "Total";
//     } else if (AMOUNT_COLUMN_INDEXES.includes(i)) {
//       td.textContent = chunkTotals[i].toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       });
//     } else {
//       td.textContent = "";
//     }
  
//     totalRow.appendChild(td);
//   }
  
//   table.querySelector("tbody").appendChild(totalRow);
  
//         // =====================================================
//         // Create temporary PDF container
//         // =====================================================
//         const pdfContainer = document.createElement("div");
  
//         const tableWidth = originalTable.scrollWidth;
  
//         pdfContainer.style.position = "fixed";
//         pdfContainer.style.left = "-10000px";
//         pdfContainer.style.top = "0";
//         pdfContainer.style.width = `${tableWidth + 40}px`;
//         pdfContainer.style.minWidth = `${tableWidth + 40}px`;
//         pdfContainer.style.backgroundColor = "#ffffff";
//         pdfContainer.style.padding = "20px";
//         pdfContainer.style.boxSizing = "border-box";
//         pdfContainer.style.fontFamily =
//           "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";
  
//         table.style.width = `${tableWidth}px`;
//         table.style.minWidth = `${tableWidth}px`;
//         table.style.maxWidth = "none";
//         table.style.tableLayout = "auto";
  
//         // =====================================================
//         // Title
//         // =====================================================
//         const titleElement = document.createElement("div");
  
//         titleElement.innerText = `${title} (${start + 1} - ${end})`;
  
//         titleElement.style.textAlign = "center";
//         titleElement.style.fontSize = "28px";
//         titleElement.style.fontWeight = "bold";
//         titleElement.style.marginBottom = "20px";
//         titleElement.style.padding = "10px";
//         titleElement.style.color = "#000";
//         titleElement.style.fontFamily =
//           "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";
  
//         pdfContainer.appendChild(titleElement);
//         pdfContainer.appendChild(table);
  
//         document.body.appendChild(pdfContainer);
  
//         await new Promise((res) => setTimeout(res, 500));
  
//         // =====================================================
//         // A3 Landscape PDF
//         // =====================================================
//         const pdf = new jsPDF("l", "mm", "a3");
  
//         const pageWidth = pdf.internal.pageSize.getWidth();
//         const pageHeight = pdf.internal.pageSize.getHeight();
  
//         const sideMargin = 10;
//         const topMargin = 10;
//         const bottomMargin = 15;
  
//         const canvas = await html2canvas(pdfContainer, {
//           scale: 1.5,
//           useCORS: true,
//           backgroundColor: "#ffffff",
//           windowWidth: pdfContainer.scrollWidth,
//         });
  
//         const imgWidth = pageWidth - sideMargin * 2;
//         const pxToMm = imgWidth / canvas.width;
  
//         const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//         const usablePageHeightPx = usablePageHeightMm / pxToMm;
  
//         let renderedHeight = 0;
//         let pageNumber = 0;
  
//         while (renderedHeight < canvas.height) {
//           const sliceHeight = Math.min(
//             usablePageHeightPx,
//             canvas.height - renderedHeight
//           );
  
//           const pageCanvas = document.createElement("canvas");
//           const context = pageCanvas.getContext("2d");
  
//           pageCanvas.width = canvas.width;
//           pageCanvas.height = Math.ceil(sliceHeight);
  
//           context.drawImage(
//             canvas,
//             0,
//             renderedHeight,
//             canvas.width,
//             sliceHeight,
//             0,
//             0,
//             canvas.width,
//             sliceHeight
//           );
  
//           const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);
  
//           if (pageNumber > 0) {
//             pdf.addPage();
//           }
  
//           pdf.addImage(
//             imgData,
//             "JPEG",
//             sideMargin,
//             topMargin,
//             imgWidth,
//             sliceHeight * pxToMm
//           );
  
//           renderedHeight += sliceHeight;
//           pageNumber++;
//         }
  
//         // Save PDF
//         pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
  
//         // Remove temporary container
//         document.body.removeChild(pdfContainer);
  
//         await new Promise((res) => setTimeout(res, 300));
//       }
//     } catch (error) {
//       console.error("PDF Export Error:", error);
//       alert("Error while generating PDF.");
//     } finally {
//       setExportingPDF(false);
//       setLoading(false);
//     }
//   };

//   //--> old code
//   // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   //   const CHUNK_SIZE = 500;

//   //   const originalTable = document.querySelector(`.${tableClass}`);

//   //   if (!originalTable) {
//   //     setExportingPDF(false);
//   //     alert("Table not found");
//   //     return;
//   //   }

//   //   setLoading(true);
//   //   setExportingPDF(true);

//   //   await new Promise((res) => setTimeout(res, 400));

//   //   try {
//   //     const selectedIds = (selectedBills || []).map((id) => String(id));

//   //     // Get all actual data rows
//   //     const allDataRows = Array.from(
//   //       originalTable.querySelectorAll("tbody tr[data-demand-id]"),
//   //     );

//   //     // If user selected records → export selected records
//   //     // If user selected nothing → export all records
//   //     const rowsToDownload =
//   //       selectedIds.length > 0
//   //         ? allDataRows.filter((row) =>
//   //             selectedIds.includes(String(row.getAttribute("data-demand-id"))),
//   //           )
//   //         : allDataRows;

//   //     const totalRows = rowsToDownload.length;

//   //     if (totalRows === 0) {
//   //       alert("No records found to download.");
//   //       return;
//   //     }

//   //     for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
//   //       const end = Math.min(start + CHUNK_SIZE, totalRows);

//   //       // IDs of rows for current PDF chunk
//   //       const currentChunkIds = rowsToDownload
//   //         .slice(start, end)
//   //         .map((row) => String(row.getAttribute("data-demand-id")));

//   //       // Clone complete table
//   //       const table = originalTable.cloneNode(true);

//   //       // Remove rows that are not part of current chunk
//   //       const clonedDataRows = table.querySelectorAll(
//   //         "tbody tr[data-demand-id]",
//   //       );

//   //       clonedDataRows.forEach((row) => {
//   //         const demandId = String(row.getAttribute("data-demand-id"));

//   //         if (!currentChunkIds.includes(demandId)) {
//   //           row.remove();
//   //         }
//   //       });

//   //       // Remove Page Total / Gross Total rows
//   //       const allClonedRows = table.querySelectorAll("tbody tr");

//   //       allClonedRows.forEach((row) => {
//   //         if (!row.getAttribute("data-demand-id")) {
//   //           row.remove();
//   //         }
//   //       });

//   //       // Create temporary PDF container
//   //       const pdfContainer = document.createElement("div");

//   //       const tableWidth = originalTable.scrollWidth;

//   //       pdfContainer.style.position = "fixed";
//   //       pdfContainer.style.left = "-10000px";
//   //       pdfContainer.style.top = "0";
//   //       pdfContainer.style.width = `${tableWidth + 40}px`;
//   //       pdfContainer.style.minWidth = `${tableWidth + 40}px`;
//   //       pdfContainer.style.backgroundColor = "#ffffff";
//   //       pdfContainer.style.padding = "20px";
//   //       pdfContainer.style.boxSizing = "border-box";
//   //       pdfContainer.style.fontFamily =
//   //         "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";

//   //       table.style.width = `${tableWidth}px`;
//   //       table.style.minWidth = `${tableWidth}px`;
//   //       table.style.maxWidth = "none";
//   //       table.style.tableLayout = "auto";

//   //       // Marathi title
//   //       const titleElement = document.createElement("div");

//   //       titleElement.innerText = `${title} (${start + 1} - ${end})`;

//   //       titleElement.style.textAlign = "center";
//   //       titleElement.style.fontSize = "28px";
//   //       titleElement.style.fontWeight = "bold";
//   //       titleElement.style.marginBottom = "20px";
//   //       titleElement.style.padding = "10px";
//   //       titleElement.style.color = "#000";
//   //       titleElement.style.fontFamily =
//   //         "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif";

//   //       pdfContainer.appendChild(titleElement);
//   //       pdfContainer.appendChild(table);

//   //       document.body.appendChild(pdfContainer);

//   //       await new Promise((res) => setTimeout(res, 500));

//   //       // A3 Landscape for all columns
//   //       const pdf = new jsPDF("l", "mm", "a3");

//   //       const pageWidth = pdf.internal.pageSize.getWidth();
//   //       const pageHeight = pdf.internal.pageSize.getHeight();

//   //       const sideMargin = 10;
//   //       const topMargin = 10;
//   //       const bottomMargin = 15;

//   //       const canvas = await html2canvas(pdfContainer, {
//   //         scale: 1.5,
//   //         useCORS: true,
//   //         backgroundColor: "#ffffff",
//   //         windowWidth: pdfContainer.scrollWidth,
//   //       });

//   //       const imgWidth = pageWidth - sideMargin * 2;
//   //       const pxToMm = imgWidth / canvas.width;

//   //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;

//   //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

//   //       let renderedHeight = 0;
//   //       let pageNumber = 0;

//   //       while (renderedHeight < canvas.height) {
//   //         const sliceHeight = Math.min(
//   //           usablePageHeightPx,
//   //           canvas.height - renderedHeight,
//   //         );

//   //         const pageCanvas = document.createElement("canvas");
//   //         const context = pageCanvas.getContext("2d");

//   //         pageCanvas.width = canvas.width;
//   //         pageCanvas.height = Math.ceil(sliceHeight);

//   //         context.drawImage(
//   //           canvas,
//   //           0,
//   //           renderedHeight,
//   //           canvas.width,
//   //           sliceHeight,
//   //           0,
//   //           0,
//   //           canvas.width,
//   //           sliceHeight,
//   //         );

//   //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

//   //         if (pageNumber > 0) {
//   //           pdf.addPage();
//   //         }

//   //         pdf.addImage(
//   //           imgData,
//   //           "JPEG",
//   //           sideMargin,
//   //           topMargin,
//   //           imgWidth,
//   //           sliceHeight * pxToMm,
//   //         );

//   //         renderedHeight += sliceHeight;
//   //         pageNumber++;
//   //       }

//   //       // Save file
//   //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

//   //       // Remove temporary container
//   //       document.body.removeChild(pdfContainer);

//   //       await new Promise((res) => setTimeout(res, 300));
//   //     }
//   //   } catch (error) {
//   //     console.error("PDF Export Error:", error);
//   //     alert("Error while generating PDF.");
//   //   } finally {
//   //     setExportingPDF(false);
//   //     setLoading(false);
//   //   }
//   // };

//   const formatFileName = (file) => {
//     if (!file) return "";

//     const dotIndex = file.lastIndexOf(".");
//     const extension = dotIndex !== -1 ? file.substring(dotIndex) : "";
//     const lastThree =
//       dotIndex !== -1 ? file.substring(dotIndex - 4, dotIndex) : "";

//     return `${file.substring(0, 10)}........${lastThree}${extension}`;
//   };
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (!progressData?.length) return;

//       if (e.key === "ArrowRight") {
//         setSelectedImageIndex(
//           (prevIndex) => (prevIndex + 1) % progressData.length,
//         );
//       }

//       if (e.key === "ArrowLeft") {
//         setSelectedImageIndex(
//           (prevIndex) =>
//             (prevIndex - 1 + progressData.length) % progressData.length,
//         );
//       }

//       // Optional: close image/modal with Escape
//       // if (e.key === "Escape") {
//       //   setSelectedImageIndex(null);
//       // }
//     };

//     window.addEventListener("keydown", handleKeyDown);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [progressData]);

  
//   const refreshStateSummary = async () => {
//   try {
//     const summaryRes = await GetStateBillSummary(fromDate1, toDate1);
//     if (summaryRes?.status) {
//       setDistrictSummary(summaryRes.message);
//     }
//   } catch (err) {
//     console.log(err);
//   }
// };

// useEffect(() => {
//   if (AdminData?.Department_Name === "State") {
//     refreshStateSummary();
//     // GetDemandApproval(fromDate1, toDate1).then((res) => {
//     //   if (Array.isArray(res)) {
//     //     const seen = new Set();
//     //     setALLTableData(
//     //       res.filter((r) => !seen.has(r.DemandGenerationID) && seen.add(r.DemandGenerationID)),
//     //     );
//     //   }
//     // });
//   }
// }, [fromDate1, toDate1,selectedDistrict]);

// function inDateRange(item) {
//   if (!fromDate1 && !toDate1) return true;
//   if (!item.BillReceivedDate) return false;

//   const d = new Date(item.BillReceivedDate);
//   d.setHours(0, 0, 0, 0);

//   if (fromDate1) {
//     const from = new Date(fromDate1);
//     from.setHours(0, 0, 0, 0);
//     if (d < from) return false;
//   }
//   if (toDate1) {
//     const to = new Date(toDate1);
//     to.setHours(23, 59, 59, 999);
//     if (d > to) return false;
//   }
//   return true;
// };
// // Same stage rule as the backend summary query


// // const passesBase = (item) => inDateRange(item) && inMyStage(item);
// function passesBase(item) {
//   return inDateRange(item) && inMyStage(item);
// }
//   return (
//     <>
//       {/* DIVISION TABLE */}
//       {showspecific === 1 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               padding: "10px 4rem",
//             }}
//           >
//             <h4
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 margin: 0,
//               }}
//             >
//               <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
//               {t("Bill Inwards")}
//             </h4>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" , marginLeft:"10px"}}>
//     <div className="input-group" style={{ width: "190px" }}>
//       <span className="input-group-text">{t("From")}</span>
//       <input
//         type="date"
//         className="form-control"
//         value={fromDate1}
//         max={toDate1 || undefined}
//         onChange={(e) => setFromDate1(e.target.value)}
//       />
//     </div>

//     <div className="input-group" style={{ width: "190px" }}>
//       <span className="input-group-text">{t("To")}</span>
//       <input
//         type="date"
//         className="form-control"
//         value={toDate1}
//         min={fromDate1 || undefined}
//         onChange={(e) => setToDate1(e.target.value)}
//       />
//     </div>
//   </div>
//           </div>

//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               backgroundColor: "white",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//               fontFamily: "sans-serif",
//             }}
//           >
//             <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
//               {t("Division Summary")}
//             </h4>
       
//             <div
//               className="col-12 tableContainer2"
//               style={{ overflowX: "scroll" }}
//             >
//               <table
//                 className="col-12"
//                 style={{
//                   textAlign: "center",
//                   width: "100%",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "#1565c0",
//                       color: "white",
//                       fontSize: "11px",
//                     }}
//                   >
//                     <th
//                       rowSpan="2"
//                       style={{
//                         padding: "8px",
//                         minWidth: "60px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Sr No")}
//                     </th>
//                     <th
//                       rowSpan="2"
//                       style={{
//                         padding: "8px",
//                         minWidth: "150px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Division")}
//                     </th>
//                     <th
//                       colSpan="2"
//                       style={{
//                         padding: "8px",
//                         minWidth: "260px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Total Pending Bill at ZP Level")}
//                     </th>
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <th
//                         colSpan="2"
//                         style={{
//                           padding: "8px",
//                           minWidth: "260px",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {t("RDD Checker(ASO)")}
//                       </th>
//                     )}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <th
//                         colSpan="2"
//                         style={{
//                           padding: "8px",
//                           minWidth: "260px",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {t("RDD Section Officer")}
//                       </th>
//                     )}
//                   </tr>
//                   <tr
//                     style={{
//                       backgroundColor: "#1976d2",
//                       color: "white",
//                       fontSize: "11px",
//                     }}
//                   >
//                     <th
//                       style={{
//                         padding: "8px",
//                         minWidth: "130px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Count")}
//                     </th>
//                     <th
//                       style={{
//                         padding: "8px",
//                         minWidth: "130px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Amount")}
//                     </th>
//                     {(AdminData?.Role === "RDD Checker(ASO)" ||
//                       AdminData?.Role === "RDD Section Officer") && (
//                       <>
//                         <th
//                           style={{
//                             padding: "8px",
//                             minWidth: "130px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Count")}
//                         </th>
//                         <th
//                           style={{
//                             padding: "8px",
//                             minWidth: "130px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Amount")}
//                         </th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {divisionSummary.length > 0 ? (
//                     divisionSummary.map((item, index) => (
//                       <tr
//                         key={index}
//                         style={{
//                           fontSize: "10px",
//                           backgroundColor:
//                             index % 2 === 0 ? "#f9f9f9" : "white",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#e3f2fd")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.backgroundColor =
//                             index % 2 === 0 ? "#f9f9f9" : "white")
//                         }
//                         onClick={() => HandleDivisionClick(item.Division)}
//                       >
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {index + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             color: "#1976d2",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t(item.Division)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {item.TotalPendingCount}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {Number(item.TotalPendingAmount).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {item.RDDCheckerCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(item.RDDCheckerAmount).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {item.RDDSOCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(item.RDDSOAmount).toLocaleString("en-IN")}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={6}
//                         style={{ padding: "20px", fontWeight: "bold" }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>

//                 <tfoot>
//                   {(() => {
//                     const total = divisionSummary.reduce(
//                       (acc, item) => ({
//                         TotalPendingCount:
//                           acc.TotalPendingCount +
//                           Number(item.TotalPendingCount || 0),
//                         TotalPendingAmount:
//                           acc.TotalPendingAmount +
//                           Number(item.TotalPendingAmount || 0),
//                         RDDCheckerCount:
//                           acc.RDDCheckerCount +
//                           Number(item.RDDCheckerCount || 0),
//                         RDDCheckerAmount:
//                           acc.RDDCheckerAmount +
//                           Number(item.RDDCheckerAmount || 0),
//                         RDDSOCount:
//                           acc.RDDSOCount + Number(item.RDDSOCount || 0),
//                         RDDSOAmount:
//                           acc.RDDSOAmount + Number(item.RDDSOAmount || 0),
//                       }),
//                       {
//                         TotalPendingCount: 0,
//                         TotalPendingAmount: 0,
//                         RDDCheckerCount: 0,
//                         RDDCheckerAmount: 0,
//                         RDDSOCount: 0,
//                         RDDSOAmount: 0,
//                       },
//                     );

//                     return (
//                       <tr
//                         style={{
//                           backgroundColor: "#ccdef4",
//                           color: "black",
//                           fontWeight: "bold",
//                           fontSize: "11px",
//                         }}
//                       >
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                           colSpan={2}
//                         >
//                           {t("Total")}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {total.TotalPendingCount}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {Number(total.TotalPendingAmount).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {total.RDDCheckerCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(total.RDDCheckerAmount).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {total.RDDSOCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(total.RDDSOAmount).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     );
//                   })()}
//                 </tfoot>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {showspecific === 3 && showDistrictSummary && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           {/* Header bar matching bill table */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "15px",
//               marginBottom: "20px",
//               padding: "10px 4rem",
//             }}
//           >
//             {AdminData?.Department_Name === "State" && (
//               <button
//                 className="btn btn-danger"
//                 onClick={() => {
//                   setCurrentPage(1);
//                   setTableData([]);
//                   setShowSpecific(1);
//                   // setFromDate1();
//                   // setToDate1();
//                 }}
//               >
//                 Back
//               </button>
//             )}

//             <h4
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 margin: 0,
//               }}
//             >
//               <img
//                 src={BillApprovalBlue32}
//                 alt="Bill"
//                 style={{ width: "1.5rem" }}
//               />
//               {t("Bill Data")}
//             </h4>
//           </div>

//           {/* Table card */}
//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               backgroundColor: "white",
//               borderRadius: "10px",
//               padding: "20px 20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//               fontFamily: "sans-serif",
//             }}
//           >
//             <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
//               {t("Bill Data")}
//             </h4>

//             <div
//               className="col-12 tableContainer2"
//               style={{ overflowX: "scroll" }}
//             >
//               <table
//                 className="col-12"
//                 style={{
//                   textAlign: "center",
//                   width: "100%",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <thead>
//                   {/* Top Header */}
//                   <tr
//                     style={{
//                       backgroundColor: "#1565c0",
//                       color: "white",
//                       fontSize: "11px",
//                       textAlign: "center",
//                     }}
//                   >
//                     <th
//                       rowSpan="2"
//                       style={{
//                         minWidth: "60px",
//                         padding: "8px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Sr No")}
//                     </th>

//                     <th
//                       rowSpan="2"
//                       style={{
//                         minWidth: "130px",
//                         padding: "8px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("District")}
//                     </th>

//                     {/* Parent Header */}
//                     <th
//                       colSpan="2"
//                       style={{
//                         minWidth: "260px",
//                         padding: "8px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Total Pending Bill at ZP Level")}
//                     </th>

//                     {/* Dynamic Parent Header */}
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <th
//                         colSpan="2"
//                         style={{
//                           minWidth: "260px",
//                           padding: "8px",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {t("RDD Checker(ASO)")}
//                       </th>
//                     )}

//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <th
//                         colSpan="2"
//                         style={{
//                           minWidth: "260px",
//                           padding: "8px",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {t("RDD Section Officer")}
//                       </th>
//                     )}
//                   </tr>

//                   {/* Sub Header */}
//                   <tr
//                     style={{
//                       backgroundColor: "#1976d2",
//                       color: "white",
//                       fontSize: "11px",
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* Total Pending Bill sub columns */}
//                     <th
//                       style={{
//                         minWidth: "130px",
//                         padding: "8px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Count")}
//                     </th>

//                     <th
//                       style={{
//                         minWidth: "130px",
//                         padding: "8px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Amount")}
//                     </th>

//                     {/* RDD Checker sub columns */}
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <>
//                         <th
//                           style={{
//                             minWidth: "130px",
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Count")}
//                         </th>

//                         <th
//                           style={{
//                             minWidth: "130px",
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Amount")}
//                         </th>
//                       </>
//                     )}

//                     {/* RDD SO sub columns */}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <>
//                         <th
//                           style={{
//                             minWidth: "130px",
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Count")}
//                         </th>

//                         <th
//                           style={{
//                             minWidth: "130px",
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {t("Amount")}
//                         </th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredDistricts && filteredDistricts.length > 0 ? (
//                     filteredDistricts.map((item, index) => (
//                       <tr
//                         key={index}
//                         style={{
//                           fontSize: "10px",
//                           backgroundColor:
//                             index % 2 === 0 ? "#f9f9f9" : "white", // alternating rows
//                         }}
//                       >
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {index + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             color: "#1976d2",
//                             cursor: "pointer",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                           onClick={() => HandleDistrictClick(item.District)}
//                         >
//                           {t(item.District)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {item.TotalPendingCount}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {Number(item.TotalPendingAmount || 0).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>

//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {item.RDDCheckerCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(
//                                 item.RDDCheckerAmount || 0,
//                               ).toLocaleString("en-IN")}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {item.RDDSOCount}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 fontSize: "15px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               ₹{" "}
//                               {Number(item.RDDSOAmount || 0).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={6}
//                         style={{ padding: "20px", fontWeight: "bold" }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}
//                   <tr
//                     style={{
//                       backgroundColor: "#e3f2fd",
//                       fontWeight: "bold",
//                       fontSize: "11px",
//                     }}
//                   >
//                     <td
//                       colSpan={2}
//                       style={{
//                         padding: "10px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {t("Total")}
//                     </td>

//                     {/* Total Pending */}
//                     <td
//                       style={{
//                         padding: "10px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {filteredDistricts.reduce(
//                         (sum, item) =>
//                           sum + Number(item.TotalPendingCount || 0),
//                         0,
//                       )}
//                     </td>

//                     <td
//                       style={{
//                         padding: "10px",
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       ₹{" "}
//                       {filteredDistricts
//                         .reduce(
//                           (sum, item) =>
//                             sum + Number(item.TotalPendingAmount || 0),
//                           0,
//                         )
//                         .toLocaleString("en-IN")}
//                     </td>

//                     {/* RDD Checker Total */}
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {filteredDistricts.reduce(
//                             (sum, item) =>
//                               sum + Number(item.RDDCheckerCount || 0),
//                             0,
//                           )}
//                         </td>

//                         <td
//                           style={{
//                             padding: "10px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {filteredDistricts
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.RDDCheckerAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                       </>
//                     )}

//                     {/* RDD SO Total */}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {filteredDistricts.reduce(
//                             (sum, item) => sum + Number(item.RDDSOCount || 0),
//                             0,
//                           )}
//                         </td>

//                         <td
//                           style={{
//                             padding: "10px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {filteredDistricts
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.RDDSOAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Year wise record */}

//       {showspecific === 5 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           {/* Header */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "15px",
//               marginBottom: "20px",
//               padding: "10px 4rem",
//             }}
//           >
//             <button
//               className="btn btn-danger"
//               onClick={() => {
//                 setCurrentPage(1);
//                 setSelectedDistrict("");
//                 setselectedProposalYear("");
//                 setDistrictData([]);
//                 setTableData([]);
//                 setShowSpecific(3);
//                 setShowDistrictSummary(true);
//                 // setFromDate1();
//                 // setToDate1();
//               }}
//             >
//               Back
//             </button>

//             <h4
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 margin: 0,
//               }}
//             >
//               <img
//                 src={BillApprovalBlue32}
//                 alt="Bill"
//                 style={{ width: "1.5rem" }}
//               />

//               {t("Administrative Year Summary")}

//               {selectedDistrict && (
//                 <span
//                   style={{
//                     // color: "#1976d2",
//                     fontWeight: "600",
//                     fontSize: "18px",
//                   }}
//                 >
//                   - {t(selectedDistrict)}
//                 </span>
//               )}
//             </h4>
//           </div>

//           {/* Table Card */}
//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               backgroundColor: "white",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//               fontFamily: "sans-serif",
//             }}
//           >
//             <h4
//               style={{
//                 marginBottom: "15px",
//                 fontWeight: "bold",
//               }}
//             >
//               {t("Administrative Year Summary")}

//               {selectedDistrict && (
//                 <span
//                   style={{
//                     // color: "#1976d2",
//                     fontSize: "18px",
//                     fontWeight: "600",
//                     marginLeft: "8px",
//                   }}
//                 >
//                   - {t(selectedDistrict)}
//                 </span>
//               )}
//             </h4>

//             <div
//               className="col-12 tableContainer2"
//               style={{ overflowX: "auto" }}
//             >
//               <table
//                 className="col-12"
//                 style={{
//                   textAlign: "center",
//                   width: "100%",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "#1565c0",
//                       color: "white",
//                     }}
//                   >
//                     <th
//                       style={{
//                         padding: "12px",
//                         fontSize: "16px",
//                         fontWeight: "600",
//                         width: "15%",
//                       }}
//                     >
//                       {t("Sr No")}
//                     </th>

//                     <th
//                       style={{
//                         padding: "12px",
//                         fontSize: "16px",
//                         fontWeight: "600",
//                         width: "35%",
//                       }}
//                     >
//                       {t("Administrative Year")}
//                     </th>

//                     <th
//                       style={{
//                         padding: "12px",
//                         fontSize: "16px",
//                         fontWeight: "600",
//                         width: "25%",
//                       }}
//                     >
//                       {t("Total Bills")}
//                     </th>

//                     <th
//                       style={{
//                         padding: "12px",
//                         fontSize: "16px",
//                         fontWeight: "600",
//                         width: "25%",
//                       }}
//                     >
//                       {t("Total Amount")}
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                  {administrativeYearSummary.length > 0 ? (
//     [...administrativeYearSummary]
//       .sort((a, b) => {
//         const yearA = parseInt(a.AdministrativeYear.split("-")[0]);
//         const yearB = parseInt(b.AdministrativeYear.split("-")[0]);

//         return yearA - yearB; // Ascending order
//       })
//       .map((item, index) => (
//         <tr
//           key={item.AdministrativeYear}
//           style={{
//             backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
//           }}
//         >
//                         {/* Sr No */}
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {index + 1}
//                         </td>

//                         {/* Administrative Year */}
//                         <td
//                           onClick={() =>
//                             HandleYearClick(item.AdministrativeYear)
//                           }
//                           style={{
//                             padding: "12px",
//                             color: "#1976d2",
//                             cursor: "pointer",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           {item.AdministrativeYear}
//                         </td>

//                         {/* Total Bills */}
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {item.TotalBills}
//                         </td>

//                         {/* Total Amount */}
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "15px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           ₹{" "}
//                           {Number(item.TotalAmount || 0).toLocaleString(
//                             "en-IN",
//                             {
//                               minimumFractionDigits: 2,
//                               maximumFractionDigits: 2,
//                             },
//                           )}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="4"
//                         style={{
//                           padding: "25px",
//                           textAlign: "center",
//                           fontWeight: "bold",
//                           fontSize: "15px",
//                         }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}

//                   {/* Grand Total */}
//                   {administrativeYearSummary.length > 0 && (
//                     <tr
//                       style={{
//                         backgroundColor: "#e3f2fd",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       <td
//                         colSpan="2"
//                         style={{
//                           padding: "12px",
//                           fontSize: "15px",
//                           textAlign: "right",
//                         }}
//                       >
//                         {t("Total")}
//                       </td>

//                       <td
//                         style={{
//                           padding: "12px",
//                           fontSize: "15px",
//                         }}
//                       >
//                         {administrativeYearSummary.reduce(
//                           (sum, item) => sum + Number(item.TotalBills || 0),
//                           0,
//                         )}
//                       </td>

//                       <td
//                         style={{
//                           padding: "12px",
//                           fontSize: "15px",
//                         }}
//                       >
//                         ₹{" "}
//                         {administrativeYearSummary
//                           .reduce(
//                             (sum, item) => sum + Number(item.TotalAmount || 0),
//                             0,
//                           )
//                           .toLocaleString("en-IN", {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2,
//                           })}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {showspecific === 0 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "10px 4rem",
//             }}
//           >
//             {/* <button className=' px-4 py-2'
//               onClick={approveSelected}
//               // onClick={(e) => { SetGenerateToken(false) }}
//               disabled={selectedBills.length <= 0 ? true : loading}
//               style={{
//                 cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer',
//                 background: selectedBills.length <= 0 ? (
//                   'linear-gradient(to Right,rgba(141, 141, 141, 0.97))'
//                 ) : ('linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )'), color: 'white',
//                 fontSize: "16px"
//               }}
//             ><img src="" style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve & Pay'}
//             </button> */}
//             {/* <button className='btn btn-success'>Approve & Pay</button> */}
//             {/* <button className='btn mx-2' style={{ backgroundColor: "#B6BAC1" }}>Back</button> */}

//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               {AdminData?.Department_Name === "State" && (
//                 <button
//                   className="btn btn-danger"
//                   onClick={() => {
//                     setSelectedBills([]);
//                     setSelectAll(false);
//                     setCurrentPage(1);
//                 //     setFromDate1();
//                 // setToDate1();

//                     // Get complete original data
//                     const latest = ALLtableDataRef.current || [];

//                     // Keep currently selected district
//                     const district = selectedDistrict;

//                     console.log("Selected District:", district);

//                     // Get only selected district data
//                     // const districtFilteredData = latest.filter((item) => {
//                     //   return (
//                     //     item.District === district ||
//                     //     item.District?.startsWith(`${district}-`)
//                     //   );
//                     // });
//                     const districtFilteredData = latest.filter((item) => {
//                       const districtMatch =
//                         item.District === district ||
//                         item.District?.startsWith(`${district}-`);

//                       // return districtMatch && inDateRange(item);
//                         return districtMatch && passesBase(item);
//                     });

//                     console.log(
//                       "Selected District Year Summary Data:",
//                       districtFilteredData,
//                     );

//                     // Restore selected district data
//                     setDistrictData(districtFilteredData);
//                     setTableData(districtFilteredData);

//                     // IMPORTANT:
//                     // Do NOT clear selectedDistrict here
//                     // setSelectedDistrict("");

//                     // Clear selected year because we are going back to Year Summary
//                     setselectedProposalYear("");

//                     // Show selected District Administrative Year Summary
//                     setShowSpecific(5);
//                     setShowDistrictSummary(true);
//                   }}
//                 >
//                   Back
//                 </button>
//               )}
//               <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                 <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
//                 {t("Bill Inwards")}
//               </h4>
//             </div>
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <button
//                 onClick={approveSelected}
//                 disabled={selectedBills.length <= 0 ? true : loading}
//                 style={{
//                   color: "white",
//                   border: "none",
//                   borderRadius: "20px",
//                   padding: "8px 20px",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   cursor: "pointer",
//                   fontFamily: "sans-serif",
//                   boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                   cursor:
//                     selectedBills.length <= 0
//                       ? "not-allowed"
//                       : loading
//                         ? "not-allowed"
//                         : "pointer",
//                   background:
//                     selectedBills.length <= 0
//                       ? "linear-gradient(to Right,rgba(141, 141, 141, 0.97)"
//                       : "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5)",
//                   color: "white",
//                 }}
//               >
//                 <img
//                   src={ApprovePay32}
//                   style={{ width: "14px", filter: "brightness(0) invert(1)" }}
//                 />
//                 {loading
//                   ? AdminData.Department_Name === "District" ||
//                     AdminData.Department_Name === "State"
//                     ? "Processing..."
//                     : ""
//                   : t("Approve")}
//               </button>

//               <button
//                 onClick={() => openRemarkModal("SendBack")}
//                 disabled={selectedBills.length <= 0}
//                 style={{
//                   background: "#f0ad4e",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   cursor: "pointer",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "20px",
//                   padding: "8px 20px",
//                   gap: "8px",
//                   fontWeight: 600,
//                   cursor: selectedBills.length <= 0 ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <img
//                   src="/Send-Back-Selected32.png"
//                   style={{
//                     width: "14px",
//                     filter: "brightness(0) invert(1)",
//                     gap: "8px",
//                   }}
//                 />
//                 {t("Send Back")}
//               </button>

//               <button
//                 onClick={() => openRemarkModal("Reject")}
//                 disabled={selectedBills.length <= 0}
//                 style={{
//                   background: "#dc3545",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   cursor: "pointer",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "20px",
//                   padding: "8px 20px",
//                   fontWeight: 600,
//                   cursor: selectedBills.length <= 0 ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <img
//                   src="/Reject-Selected32.png"
//                   style={{
//                     width: "14px",
//                     filter: "brightness(0) invert(1)",
//                     gap: "8px",
//                   }}
//                 />
//                 {t("Reject")}
//               </button>
//             </div>
//           </div>

//           {/* <div
//             style={{
//               display: "flex",
//               padding: "1rem",
//               backgroundColor: "#f1f5f9",
//               justifyContent: "space-evenly",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 width: "280px",
//                 height: "100px",
//                 backgroundColor: "white",
//                 borderRadius: "12px",
//                 boxShadow: "0 0 6px rgba(0,0,0,0.08)",
//                 borderTop: "3px solid #007bff",
//                 padding: "15px",
//                 fontFamily: "sans-serif",
//               }}
//             >
//               <div
//                 style={{
//                   width: "45px",
//                   height: "45px",
//                   background: "linear-gradient(to bottom, #007bff, #00bfff)",
//                   borderRadius: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "12px",
//                 }}
//               >
//                 <img
//                   src={AvailableReleaseAmount}
//                   alt="icon"
//                   style={{ width: "45px", height: "45px" }}
//                 />
//               </div>
//               <div>
//                 <div style={{ fontSize: "14px", color: "#6c757d" }}>
//                   {t("Available Release Amount :")}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     color: "#000",
//                   }}
//                 >
//                   {Number(TotalPaidCount).toLocaleString("en-IN")}
//                 </div>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 width: "280px",
//                 height: "100px",
//                 backgroundColor: "white",
//                 borderRadius: "12px",
//                 boxShadow: "0 0 6px rgba(0,0,0,0.08)",
//                 borderTop: "3px solid #007bff",
//                 padding: "15px",
//                 fontFamily: "sans-serif",
//               }}
//             >
//               <div
//                 style={{
//                   width: "45px",
//                   height: "45px",
//                   background: "linear-gradient(to bottom, #007bff, #00bfff)",
//                   borderRadius: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "12px",
//                 }}
//               >
//                 <img
//                   src={SelectedDemandAmount}
//                   alt="icon"
//                   style={{
//                     width: "45px",
//                     height: "45px",
//                   }}
//                 />
//               </div>
//               <div>
//                 <div style={{ fontSize: "14px", color: "#6c757d" }}>
//                   {t("Selected Demand Amount :")}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     color: "#000",
//                   }}
//                 >
//                   {data?.SelectedDemandAmount
//                     ? Number(data.SelectedDemandAmount).toLocaleString("en-IN")
//                     : 0}
//                 </div>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 width: "280px",
//                 height: "100px",
//                 backgroundColor: "white",
//                 borderRadius: "12px",
//                 boxShadow: "0 0 6px rgba(0,0,0,0.08)",
//                 borderTop: "3px solid #007bff",
//                 padding: "15px",
//                 fontFamily: "sans-serif",
//               }}
//             >
//               <div
//                 style={{
//                   width: "45px",
//                   height: "45px",
//                   background: "linear-gradient(to bottom, #007bff, #00bfff)",
//                   borderRadius: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "12px",
//                 }}
//               >
//                 <img
//                   src={Balance}
//                   alt="icon"
//                   style={{
//                     width: "45px",
//                     height: "45px",
//                   }}
//                 />
//               </div>
//               <div>
//                 <div style={{ fontSize: "14px", color: "#6c757d" }}>
//                   {t("Balance :")}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     color: "#000",
//                   }}
//                 >
//                   {Number(
//                     TotalPaidCount - data.SelectedDemandAmount,
//                   ).toLocaleString("en-IN")}
//                 </div>
//               </div>
//             </div>
//           </div> */}
//           <div
//             className=" col-12 my-3 px-4"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <div
//               className="col-12"
//               style={{
//                 padding: "1px",
//                 borderRadius: "10px",
//                 background: "linear-gradient(to right, #2196f3, #9c27b0)",
//                 // display: "inline-block",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
//                   padding: "30px 20px",
//                   borderRadius: "8px",
//                   fontFamily: "sans-serif",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     // marginRight: "5px",
//                   }}
//                 >
//                   {" "}
//                   {t("Work Name")}
//                 </label>
//                 <select
//                   name="ProjectID"
//                   id=""
//                   value={data.ProjectID}
//                   onChange={HandleChangeData}
//                   style={{
//                     padding: "10px",
//                     borderRadius: "6px",
//                     border: "1px solid #ccc",
//                     width: "550px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <option value="All">{t("Choose Work Name")}</option>
//                   {workNameOptions.map((val, index) => (
//                     <option key={index} value={val.MainWorkOrderID}>
//                       {val.MainWorkOrderID}
//                     </option>
//                   ))}
//                 </select>

//                 <label
//                   style={{
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     marginRight: "5px",
//                   }}
//                 >
//                   {t("Administrative Approved Year")}
//                 </label>

//                 <select
//                   name="ApprovedYear"
//                   value={approvedYear}
//                   onChange={(e) => setApprovedYear(e.target.value)}
//                   style={{
//                     padding: "12px",
//                     borderRadius: "6px",
//                     border: "1px solid #ccc",
//                     outline: "none",
//                     width: "250px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <option value="">{t("Choose Approved Year")}</option>

//                   {[
//                     ...new Set(
//                       tableData
//                         ?.map((item) => item.WorkApprovedYear)
//                         .filter(Boolean),
//                     ),
//                   ]
//                     .sort()
//                     .map((year, index) => (
//                       <option key={index} value={year}>
//                         {year}
//                       </option>
//                     ))}
//                 </select>
//                 {/* <button
//                   style={{
//                     backgroundColor: "#28a745",
//                     color: "white",
//                     border: "none",
//                     padding: "10px 18px",
//                     borderRadius: "6px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "5px",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <span>{t("Search")}</span>
//                 </button> */}
//               </div>
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               margin: "20px",
//               gap: "20px",
//             }}
//           >
//             {/* Left Side - Tally Table */}
//             <div>
//               <table
//                 style={{
//                   borderCollapse: "collapse",
//                   minWidth: "300px",
//                   background: "#fff",
//                   boxShadow: "0 0 5px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 <thead>
//                   <tr style={{ background: "#1976d2", color: "#fff" }}>
//                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
//                       {t("No. of Bills")}
//                     </th>
//                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
//                       {t("Total Amount")}
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   <tr>
//                     <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                       {selectedBillCount}
//                     </td>
//                     <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                       ₹ {selectedBillAmount.toLocaleString("en-IN")}
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             {/* Right Side - Upload Order */}
//             {AdminData.Department_Name == "State" &&
//               (AdminData.RoleID == 25 || AdminData.RoleID == 40) && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                     padding: "15px",
//                     background: "#f8fafc",
//                     borderRadius: "10px",
//                     border: "1px solid #dbe4ee",
//                   }}
//                 >
//                   <label
//                     style={{
//                       fontSize: "15px",
//                       fontWeight: "600",
//                       color: "#1e293b",
//                       margin: 0,
//                     }}
//                   >
//                     {t("Fund Release Order")}
//                   </label>

//                   <input
//                     type="file"
//                     accept=".pdf,.xls,.xlsx"
//                     onChange={handleUploadOrder}
//                     style={{
//                       border: "1px solid #cbd5e1",
//                       padding: "8px",
//                       borderRadius: "6px",
//                       background: "white",
//                       fontSize: "13px",
//                       cursor: "pointer",
//                     }}
//                   />

//                   {/* {uploadOrderFile && (
//                     <span
//                       style={{
//                         fontSize: "13px",
//                         color: "#0f172a",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {uploadOrderFile.name}
//                     </span>
//                   )} */}
//                 </div>
//               )}
//           </div>

//           <div style={{ display: "flex", gap: "8px", padding: "4px 1rem" }}>
//             <div className="input-group" style={{ width: "150px" }}>
//               <select
//                 className="form-select"
//                 value={selectedTaluka}
//                 onChange={(e) => setSelectedTaluka(e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "8px 12px",
//                   border: "1px solid #ccc",
//                   borderRadius: "8px",
//                   backgroundColor: "#f1f6fc",
//                   fontSize: "13px",
//                 }}
//               >
//                 <option value="">Select Taluka</option>

//                 {[
//                   ...new Set(
//                     ALLtableData.map((item) => item.Taluka || item.ulb).filter(
//                       Boolean,
//                     ),
//                   ),
//                 ]
//                   .sort()
//                   .map((taluka) => (
//                     <option key={taluka} value={taluka}>
//                       {taluka}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             {/* Type of Work */}
//             <div className="input-group" style={{ width: "170px" }}>
//               <select
//                 className="form-select"
//                 value={selectedWorkType}
//                 onChange={(e) => setSelectedWorkType(e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "8px 12px",
//                   border: "1px solid #ccc",
//                   borderRadius: "8px",
//                   backgroundColor: "#f1f6fc",
//                   fontSize: "13px",
//                 }}
//               >
//                 <option value="">Select Type Of Work</option>

//                 {[
//                   ...new Set(
//                     ALLtableData.map(
//                       (item) => item.typeOfWork || item.workType,
//                     ).filter(Boolean),
//                   ),
//                 ]
//                   .sort()
//                   .map((workType) => (
//                     <option key={workType} value={workType}>
//                       {workType}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             {(AdminData.RoleID == 24 ||
//               AdminData.RoleID == 25 ||
//               AdminData.RoleID == 40 ||
//               AdminData.RoleID == 41) && (
//               <div style={{ display: "flex", gap: "8px", padding: "4px 1rem" }}>
//                 {/* <label className="form-label">Date</label> */}

//                 <div className="d-flex gap-2">
//                   <div className="input-group" style={{ width: "170px" }}>
//                     <span className="input-group-text">From</span>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={fromDate}
//                       onChange={(e) => setFromDate(e.target.value)}
//                     />
//                   </div>

//                   <div className="input-group" style={{ width: "170px" }}>
//                     <span className="input-group-text">To</span>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={toDate}
//                       onChange={(e) => setToDate(e.target.value)}
//                     />
//                   </div>
//                 </div>
//                 {/* Search */}
//                 <div style={{ position: "relative", width: "220px" }}>
//                   <img
//                     src="/Search32.png"
//                     alt="Search"
//                     style={{
//                       position: "absolute",
//                       top: "50%",
//                       left: "10px",
//                       transform: "translateY(-50%)",
//                       width: "16px",
//                       opacity: 0.6,
//                     }}
//                   />
//                   <input
//                     type="text"
//                     placeholder={t("Search Here")}
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     style={{
//                       width: "100%",
//                       padding: "8px 12px 8px 32px",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       backgroundColor: "#f1f6fc",
//                       fontSize: "13px",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>

//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               backgroundColor: "white",
//               borderRadius: "10px",
//               padding: "20px 20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//               fontFamily: "sans-serif",
//             }}
//           >
//             <div className="d-flex gap-2 justify-content-between">
//               <div>
//                 <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
//                   {t("Bill Details")}
//                 </h4>
//               </div>
//               <div className="d-flex gap-2 ">
//                 <button
//                   className="btn btn-success"
//                   onClick={() =>
//                     exportTableByClassToExcel(currentBills, "Bill_Inward.xlsx")
//                   }
//                 >
//                   {t("Download Excel")}
//                 </button>
//                 <button
//                   className="btn btn-danger"
//                   onClick={() =>
//                     downloadTableOnlyAsPDF(
//                       "BillInward",
//                       "BillInward.pdf",
//                       `Zilha Parishad – ${
//                         userData?.District === "State"
//                           ? selectedDistrict
//                           : userData?.District || selectedDistrict
//                       }`,
//                     )
//                   }
//                 >
//                   {t("Download PDF")}
//                 </button>
//               </div>
//             </div>

//             <div
//               className="col-12 tableContainer2"
//               style={{
//                 overflowX: "auto",
//                 overflowY: "auto",
//                 maxHeight: "600px", // change height as needed
//                 position: "relative",
//               }}
//             >
//               <table
//                 className="col-12 BillInward"
//                 style={{
//                   textAlign: "center",
//                   width: "100%",
//                   borderCollapse: "separate",
//                   borderSpacing: 0,
//                   background: "white",
//                 }}
//               >
//                 <thead
//                   style={{
//                     position: "sticky",
//                     backgroundColor: "#1976d2",
//                     top: 0,
//                     zIndex: 10,
//                   }}
//                 >
//                   <tr
//                     style={{
//                       color: "white",
//                       fontSize: "18px",
//                     }}
//                   >
//                     {/* <th style={{ minWidth: "70px", paddingInline: "4px" }}>
//                       <input
//                         type="checkbox"
//                         style={{ height: "1.2rem", width: "1.4rem" }}
//                         checked={selectAll}
//                         onChange={handleSelectAllChange}
//                       />
//                     </th>
//                     <th style={{ minWidth: "70px", padding: "8px" }}>
//                       {t("Sr.No.")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Demand Number")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Class Of Work")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Type Of Work")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Name")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       Taluka
//                     </th>

//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Approved Year")}
//                     </th>

//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Approval GR Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("MHUID Number")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Head Code")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Physical Progress in Percentage")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Received Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Amount")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Net Payable Amount")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Deduction")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Vendor Name")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Copy")}
//                     </th> */}
//                     {/* <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Demand Copy")}
//                     </th> */}
//                     {/* <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Order Copy")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Administrative Approved GR (AAGR)")}
//                     </th>
//                         <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Measurement Book")}
//                     </th>
//                         <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("SQM Inspection Report")}
//                     </th>
//                         <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work completion Certificate")}
//                     </th> */}

//                     <th style={{ minWidth: "70px", paddingInline: "4px" }}>
//                       <input
//                         type="checkbox"
//                         style={{ height: "1.2rem", width: "1.4rem" }}
//                         checked={selectAll}
//                         onChange={handleSelectAllChange}
//                       />
//                     </th>
//                     <th style={{ minWidth: "70px", padding: "8px" }}>
//                       {t("Sr.No.")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Demand ID")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Creation Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Receive Date at RDD")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Administrative Approval Year (A.A.Year)")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("MHUID Number")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Name")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Taluka")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Class Of Work")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Type Of Work")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Amount")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Net Payable Amount")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Deduction")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Administrative Approval GR Date")}
//                     </th>

//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Order Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Physical Progress in Percentage")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Measurement Book")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("SQM Inspection Report")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Work Completion Date")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Bill Copy")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Vendor Name")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Head Code")}
//                     </th>

//                     {AdminData.Department_Name == "State" &&
//                       (AdminData.RoleID == 24 || AdminData.RoleID == 41) && (
//                         <th style={{ minWidth: "130px", padding: "8px" }}>
//                           {t("Fund Release Order")}
//                         </th>
//                       )}
//                     {/* <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("View mass slip")}
//                     </th> */}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentBills && currentBills.length > 0 ? (
//                     <>
//                       {currentBills.map((val, index) => {
//                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                         return (
//                           <tr
//                             key={index}
//                             style={{
//                               fontSize: "18px",
//                               backgroundColor: bgColor,
//                             }}
//                             data-demand-id={val.DemandGenerationID}
//                           >
//                             <td>
//                               <input
//                                 type="checkbox"
//                                 style={{ height: "1.2rem", width: "1.2rem" }}
//                                 checked={selectedBills.includes(
//                                   val.DemandGenerationID,
//                                 )}
//                                 onChange={(e) => {
//                                   handleCheckboxChange(val.DemandGenerationID);
//                                   // TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount);

//                                   // if unchecking any one, uncheck master
//                                   if (!e.target.checked) {
//                                     setSelectAll(false);
//                                   }
//                                 }}
//                               />
//                             </td>
//                             <td>{index + 1}</td>
//                             {/* <td><input type="checkbox" onChange={(e) => TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount)} /></td> */}
//                             <td>
//                               <span
//                                 onClick={() =>
//                                   settingshowspecific3(val.DemandGenerationID)
//                                 }
//                                 style={{
//                                   color: "#0d6efd",
//                                   textDecoration: "underline",
//                                   cursor: "pointer",
//                                   fontWeight: "500",
//                                 }}
//                               >
//                                 {val.DemandGenerationID}
//                               </span>
//                             </td>
//                             <td>{formatDateTime(val.Date)}</td>
//                             <td>
//                               {val.BillReceivedDate
//                                 ? formatDateTime(val.BillReceivedDate)
//                                 : "-"}
//                             </td>
//                             <td>{val.ProposalYear || "-"}</td>
//                             <td>{val.MHUID_Number || "-"}</td>
//                             <td
//                               style={{
//                                 maxWidth: "300px",
//                                 whiteSpace: "normal",
//                                 wordBreak: "break-word",
//                                 overflowWrap: "break-word",
//                               }}
//                             >
//                               {val.MainWorkOrderID}
//                             </td>
//                             <td>{val.Taluka || val.ulb}</td>
//                             <td>{val.classOfWork || val.workClass}</td>
//                             <td>
//                               {val.typeOfWork && val.typeOfWork !== "NULL"
//                                 ? val.typeOfWork
//                                 : val.workType && val.workType !== "NULL"
//                                   ? val.workType
//                                   : "-"}
//                             </td>
//                             <td>{val.BillAmount}</td>
//                             <td>{val.NetPayableAmount}</td>
//                             <td
//                               onClick={() =>
//                                 DemandDeductionDetailByBillID(
//                                   val.DemandGenerationID,
//                                 )
//                               }
//                             >
//                               <p
//                                 className="makeitlink my-auto"
//                                 style={{ textAlign: "center" }}
//                               >
//                                 {Number(val.DeductionAmount).toLocaleString(
//                                   "en-IN",
//                                 )}
//                               </p>
//                             </td>
//                             <td>
//                               {val.GRCopy ? (
//                                 <a
//                                   href={`${apiurl}/UploadedGR/${val.GRCopy}`}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   style={{
//                                     color: "#0d6efd",
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {(val.GRApproveDate ||
//                                     val.workApprovedGRDate) &&
//                                     formatDate(
//                                       val.GRApproveDate ||
//                                         val.workApprovedGRDate,
//                                     )}
//                                 </a>
//                               ) : (
//                                 ((val.GRApproveDate ||
//                                   val.workApprovedGRDate) &&
//                                   // new Date(
//                                   //   val.GRApproveDate || val.workApprovedGRDate
//                                   // ).toLocaleDateString()
//                                   formatDate(
//                                     val.GRApproveDate || val.workApprovedGRDate,
//                                   )) ||
//                                 "-"
//                               )}
//                             </td>
//                             <td
//                               style={{
//                                 width: "140px",
//                                 minWidth: "140px",
//                                 padding: "10px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {val.CopyofWorkOrder ? (
//                                 <a
//                                   // href={`${apiurl}/Work_completionImages/${val.Work_completion}`}
//                                   href={`${apiurl}/WorkOrderDocsImages/${val.CopyofWorkOrder}`}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   style={{
//                                     color: "#0d6efd",
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {val.WorkOrderDate
//                                     ? formatDate(val.WorkOrderDate)
//                                     : "-"}
//                                 </a>
//                               ) : val.WorkOrderDate ? (
//                                 formatDate(val.WorkOrderDate)
//                               ) : (
//                                 "-"
//                               )}
//                             </td>
//                             <td>
//                               <span
//                                 style={{
//                                   color: "blue",
//                                   textDecoration: "underline",
//                                   cursor: "pointer",
//                                 }}
//                                 onClick={() =>
//                                   openProgressModal(
//                                     val.physicalprogressImage,
//                                     val.Location,
//                                   )
//                                 }
//                               >
//                                 {val.physicalValueOfProgress}%
//                               </span>
//                             </td>
//                             <td>
//                               {val.Measurement_Book ? (
//                                 <p>
//                                   <a
//                                     href={`${apiurl}/Measurement_BookImages/${val.Measurement_Book}`}
//                                     target="_blank"
//                                   >
//                                     {formatFileName(val.Measurement_Book)}
//                                   </a>
//                                 </p>
//                               ) : (
//                                 <p
//                                   className="text-danger fw-bold my-auto"
//                                   style={{ fontSize: "12px" }}
//                                 >
//                                   {t("No File")}
//                                 </p>
//                               )}
//                             </td>
//                             <td>
//                               {val.Inspection_Report ? (
//                                 <p>
//                                   <a
//                                     href={`${apiurl}/Inspection_ReportImages/${val.Inspection_Report}`}
//                                     target="_blank"
//                                   >
//                                     {formatFileName(val.Inspection_Report)}
//                                   </a>
//                                 </p>
//                               ) : (
//                                 <p
//                                   className="text-danger fw-bold my-auto"
//                                   style={{ fontSize: "12px" }}
//                                 >
//                                   {t("No File")}
//                                 </p>
//                               )}
//                             </td>
//                             <td>
//                               {val.Work_completion ? (
//                                 <a
//                                   href={`${apiurl}/Work_completionImages/${val.Work_completion}`}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   style={{
//                                     color: "#0d6efd",
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {val.WorkEndDate
//                                     ? formatDate(val.WorkEndDate)
//                                     : "-"}
//                                 </a>
//                               ) : val.WorkEndDate ? (
//                                 formatDate(val.WorkEndDate)
//                               ) : (
//                                 "-"
//                               )}
//                             </td>
//                             <td>
//                               {val.UploadBillCopy ? (
//                                 <p className="my-auto">
//                                   <a
//                                     href={`${apiurl}/BillCopyDocsImages/${val.UploadBillCopy}`}
//                                     target="_blank"
//                                   >
//                                     {formatFileName(val.UploadBillCopy)}
//                                   </a>
//                                 </p>
//                               ) : (
//                                 <p
//                                   className="text-danger fw-bold my-auto"
//                                   style={{ fontSize: "18px" }}
//                                 >
//                                   {t("No File")}
//                                 </p>
//                               )}
//                             </td>
//                             <td>{val.ContractorName}</td>
//                             <td>{val.BudgetID}</td>
//                             {/*  */}

//                             {/* <td>{val.physicalValueOfProgress}%</td> */}

//                             {/*
//                              */}
//                             {/* <td style={{ fontSize: "12px", padding: "5px" }}>
//                               <button
//                                 className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
//                                 style={{
//                                   minHeight: "33px",
//                                   minWidth: "100px",
//                                   padding: "0.375rem 0.75rem",
//                                   fontSize: "0.9rem",
//                                   fontWeight: 400,
//                                   lineHeight: 1.5,
//                                   cursor: "pointer",
//                                   background:
//                                     "linear-gradient(to right, #38439f, #048ecc)",
//                                   color: "white",
//                                   borderRadius: "999px",
//                                   border: "1px solid transparent",
//                                 }}
//                                 onClick={() =>
//                                   settingshowspecific3(val.DemandGenerationID)
//                                 }
//                               >
//                                 <img
//                                   src="/view32.png"
//                                   alt="view"
//                                   width="15"
//                                   height="15"
//                                   style={{ verticalAlign: "middle" }}
//                                 />
//                                 <span style={{ lineHeight: 1 }}>View </span>
//                               </button>
//                             </td> */}

//                             {AdminData.Department_Name == "State" &&
//                               (AdminData.RoleID == 24 ||
//                                 AdminData.RoleID == 41) && (
//                                 <td className="py-2">
//                                   {val.uploadWork ? (
//                                     <p className="my-auto">
//                                       <a
//                                         href={`${apiurl}/UploadWorkFiles/${val.uploadWork}`}
//                                         target="_blank"
//                                       >
//                                         {formatFileName(val.uploadWork)}
//                                       </a>
//                                     </p>
//                                   ) : (
//                                     <p
//                                       className="text-danger fw-bold my-auto"
//                                       style={{ fontSize: "12px" }}
//                                     >
//                                       {t("No File")}
//                                     </p>
//                                   )}
//                                 </td>
//                               )}
//                           </tr>
//                         );
//                       })}{" "}
//                       <tr
//                         style={{
//                           backgroundColor: "#ffffff",
//                           fontWeight: "bold",
//                           fontSize: "18px",
//                         }}
//                       >
//                         <td
//                           colSpan={11}
//                           style={{ textAlign: "right", padding: "10px" }}
//                         >
//                           Page Total
//                         </td>

//                         {/* Total Bill Amount */}
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce(
//                               (sum, item) => sum + Number(item.BillAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>

//                         {/* Total Net Payable Amount */}
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.NetPayableAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.DeductionAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         {/* Empty remaining columns */}
//                         <td colSpan={0}></td>
//                       </tr>
//                       <tr
//                         style={{
//                           backgroundColor: "#ffffff",
//                           fontWeight: "bold",
//                           fontSize: "18px",
//                         }}
//                       >
//                         <td
//                           colSpan={11}
//                           style={{ textAlign: "right", padding: "10px" }}
//                         >
//                           Gross Total
//                         </td>

//                         {/* Total Bill Amount */}
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {sortedBills
//                             .reduce(
//                               (sum, item) => sum + Number(item.BillAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>

//                         {/* Total Net Payable Amount */}
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {sortedBills
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.NetPayableAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {sortedBills
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.DeductionAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         {/* Empty remaining columns */}
//                         <td colSpan={0}></td>
//                       </tr>
//                     </>
//                   ) : (
//                     <tr>
//                       <td colSpan={14}>{t("No data found !!")}</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 // padding: " 0px 2.5rem",
//                 height: "3rem",
//                 alignItems: "center",
//                 fontSize: "18px",
//               }}
//             >
//               <div>
//                 <p style={{ margin: "0px", color: "black" }}>
//                   {t("Showing")}{" "}
//                   {tableData.length === 0 ? 0 : indexOfFirstBill + 1} {t("to")}{" "}
//                   {Math.min(indexOfLastBill, tableData.length)} {t("of")}{" "}
//                   {tableData.length} {t("entries")}
//                 </p>
//               </div>
//               <div
//                 style={{ display: "flex", alignItems: "center", gap: "10px" }}
//               >
//                 <GooglePagination
//                   currentPage={currentPage}
//                   totalPages={totalPages}
//                   onPageChange={setCurrentPage}
//                 />

//                 <button
//                   onClick={() => {
//                     setShowAll(!showAll);
//                     setCurrentPage(1);
//                   }}
//                   style={{
//                     border: "none",
//                     outline: "none",
//                     cursor: "pointer",
//                     padding: "8px 16px",
//                     borderRadius: "20px",
//                     fontSize: "13px",
//                     fontWeight: "600",
//                     color: "#fff",
//                     background: showAll
//                       ? "linear-gradient(135deg, #28a745, #20c997)"
//                       : "linear-gradient(135deg, #0067ab, #0098d5)",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                     transition: "all 0.3s ease",
//                   }}
//                 >
//                   {showAll ? "✓ Showing All" : "View All"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {selectedDemandID && showspecific === 2 && (
//         <div
//           className="col-12"
//           style={{
//             backgroundColor: "#EFF3F8",
//             height: "90vh",
//             overflowX: "hidden",
//             overflowY: "scroll",
//           }}
//         >
//           <div className="col-11 m-auto">
//             <div className="col-12">
//               <div className="col-12 py-3">
//                 <button
//                   className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                   onClick={() => setShowSpecific(0)}
//                 >
//                   {t("Back")}
//                 </button>
//               </div>

//               <div className="col-11 my-4 mx-auto">
//                 <div className="row">
//                   <div className="col-9 my-auto">
//                     <h2
//                       className="col-10 m-0"
//                       style={{
//                         color: "#2C78DB",
//                         fontWeight: "700",
//                         fontSize: "1.4rem",
//                       }}
//                     >
//                       {t("Deduction Data of Bill")} {selectedDemandID}
//                     </h2>
//                   </div>

//                   {/* <div className="col-2 text-end">
//                 <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
//               </div> */}
//                 </div>
//               </div>
//               <div className="col-12 pb-5">
//                 <div
//                   className="m-auto mb-3"
//                   style={{
//                     backgroundColor: "white",
//                     padding: "40px 40px",
//                     boxShadow: "0px 0px 5px 1px #E4E8EC",
//                     borderRadius: "20px",
//                     width: "100%",
//                     maxWidth: "100%",
//                     overflowX: "hidden",
//                   }}
//                 >
//                   <div
//                     className="col-12 tableDesign"
//                     style={{ background: "#2C78DB", overflowX: "hidden" }}
//                   >
//                     <table
//                       className="m-0 p-0"
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             color: "white",
//                             border: "none",
//                             height: "3rem",
//                             fontSize: "12px",
//                           }}
//                         >
//                           <th style={{ width: "10%" }}>{t("Sr No")}</th>
//                           <th style={{ width: "45%" }}>
//                             {t("Deduction Name")}
//                           </th>
//                           <th style={{ width: "45%", textAlign: "left" }}>
//                             {t("Deduction Amount")}
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {fetchSpecificDemandDeductionDetail &&
//                         fetchSpecificDemandDeductionDetail.length > 0 ? (
//                           <>
//                             {fetchSpecificDemandDeductionDetail
//                               .filter(
//                                 (item) =>
//                                   item.TypeOfAmount !== "Total Amount Payable",
//                               )
//                               .map((val, index) => {
//                                 const bgColor =
//                                   index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                 return (
//                                   <tr
//                                     key={index}
//                                     style={{
//                                       backgroundColor: bgColor,
//                                       fontSize: "12px",
//                                       fontWeight: "400",
//                                     }}
//                                   >
//                                     <td>{index + 1}</td>
//                                     <td>{val.TypeOfAmount}</td>
//                                     <td style={{ textAlign: "left" }}>
//                                       ₹{" "}
//                                       {Number(val.TotalAmount).toLocaleString(
//                                         "en-IN",
//                                       )}
//                                     </td>
//                                   </tr>
//                                 );
//                               })}

//                             <tr
//                               style={{
//                                 fontWeight: "bold",
//                                 backgroundColor: "#f0f0f0",
//                               }}
//                             >
//                               <td colSpan={2}>{t("Total Deduction Amount")}</td>
//                               <td style={{ textAlign: "left" }}>
//                                 ₹{" "}
//                                 {
//                                   Number(
//                                     fetchSpecificDemandDeductionDetail
//                                       .filter(
//                                         (item) =>
//                                           item.TypeOfAmount !==
//                                           "Total Amount Payable",
//                                       )
//                                       .reduce(
//                                         (acc, curr) =>
//                                           acc +
//                                           parseFloat(curr.TotalAmount || 0),
//                                         0,
//                                       ),
//                                   ).toLocaleString("en-IN")
//                                   // .toFixed(2)
//                                 }
//                               </td>
//                             </tr>
//                           </>
//                         ) : (
//                           <tr>
//                             <td colSpan={5} className="fw-bold">
//                               {t("No Data Found !!")}
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* {showProgressModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ background: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Physical Progress Images</h5>

//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowProgressModal(false)}
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="row">
//                   {progressImages?.length > 0 ? (
//                     progressImages.map((img, index) => (
//                       <div className="col-md-4 mb-3" key={index}>
//                         <img
//                           src={`${apiurl}/UploadProgressDocsImages/${img}`}
//                           alt="progress"
//                           className=" rounded border p-2"
//                           style={{
//                             maxWidth: "100%",
//                             textAlign: "center",
//                             alignItems: "center",
//                             maxHeight: "500px",
//                             width: "auto",
//                             height: "auto",
//                             objectFit: "contain",
//                             borderRadius: "8px",
//                           }}
//                         />
//                       </div>
//                     ))
//                   ) : (
//                     <p>No Images Found</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )} */}

//       {showProgressModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ background: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Physical Progress Images</h5>

//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowProgressModal(false)}
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="row">
//                   {progressData?.length > 0 ? (
//                     progressData.map((item, index) => (
//                       <div className="col-md-4 mb-3" key={index}>
//                         <div
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: "10px",
//                             padding: "10px",
//                             background: "#fff",
//                           }}
//                         >
//                           <img
//                             src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
//                             alt="Document"
//                             style={{
//                               width: "120px",
//                               cursor: "pointer",
//                               maxHeight: "250px",
//                               objectFit: "contain",
//                             }}
//                             onClick={() => {
//                               setSelectedImage(
//                                 `${apiurl}/UploadProgressDocsImages/${item.image}`,
//                               );
//                               setSelectedImageIndex(index);
//                               setShowImageModal(true);
//                             }}
//                           />
//                           {/* <img
//                             src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
//                             alt="progress"
//                             className="img-fluid rounded"
//                             style={{
//                               width: "100%",
//                               maxHeight: "250px",
//                               objectFit: "contain",
//                             }}
//                           /> */}

//                           <div
//                             style={{
//                               marginTop: "10px",
//                               fontSize: "14px",
//                               lineHeight: "1.7",
//                             }}
//                           >
//                             <div>
//                               📍 <strong>Latitude:</strong>{" "}
//                               {item.location?.latitude || "-"}
//                             </div>

//                             <div>
//                               📍 <strong>Longitude:</strong>{" "}
//                               {item.location?.longitude || "-"}
//                             </div>

//                             <div>
//                               📅 <strong>Date:</strong>{" "}
//                               {item.location?.date || "-"}
//                             </div>

//                             <div>
//                               🕒 <strong>Time:</strong>{" "}
//                               {item.location?.time || "-"}
//                             </div>

//                             <div>
//                               ⛰️ <strong>Elevation:</strong>{" "}
//                               {item.location?.elevation || "-"} m
//                             </div>

//                             <div>
//                               🎯 <strong>Accuracy:</strong>{" "}
//                               {item.location?.accuracy || "-"} m
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <p>No Images Found</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {showRemarkModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0,0,0,0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             style={{
//               background: "white",
//               padding: "24px",
//               borderRadius: "12px",
//               width: "420px",
//             }}
//           >
//             <h5>
//               {remarkAction === "Reject"
//                 ? t("Reject Bill")
//                 : t("Send Back Bill")}
//             </h5>
//             <textarea
//               rows={4}
//               value={remarkText}
//               onChange={(e) => setRemarkText(e.target.value)}
//               placeholder={t("Enter remark (required)")}
//               style={{
//                 width: "100%",
//                 padding: "8px",
//                 borderRadius: "6px",
//                 border: "1px solid #ccc",
//                 marginTop: "10px",
//               }}
//             />
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//                 marginTop: "16px",
//               }}
//             >
//               <button
//                 onClick={() => setShowRemarkModal(false)}
//                 className="btn btn-secondary"
//               >
//                 {t("Cancel")}
//               </button>
//               <button
//                 onClick={submitRejectSendBack}
//                 className={
//                   remarkAction === "Reject"
//                     ? "btn btn-danger"
//                     : "btn btn-warning"
//                 }
//               >
//                 {t("Confirm")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showspecific === 4 && (
//         <>
//           <div className="col-12 m-auto">
//             <div
//               className="col-12 m-auto my-15 mb-10 budgetContainer "
//               style={{
//                 maxHeight: "85vh", // or 700px
//                 overflowY: "auto",
//                 overflowX: "hidden",
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",
//               }}
//             >
//               <div className="m-auto budgetElement">
//                 {/* Heading */}

//                 {/* TABLE CONTAINER */}
//                 <div
//                   className="mt-3 d-flex justify-content-between"
//                   style={{
//                     position: "relative",
//                     alignItems: "center",
//                     background: "#fff",
//                   }}
//                 >
//                   {/* TITLE – LEFT */}
//                   <div className="d-flex align-items-center gap-2 mb-3">
//                     <img
//                       src="/Bill-files64.png"
//                       alt="MAS Slip"
//                       width="26"
//                       height="26"
//                       // style={{ transform: "translateY(9px)", }}
//                     />
//                     <h5 className="m-0 fw-bold">Bill Slip</h5>
//                   </div>
//                   {/* BACK BUTTON – TOP RIGHT */}
//                   <div className="col-4 pb-3 d-flex justify-content-end gap-2">
//                     <button
//                       className="btn btn-primary d-flex align-items-center gap-2"
//                       style={{
//                         borderRadius: "999px",
//                         padding: "6px 22px",
//                         fontSize: "14px",
//                         zIndex: 10,
//                       }}
//                       onClick={exportBillSlipPDF}
//                       disabled={exportingBillSlipPDF}
//                     >
//                       {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
//                     </button>
//                     <button
//                       className="btn btn-danger d-flex align-items-center gap-2"
//                       style={{
//                         top: "12px",
//                         right: "12px",
//                         borderRadius: "999px",
//                         padding: "6px 22px",
//                         fontSize: "14px",
//                         zIndex: 10,
//                       }}
//                       onClick={BackFunction}
//                     >
//                       {/* <img
//                         src={Back32}
//                         alt="back"
//                         width="14"
//                         height="14"
//                         // style={{ filter: "brightness(0) invert(1)" }}
//                       /> */}
//                       Back
//                     </button>
//                   </div>
//                 </div>

//                 {/* ================= HEADER ================= */}
//                 <div ref={billSlipRef}>
//                   <div
//                     className="text-center text-white py-3"
//                     style={{
//                       background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
//                     }}
//                   >
//                     <div style={{ fontSize: "18px", fontWeight: "bold" }}>
//                       Zila Parishad - {selectedBillData.District}
//                     </div>

//                     {/* <div style={{ fontSize: "15px", fontWeight: "bold" }}>
//                       प्रशासकीय मंजुरी वर्ष - 2026-2027
//                     </div>

//                     <div>
//                       विभाग - EXE.ENGINEER ZP Division{" "}
//                       {selectedBillData.Division}
//                     </div>

//                     <div>उप-विभाग - {selectedBillData.District}</div>

//                     <div class="small">
//                       या तपशीलवार शीर्षाचे देयकासाठी आवश्यक असेल तिथे वित्त
//                       विभागाचा अनौपचारिक संदर्भ तपासावा.
//                     </div> */}
//                   </div>
//                   <div className="border border-dark p-1">
//                     <table
//                       className="table mb-0"
//                       style={{ fontSize: "14px", border: "none" }}
//                     >
//                       <tbody>
//                         {/* <tr>
//                           <td className='text-start'>
//                             <span>UserName :</span>

//                           </td>
//                           <td className='text-end'>
//                             <span>DateTime : </span>
//                           </td>
//                         </tr> */}
//                         <tr>
//                           <td
//                             colSpan={2}
//                             className="fw-bold text-center fs-6 p-1"
//                           >
//                             {" "}
//                             Bill Slip for RDD
//                           </td>
//                         </tr>
//                         {[
//                           [
//                             "User Name",
//                             `${selectedBillData.UploadedBy ?? "-"}`,
//                           ],
//                           [
//                             "Demand ID",
//                             `${selectedBillData.DemandGenerationID ?? "-"}`,
//                           ],
//                           [
//                             "Bill Creation Date",
//                             formatDateTime(selectedBillData.UploadedOn),
//                           ],
//                           ["Head Code", `${selectedBillData.BudgetID ?? "-"}`],
//                           ["Work Name", `${selectedBillData.ProjectID ?? "-"}`],
//                           [
//                             "Class of Work",
//                             `${selectedBillData.classOfWork || selectedBillData.workClass || "-"}`,
//                           ],
//                           [
//                             "Work Approved Year",
//                             `${selectedBillData.ProposalYear ?? "-"}`,
//                           ],
//                           [
//                             "Work order date",
//                             formatDate(selectedBillData.WorkOrderDate),
//                           ],
//                           [
//                             "Work Approved Amount",
//                             `${selectedBillData.ApprovedWorkAmount ?? "-"}`,
//                           ],
//                           [
//                             "Gross Bill Amount",
//                             `${selectedBillData.BillAmount ?? "-"}`,
//                           ],
//                           [
//                             "R.A.Bill No:",
//                             `${selectedBillData.RABillNumber ?? "-"}`,
//                           ],

//                           [
//                             "Invoice Bill No",
//                             `${selectedBillData.InvoiceNo ?? "-"}`,
//                           ],
//                         ].map(([label, value], index) => (
//                           <tr
//                             key={index}
//                             style={{ border: "1.5px solid #1190CA" }}
//                           >
//                             <td
//                               className="text-start"
//                               style={{
//                                 width: "30%",
//                                 backgroundColor: "#EAF3FB",
//                                 fontWeight: 500,
//                                 padding: "6px 10px",
//                                 borderRight: "1.5px solid #1190CA",
//                               }}
//                             >
//                               {label}
//                             </td>

//                             <td
//                               className="text-start"
//                               style={{
//                                 width: "70%",
//                                 padding: "6px 10px",
//                                 backgroundColor: "#FFFFFF",
//                               }}
//                             >
//                               {value}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     <table
//                       className="mt-1"
//                       style={{
//                         borderCollapse: "collapse",
//                         border: "1px solid #000",
//                       }}
//                     >
//                       <tbody>
//                         <tr className="border border-dark">
//                           <td
//                             className="text-start border border-dark "
//                             style={{ width: "30%" }}
//                           >
//                             Bill Amount
//                           </td>
//                           <td
//                             className="text-start border border-dark"
//                             style={{ width: "23%" }}
//                           >
//                             Deduction Amount
//                           </td>
//                           {/* <td
//                             className="text-start border border-dark"
//                             style={{ width: "23%" }}
//                           >
//                             Total Bill Amount
//                           </td> */}
//                           <td
//                             className="text-start border border-dark "
//                             style={{ width: "24%" }}
//                           >
//                             Net Payable
//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="text-start border border-dark">
//                             {selectedBillData.BillAmount}
//                           </td>
//                           <td className="text-start border border-dark">
//                             {selectedBillData.DeductionAmount}
//                           </td>
//                           {/* <td className="text-start border border-dark">
//                             {selectedBillData.BillAmount}
//                           </td> */}
//                           <td className="text-start border border-dark">
//                             {selectedBillData.NetPayableAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* Vendor Details */}
//                     <table
//                       className="mt-2"
//                       style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         fontSize: "14px",
//                       }}
//                     >
//                       <tbody>
//                         {/* Section Title */}
//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             backgroundColor: "#EAF3FB",
//                           }}
//                         >
//                           <td
//                             colSpan="6"
//                             style={{
//                               padding: "8px 10px",
//                               fontWeight: 600,
//                               textAlign: "center",
//                             }}
//                           >
//                             Vendor Details
//                           </td>
//                         </tr>

//                         {/* Column Headers */}
//                         <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Vendor Name
//                           </td>
//                           {/* <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }}>PAN Number</td> */}
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             IFSC Code
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Branch Name
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Bank Name
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Account Number
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Amount{" "}
//                           </td>
//                         </tr>

//                         {fetchSpecificDemandDeductionDetail &&
//                           fetchSpecificDemandDeductionDetail
//                             .filter(
//                               (val) =>
//                                 val.TypeOfAmount == "Total Amount Payable",
//                             )
//                             .map((val, index) => {
//                               return (
//                                 <>
//                                   <tr
//                                     style={{ border: "1.5px solid #1190CA" }}
//                                     key={index}
//                                   >
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Vendor_Company_Name}
//                                     </td>
//                                     {/* <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Vendor_Company_Name}</td> */}
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Bank_IFSC_Code}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Branch_Name}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.BANK_NAME}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Bank_Account_Number}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.NetPayableAmount}
//                                     </td>
//                                   </tr>
//                                 </>
//                               );
//                             })}

//                         {/* <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                           >
//                             Shivsai Construction
//                           </td>
//                           <td className='border border-dark'>AKIPS8199N</td>
//                           <td className='border border-dark'>MAHB0001302</td>
//                           <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
//                           <td className='border border-dark'>2,43,991.0</td>
//                           <td className='border border-dark'> 2,43,991.0</td>
//                         </tr> */}

//                         {/* Total */}
//                         <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               backgroundColor: "#EAF3FB",
//                               fontWeight: 500,
//                             }}
//                             colSpan={5}
//                           >
//                             Total
//                           </td>
//                           <td className="border border-dark">
//                             {selectedBillData.NetPayableAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <table
//                       className="my-2"
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             backgroundColor: "#EAF3FB",
//                           }}
//                         >
//                           <td
//                             colSpan="6"
//                             style={{
//                               padding: "8px 10px",
//                               fontWeight: 600,
//                               textAlign: "center",
//                             }}
//                           >
//                             Deduction Amount Details
//                           </td>
//                         </tr>
//                         <tr
//                           style={{
//                             color: "white",
//                             border: "none",
//                             height: "3rem",
//                           }}
//                         >
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Sr No
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Deduction Type
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Deduction Amount{" "}
//                           </th>
//                           {/* <th style={{ minWidth: "60px", padding: "8px" }}>
//                           Vendor Name
//                         </th> */}
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Account Number
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Bank Name
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             IFSC
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {fetchSpecificDemandDeductionDetail.filter(
//                           (val) => val.TypeOfAmount != "Total Amount Payable",
//                         )?.length == 0 ? (
//                           <tr>
//                             <td
//                               colSpan="30"
//                               style={{
//                                 textAlign: "center",
//                                 padding: "20px",
//                                 backgroundColor: "#f9f9f9",
//                               }}
//                             >
//                               No data available
//                             </td>
//                           </tr>
//                         ) : (
//                           fetchSpecificDemandDeductionDetail
//                             .filter(
//                               (val) =>
//                                 val.TypeOfAmount != "Total Amount Payable",
//                             )
//                             .map((technicalInwards, index) => {
//                               const bgColor =
//                                 index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                               return (
//                                 <tr
//                                   className="px-3"
//                                   key={index}
//                                   style={{
//                                     borderBottom: "1px solid #3b409e",
//                                     backgroundColor: bgColor,
//                                   }}
//                                 >
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {index + 1}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.TypeOfAmount}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.TotalAmount}
//                                   </td>
//                                   {/* <td
//                                   style={{ fontSize: "12px", padding: "5px" }}
//                                 >
//                                   {technicalInwards.Vendor_Company_Name}
//                                 </td> */}
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_Account_Number}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_Name}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_IFSC_Code}
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                         )}

//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             fontWeight: 600,
//                             background: "white",
//                           }}
//                         >
//                           <td
//                             colSpan="2"
//                             style={{ padding: "6px 8px", textAlign: "right" }}
//                           >
//                             Total
//                           </td>
//                           <td style={{ padding: "6px 8px" }}>
//                             {selectedBillData.DeductionAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* Signature grid */}
//                     <table style={footerTitleStyle}>
//                       <tbody>
//                         <tr>
//                           <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <table style={remarksTableStyle}>
//                       <tbody>
//                         <tr>
//                           <td style={remarksTableTdStyle}>
//                             प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत
//                             करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च
//                             करण्यात येणार आहे.
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <table style={remarksTableStyle}>
//                       <tbody>
//                         <tr>
//                           <td style={remarksTableTdStyle}>
//                             स्वाक्षरी आहरण व संवितरण अधिकारी
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <table style={instructionTableStyle}>
//                       <tbody>
//                         <tr>
//                           <td style={instructionTableTdStyle}>
//                             दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे
//                             प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या
//                             अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात
//                             नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी
//                             ग्रामविकास विभाग मुबई येथे सादर करण्यात आले नव्हते.
//                             प्रमाणित करण्यात येते की वरील मागणी ही महाराष्ट्र
//                             कोषागार नियम / मुंबई वित्तीय नियम / महाराष्ट्र
//                             आकस्मिक खर्च नियम व वेळोवेळी विहित केलेल्या
//                             आदेशांच्या आधारे तयार करण्यात आली आहे. श्री. किंवा
//                             श्रीमती ______________________________ यांना सदर
//                             देयकाची रक्कम/किंवा अपेक्षित देयक प्रदान करीता
//                             प्राधिकृत करण्यात आले असून त्यांची स्वाक्षरी
//                             खालीलप्रमाणे आहे.
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* <table style={signatureTableStyle}>
//                       <tbody>
//                         <tr>
//                           <td style={signatureTableTdStyle}>
//                             <div style={signBoxStyle}>
//                               <div style={signSpaceStyle}></div>
//                               <div style={signTitleStyle}>
//                                 संदेश वाहकाची स्वाक्षरी
//                               </div>
//                             </div>
//                           </td>

//                           <td style={signatureTableTdStyle}></td>

//                           <td style={signatureTableTdStyle}>
//                             <div style={signBoxStyle}>
//                               <div style={signSpaceStyle}></div>

//                               <div style={signTitleStyle}>सही</div>

//                               <div style={officerStyle}>
//                                 DY Secretary / Controller Officer
//                               </div>

//                               <div style={officerMarathiStyle}>
//                                 आहरण व संवितरण अधिकारी
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table> */}

//                     {/* Footer */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {showImageModal && (
//         <div
//           onClick={() => setShowImageModal(false)}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           {/* Previous Button */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();

//               const prevIndex =
//                 (selectedImageIndex - 1 + progressData.length) %
//                 progressData.length;

//               setSelectedImageIndex(prevIndex);
//             }}
//             style={{
//               position: "absolute",
//               left: "20px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               fontSize: "30px",
//               background: "rgba(0,0,0,0.5)",
//               color: "#fff",
//               border: "none",
//               borderRadius: "50%",
//               width: "50px",
//               height: "50px",
//               cursor: "pointer",
//               zIndex: 10001,
//             }}
//           >
//             ❮
//           </button>

//           {/* Close Button */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               setShowImageModal(false);
//             }}
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "30px",
//               fontSize: "30px",
//               color: "#fff",
//               background: "transparent",
//               border: "none",
//               cursor: "pointer",
//               zIndex: 10001,
//             }}
//           >
//             ×
//           </button>

//           {/* Current Image */}
//           <img
//             src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
//             alt="Preview"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxWidth: "85%",
//               maxHeight: "85%",
//               borderRadius: "8px",
//               objectFit: "contain",
//             }}
//           />

//           <button
//             onClick={() => setShowImageModal(false)}
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "30px",
//               fontSize: "30px",
//               color: "#fff",
//               background: "transparent",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             ×
//           </button>

//           {/* Image Counter */}
//           <div
//             style={{
//               position: "absolute",
//               bottom: "20px",
//               color: "#fff",
//               fontSize: "16px",
//               fontWeight: "bold",
//               background: "rgba(0,0,0,0.5)",
//               padding: "6px 12px",
//               borderRadius: "20px",
//             }}
//           >
//             {selectedImageIndex + 1} / {progressData.length}
//           </div>

//           {/* Next Button */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();

//               const nextIndex = (selectedImageIndex + 1) % progressData.length;

//               setSelectedImageIndex(nextIndex);
//             }}
//             style={{
//               position: "absolute",
//               right: "20px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               fontSize: "30px",
//               background: "rgba(0,0,0,0.5)",
//               color: "#fff",
//               border: "none",
//               borderRadius: "50%",
//               width: "50px",
//               height: "50px",
//               cursor: "pointer",
//               zIndex: 10001,
//             }}
//           >
//             ❯
//           </button>
//         </div>
//       )}

//       {/* {showImageModal && (
//         <div
//           onClick={() => setShowImageModal(false)}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <img
//             src={selectedImage}
//             alt="Preview"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxWidth: "90%",
//               maxHeight: "90%",
//               borderRadius: "8px",
//             }}
//           />

//           <button
//             onClick={() => setShowImageModal(false)}
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "30px",
//               fontSize: "30px",
//               color: "#fff",
//               background: "transparent",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             ×
//           </button>
//         </div>
//       )} */}
//     </>
//   );
// };

// export default DemandApproval;
